'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('styled-components');
var React = require('react');
var require$$1 = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var require$$1__default = /*#__PURE__*/_interopDefaultLegacy(require$$1);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

exports.Colors = void 0;
(function (Colors) {
    Colors["pink900"] = "#E74993";
    Colors["pink800"] = "#EE5FA8";
    Colors["pink600"] = "#F99CCC";
    Colors["pink400"] = "#FFCDE7";
    Colors["pink200"] = "#FFE9F4";
    Colors["pink100"] = "#FFF2F9";
    Colors["dark200"] = "#1F1E22";
    Colors["dark100"] = "#404047";
    Colors["gray800"] = "#625E68";
    Colors["gray500"] = "#8B89A6";
    Colors["gray400"] = "#ded8e7";
    Colors["gray200"] = "#F0EDF4";
    Colors["gray100"] = "#FAFAFA";
    Colors["light"] = "#FFFFFF";
    Colors["orange"] = "#ED975B";
    Colors["cyan"] = "#82F0C2";
    Colors["yellow"] = "#F9E160";
    Colors["paperNew"] = "#F7F4EE";
    Colors["darkBlue"] = "#17162D";
    Colors["darkBlue100"] = "#141429";
    Colors["darkBlue200"] = "#0A0A14";
    Colors["red"] = "#F1013B";
    Colors["transparent"] = "transparent";
    Colors["creme"] = "#FFF8D6";
    Colors["lightGreen"] = "#BEE686";
    Colors["darkGreen"] = "#004D43";
})(exports.Colors || (exports.Colors = {}));

exports.Icons = void 0;
(function (Icons) {
    Icons["close"] = "close";
    Icons["chevron_right"] = "chevron_right";
    Icons["chevron_left"] = "chevron_left";
    Icons["expand_more"] = "expand_more";
    Icons["expand_less"] = "expand_less";
    Icons["swap"] = "swap_horiz";
    Icons["description"] = "description";
    Icons["picture_as_pdf"] = "picture_as_pdf";
    Icons["school"] = "school";
    Icons["visibility_off"] = "visibility_off";
    Icons["visibility"] = "visibility";
    Icons["attach_money"] = "attach_money";
    Icons["heart_plus"] = "heart_plus";
    Icons["ecg_heart"] = "ecg_heart";
    Icons["savings"] = "savings";
    Icons["cached"] = "cached";
    Icons["overview"] = "overview";
    Icons["interests"] = "interests";
    Icons["rocket_launch"] = "rocket_launch";
    Icons["wallet"] = "wallet";
    Icons["water_drop"] = "water_drop";
    Icons["drag_handle"] = "drag_handle";
    Icons["percent"] = "percent";
    Icons["money"] = "money";
    Icons["payments"] = "payments";
    Icons["auto_graph"] = "auto_graph";
    Icons["send"] = "send";
    Icons["monetization_on"] = "monetization_on";
    Icons["help"] = "help";
    Icons["favorite"] = "favorite";
    Icons["folder_open"] = "folder_open";
    Icons["folder_zip"] = "folder_zip";
    Icons["person"] = "person";
    Icons["notifications"] = "notifications";
    Icons["settings"] = "settings";
    Icons["logout"] = "logout";
    Icons["search"] = "search";
    Icons["north_east"] = "north_east";
    Icons["language"] = "language";
    Icons["arrow_back"] = "arrow_back";
    Icons["system_update_alt"] = "system_update_alt";
    Icons["menu"] = "menu";
    Icons["sync"] = "sync";
    Icons["progress_activity"] = "progress_activity";
    Icons["mail"] = "mail";
    Icons["eco"] = "eco";
    Icons["undo"] = "undo";
    Icons["file_dolar"] = "request_page";
    Icons["supervisor_account"] = "supervisor_account";
    Icons["arrow_upward"] = "arrow_upward";
    Icons["arrow_downward"] = "arrow_downward";
    Icons["done"] = "done";
})(exports.Icons || (exports.Icons = {}));
var IconSocialIn = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-icon-social-in.svg';
var IconSocialInstagram = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-icon-social-instagram.svg';
var IconSocialSpotify = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-icon-social-spotify.svg';
var IconSocialYoutube = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-icon-social-youtube.svg';

// import { Icons } from "./../Icon/Icon.types";
exports.EButtonPreset = void 0;
(function (EButtonPreset) {
    EButtonPreset[EButtonPreset["solid"] = 0] = "solid";
    EButtonPreset[EButtonPreset["link"] = 1] = "link";
    EButtonPreset[EButtonPreset["outline"] = 2] = "outline";
})(exports.EButtonPreset || (exports.EButtonPreset = {}));
var isDarkLabel = function (color) {
    switch (color) {
        case exports.Colors.cyan:
        case exports.Colors.yellow:
        case exports.Colors.light:
            return true;
        default:
            return false;
    }
};
var getButtonLabelColor = function (preset, color) {
    if (preset === exports.EButtonPreset.solid && isDarkLabel(color)) {
        return exports.Colors.darkBlue;
    }
    switch (preset) {
        case exports.EButtonPreset.link:
        case exports.EButtonPreset.outline:
            return color;
        default:
            return exports.Colors.light;
    }
};

/**
 * Components
 */
var ButtonWrapper = styled__default["default"].div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  width: fit-content;\n  border-radius: 4px;\n  padding: 0 8px;\n  cursor: ", ";\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: ", ";\n  user-select: none;\n  position: relative;\n  transition: 0.2s ease-in-out;\n  border-style: solid;\n  border-width: 1pt;\n  border-color: ", ";\n  box-sizing: border-box;\n  @media (min-width: ", ") {\n    padding: 0 16px;\n  }\n  &:hover {\n    ", "\n  }\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n"], ["\n  background-color: ", ";\n  height: ", ";\n  width: fit-content;\n  border-radius: 4px;\n  padding: 0 8px;\n  cursor: ", ";\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: ", ";\n  user-select: none;\n  position: relative;\n  transition: 0.2s ease-in-out;\n  border-style: solid;\n  border-width: 1pt;\n  border-color: ", ";\n  box-sizing: border-box;\n  @media (min-width: ", ") {\n    padding: 0 16px;\n  }\n  &:hover {\n    ", "\n  }\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n"])), function (_a) {
    var preset = _a.preset, color = _a.color;
    return preset === exports.EButtonPreset.solid ? color : exports.Colors.transparent;
}, function (_a) {
    var compact = _a.compact;
    return (compact ? '40px' : '48px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.8 : 1);
}, function (_a) {
    var preset = _a.preset, color = _a.color;
    return preset === exports.EButtonPreset.outline ? color : 'transparent';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var preset = _a.preset, theme = _a.theme, color = _a.color;
    return preset === exports.EButtonPreset.solid
        ? "box-shadow: 0px 2px 8px ".concat(theme.colors.dark200, "45;")
        : "background-color: ".concat(color, "25;");
});
var ButtonLabel = styled__default["default"].div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  padding-bottom: 2px;\n  display: ", ";\n  @media (min-width: ", ") {\n    display: block;\n  }\n"], ["\n  padding-bottom: 2px;\n  display: ", ";\n  @media (min-width: ", ") {\n    display: block;\n  }\n"])), function (_a) {
    var responsive = _a.responsive;
    return (responsive ? 'none' : 'block');
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var ButtonAddon = styled__default["default"].div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  padding-top: 3px;\n"], ["\n  padding-top: 3px;\n"])));
var ButtonLoadingWrapper = styled__default["default"].div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var ButtonLoadingIcon = styled__default["default"].div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  padding-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 32px;\n  height: 32px;\n  padding-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var templateObject_1$J, templateObject_2$e, templateObject_3$b, templateObject_4$9, templateObject_5$8;

exports.BreakPoints = void 0;
(function (BreakPoints) {
    BreakPoints["xs"] = "320px";
    BreakPoints["sm"] = "480px";
    BreakPoints["md"] = "768px";
    BreakPoints["lg"] = "1024px";
    BreakPoints["xl"] = "1366px";
    BreakPoints["xxl"] = "1536px";
})(exports.BreakPoints || (exports.BreakPoints = {}));

exports.TextSizes = void 0;
(function (TextSizes) {
    TextSizes[TextSizes["heading"] = 88] = "heading";
    TextSizes[TextSizes["heading1"] = 64] = "heading1";
    TextSizes[TextSizes["heading2"] = 48] = "heading2";
    TextSizes[TextSizes["heading3"] = 40] = "heading3";
    TextSizes[TextSizes["heading4"] = 36] = "heading4";
    TextSizes[TextSizes["heading5"] = 24] = "heading5";
    TextSizes[TextSizes["bodyLg"] = 20] = "bodyLg";
    TextSizes[TextSizes["bodyMd"] = 16] = "bodyMd";
    TextSizes[TextSizes["body"] = 14] = "body";
    TextSizes[TextSizes["bodySm"] = 12] = "bodySm";
    TextSizes[TextSizes["caption"] = 10] = "caption";
})(exports.TextSizes || (exports.TextSizes = {}));
exports.TextLineHeight = void 0;
(function (TextLineHeight) {
    TextLineHeight[TextLineHeight["heading"] = 1.15] = "heading";
    TextLineHeight[TextLineHeight["heading1"] = 1.15] = "heading1";
    TextLineHeight[TextLineHeight["heading2"] = 1.25] = "heading2";
    TextLineHeight[TextLineHeight["heading3"] = 1.25] = "heading3";
    TextLineHeight[TextLineHeight["heading4"] = 1.35] = "heading4";
    TextLineHeight[TextLineHeight["heading5"] = 1.35] = "heading5";
    TextLineHeight[TextLineHeight["bodyLg"] = 1.5] = "bodyLg";
    TextLineHeight[TextLineHeight["bodyMd"] = 1.5] = "bodyMd";
    TextLineHeight[TextLineHeight["body"] = 1.5] = "body";
    TextLineHeight[TextLineHeight["bodySm"] = 1.2] = "bodySm";
    TextLineHeight[TextLineHeight["caption"] = 1.2] = "caption";
    TextLineHeight["auto"] = "auto";
})(exports.TextLineHeight || (exports.TextLineHeight = {}));

exports.EFontFamily = void 0;
(function (EFontFamily) {
    EFontFamily[EFontFamily["primary"] = 0] = "primary";
    EFontFamily[EFontFamily["secondary"] = 1] = "secondary";
})(exports.EFontFamily || (exports.EFontFamily = {}));
exports.EFontWeight = void 0;
(function (EFontWeight) {
    EFontWeight["light"] = "300";
    EFontWeight["regular"] = "400";
    EFontWeight["medium"] = "500";
    EFontWeight["bold"] = "600";
})(exports.EFontWeight || (exports.EFontWeight = {}));
var getFontSize = function (size, media) {
    if (media == null)
        return size;
    switch (media) {
        case exports.BreakPoints.xs:
        case exports.BreakPoints.sm:
            switch (size) {
                case exports.TextSizes.heading:
                case exports.TextSizes.heading1:
                case exports.TextSizes.heading2:
                case exports.TextSizes.heading3:
                    return exports.TextSizes.heading4;
                case exports.TextSizes.heading4:
                    return exports.TextSizes.bodyLg;
                case exports.TextSizes.bodyLg:
                case exports.TextSizes.bodyMd:
                    return exports.TextSizes.bodyMd;
                default:
                    return size;
            }
        case exports.BreakPoints.md:
            switch (size) {
                case exports.TextSizes.heading:
                case exports.TextSizes.heading1:
                case exports.TextSizes.heading2:
                    return exports.TextSizes.heading3;
                case exports.TextSizes.heading3:
                case exports.TextSizes.heading4:
                    return exports.TextSizes.heading5;
                default:
                    return size;
            }
        default:
            return size;
    }
};
var getLineHeight = function (size, media) {
    switch (media) {
        case exports.BreakPoints.sm:
        case exports.BreakPoints.xs:
            return exports.TextLineHeight.auto;
    }
    switch (size) {
        case exports.TextSizes.caption:
            return exports.TextLineHeight.caption;
        case exports.TextSizes.body:
            return exports.TextLineHeight.body;
        case exports.TextSizes.bodySm:
            return exports.TextLineHeight.bodySm;
        case exports.TextSizes.bodyMd:
            return exports.TextLineHeight.bodyMd;
        case exports.TextSizes.bodyLg:
            return exports.TextLineHeight.bodyLg;
        case exports.TextSizes.heading:
            return exports.TextLineHeight.heading;
        case exports.TextSizes.heading1:
            return exports.TextLineHeight.heading1;
        case exports.TextSizes.heading2:
            return exports.TextLineHeight.heading2;
        case exports.TextSizes.heading3:
            return exports.TextLineHeight.heading3;
        case exports.TextSizes.heading4:
            return exports.TextLineHeight.heading4;
        case exports.TextSizes.heading5:
            return exports.TextLineHeight.heading5;
        default:
            return exports.TextLineHeight.auto;
    }
};

/**
 * Components
 */
styled__default["default"].div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  line-height: 40px;\n"], ["\n  line-height: 40px;\n"])));
var TextLabel = styled__default["default"].span(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  line-height: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: 0.02rem;\n  ", ";\n  cursor: ", ";\n  box-sizing: border-box;\n  text-transform: ", ";\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"], ["\n  line-height: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: 0.02rem;\n  ", ";\n  cursor: ", ";\n  box-sizing: border-box;\n  text-transform: ", ";\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var preset = _a.preset;
    return getLineHeight(preset);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.darkBlue;
}, function (_a) {
    var weight = _a.weight;
    return weight || '400';
}, function (_a) {
    var preset = _a.preset, theme = _a.theme;
    return "".concat(getFontSize(preset || exports.TextSizes.body, theme.breakpoints.xs), "px");
}, function (_a) {
    var theme = _a.theme, family = _a.family;
    return family === exports.EFontFamily.primary
        ? theme.fontFamily
        : theme.secondaryfontFamily;
}, function (_a) {
    var underline = _a.underline, isLink = _a.isLink;
    return underline || isLink ? "text-decoration: underline 10%" : '';
}, function (_a) {
    var isLink = _a.isLink;
    return (isLink ? 'pointer' : 'inherit');
}, function (_a) {
    var uppercase = _a.uppercase;
    return (uppercase ? 'uppercase' : 'auto');
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var preset = _a.preset, theme = _a.theme;
    return "".concat(getFontSize(preset || exports.TextSizes.body, theme.breakpoints.sm), "px");
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var preset = _a.preset, theme = _a.theme;
    return "".concat(getFontSize(preset || exports.TextSizes.body, theme.breakpoints.md), "px");
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var preset = _a.preset;
    return "".concat(preset, "px");
});
var templateObject_1$I, templateObject_2$d;

// Component
var Text = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? exports.Colors.darkBlue : _b, _c = _a.preset, preset = _c === void 0 ? exports.TextSizes.body : _c, _d = _a.weight, weight = _d === void 0 ? exports.EFontWeight.regular : _d, _e = _a.family, family = _e === void 0 ? exports.EFontFamily.primary : _e, _f = _a.underline, underline = _f === void 0 ? false : _f, _g = _a.isLink, isLink = _g === void 0 ? false : _g, _h = _a.uppercase, uppercase = _h === void 0 ? false : _h, args = __rest(_a, ["children", "color", "preset", "weight", "family", "underline", "isLink", "uppercase"]);
    return (
    // <TextContainer {...{ preset, ...args }} ui-text-container>
    jsxRuntime.jsx(TextLabel, __assign({ "ui-text-label": true }, __assign({ color: color, preset: preset, weight: weight, family: family, underline: underline, isLink: isLink, uppercase: uppercase }, args), { children: children }))
    // </TextContainer>
    );
};

exports.EIconSize = void 0;
(function (EIconSize) {
    EIconSize["small"] = "small";
    EIconSize["normal"] = "normal";
    EIconSize["large"] = "large";
})(exports.EIconSize || (exports.EIconSize = {}));

/**
 * Components
 */
var IconSpan = styled__default["default"].span.attrs(function () { return ({
    className: 'material-icons-outlined',
}); })(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: 500;\n"], ["\n  color: ", ";\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: 500;\n"])), function (_a) {
    var color = _a.color;
    return color || exports.Colors.darkBlue;
}, function (_a) {
    var size = _a.size;
    return size === exports.EIconSize.small
        ? '16px'
        : size === exports.EIconSize.normal
            ? '24px'
            : '32px';
});
var templateObject_1$H;

var Icon = function (_a) {
    var icon = _a.icon, color = _a.color, _b = _a.size, size = _b === void 0 ? exports.EIconSize.normal : _b, onClick = _a.onClick, args = __rest(_a, ["icon", "color", "size", "onClick"]);
    return (jsxRuntime.jsx(IconSpan, __assign({ size: size, color: color, onClick: onClick }, args, { children: icon })));
};

var Loading = function (_a) {
    var color = _a.color;
    return (jsxRuntime.jsx("div", { children: jsxRuntime.jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, { children: [jsxRuntime.jsx("path", { d: 'M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z', opacity: '.25', fill: color }), jsxRuntime.jsx("path", __assign({ d: 'M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z', fill: color }, { children: jsxRuntime.jsx("animateTransform", { attributeName: 'transform', type: 'rotate', dur: '0.75s', values: '0 12 12;360 12 12', repeatCount: 'indefinite' }) }))] })) }));
};

var Button = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.color, color = _c === void 0 ? exports.Colors.darkBlue200 : _c, _d = _a.preset, preset = _d === void 0 ? exports.EButtonPreset.solid : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.rightAddon, rightAddon = _h === void 0 ? null : _h, _j = _a.leftAddon, leftAddon = _j === void 0 ? null : _j, _k = _a.underline, underline = _k === void 0 ? false : _k, _l = _a.responsive, responsive = _l === void 0 ? false : _l, _m = _a.compact, compact = _m === void 0 ? false : _m, _o = _a.actionName, actionName = _o === void 0 ? '' : _o, args = __rest(_a, ["label", "color", "preset", "onClick", "isLoading", "disabled", "rightAddon", "leftAddon", "underline", "responsive", "compact", "actionName"]);
    return (jsxRuntime.jsxs(ButtonWrapper, __assign({ role: 'button', color: color, disabled: disabled || isLoading, preset: preset, onClick: function () { return (disabled || isLoading ? function () { } : onClick()); }, compact: compact }, args, (actionName !== '' ? { 'data-vox-action': actionName } : {}), { children: [jsxRuntime.jsxs("div", __assign({ className: 'container', style: {
                    opacity: isLoading ? 0 : 1,
                    display: 'flex',
                    alignItems: 'center',
                } }, { children: [leftAddon && (jsxRuntime.jsx(ButtonAddon, { children: jsxRuntime.jsx(Icon, { icon: leftAddon, color: color }) })), label.length ? (jsxRuntime.jsx(ButtonLabel, __assign({ responsive: responsive }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, underline: underline, color: getButtonLabelColor(preset, color) }, { children: label })) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), rightAddon && (jsxRuntime.jsx(ButtonAddon, { children: jsxRuntime.jsx(Icon, { icon: rightAddon, color: getButtonLabelColor(preset, color) }) }))] })), isLoading ? (jsxRuntime.jsx(ButtonLoadingWrapper, { children: jsxRuntime.jsx(ButtonLoadingIcon, { children: jsxRuntime.jsx(Loading, { color: getButtonLabelColor(preset, color) }) }) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })));
};

// Component generated with util/vox-create-component.js
/**
 * Components
 */
var AvatarWrapper = styled__default["default"].div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-right: 15px;\n  padding-left: 10px;\n  width: ", ";\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-right: 15px;\n  padding-left: 10px;\n  width: ", ";\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, dark = _a.dark;
    return dark ? theme.colors.dark100 : "".concat(theme.colors.pink100);
}, function (_a) {
    var block = _a.block;
    return (block ? 'auto' : 'fit-content');
}, function (_a) {
    var theme = _a.theme, dark = _a.dark;
    return dark ? theme.colors.gray800 : "".concat(theme.colors.pink200);
});
var AvatarTextWrapper = styled__default["default"].div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject([""], [""])));
var AvatarTitle = styled__default["default"].div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject([""], [""])));
var AvatarSubTitle = styled__default["default"].div(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  margin-top: 2px;\n"], ["\n  margin-top: 2px;\n"])));
var AvatarImage = styled__default["default"].div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  min-height: 36px;\n  margin-right: 10px;\n  justify-content: center;\n  min-width: 36px;\n  background-color: ", ";\n"], ["\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  min-height: 36px;\n  margin-right: 10px;\n  justify-content: center;\n  min-width: 36px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme, dark = _a.dark;
    return dark ? theme.colors.gray800 : theme.colors.pink400;
});
var templateObject_1$G, templateObject_2$c, templateObject_3$a, templateObject_4$8, templateObject_5$7;

var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.title, title = _c === void 0 ? 'Olá, Avatar name' : _c, subTitle = _a.subTitle, image = _a.image, dark = _a.dark, args = __rest(_a, ["size", "title", "subTitle", "image", "dark"]);
    var titleColor = dark ? exports.Colors.light : exports.Colors.darkBlue;
    var subtitleColor = dark ? exports.Colors.cyan : exports.Colors.pink800;
    return (jsxRuntime.jsxs(AvatarWrapper, __assign({ dark: dark }, args, { children: [jsxRuntime.jsx(AvatarImage, __assign({}, { image: image, size: size, dark: dark }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, color: titleColor }, { children: title.substring(0, 1) })) })), jsxRuntime.jsxs(AvatarTextWrapper, { children: [jsxRuntime.jsx(AvatarTitle, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.bold, color: titleColor }, { children: title })) }), subTitle && (jsxRuntime.jsx(AvatarSubTitle, __assign({}, { size: size }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, weight: exports.EFontWeight.bold, color: subtitleColor }, { children: subTitle })) })))] })] })));
};

/**
 * Components
 */
var DocumentItemWrapper = styled__default["default"].div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  border-radius: 2px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  user-select: none;\n  border-width: 2px;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: 4px;\n  padding: 16px 16px;\n  box-sizing: border-box;\n  background-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"], ["\n  border-radius: 2px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  user-select: none;\n  border-width: 2px;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: 4px;\n  padding: 16px 16px;\n  box-sizing: border-box;\n  background-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
});
var DocumentLabelWrapper = styled__default["default"].div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n"], ["\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n"])));
var DocumentIconWrapper = styled__default["default"].div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var templateObject_1$F, templateObject_2$b, templateObject_3$9;

var DocumentItem = function (_a) {
    var label = _a.label, description = _a.description, _b = _a.icon, icon = _b === void 0 ? exports.Icons.description : _b, onClick = _a.onClick, args = __rest(_a, ["label", "description", "icon", "onClick"]);
    // States
    return (jsxRuntime.jsxs(DocumentItemWrapper, __assign({ onClick: function () { return (onClick ? onClick() : {}); } }, args, { children: [jsxRuntime.jsxs(DocumentLabelWrapper, { children: [label ? (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, weight: exports.EFontWeight.medium, color: exports.Colors.gray500 }, { children: label }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), description ? (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.medium, color: exports.Colors.darkBlue }, { children: description }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] }), jsxRuntime.jsx(DocumentIconWrapper, { children: jsxRuntime.jsx(Icon, { icon: icon, color: exports.Colors.darkBlue }) })] })));
};

/**
 * Components
 */
var MenuItemWrapper = styled__default["default"].div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px;\n  border-radius: 2px;\n  height: 52px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: ", "px;\n  padding-right: 30px;\n  &:hover {\n    cursor: pointer;\n    background-color: ", "45;\n  }\n"], ["\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px;\n  border-radius: 2px;\n  height: 52px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: ", "px;\n  padding-right: 30px;\n  &:hover {\n    cursor: pointer;\n    background-color: ", "45;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var icon = _a.icon;
    return (icon ? 20 : 30);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var templateObject_1$E;

var MenuItem$1 = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? 'Menu item' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d; _a.badge; var _f = _a.selected, selected = _f === void 0 ? false : _f, leftIcon = _a.leftIcon; _a.rightIcon; var onClick = _a.onClick, args = __rest(_a, ["name", "label", "disabled", "badge", "selected", "leftIcon", "rightIcon", "onClick"]);
    return (jsxRuntime.jsxs(MenuItemWrapper, __assign({ id: name, icon: leftIcon, itemID: name, onClick: function () { return (onClick && !disabled ? onClick() : {}); } }, __assign({ disabled: disabled }, args), { children: [leftIcon && jsxRuntime.jsx(Icon, { icon: leftIcon }), jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: selected ? exports.Colors.darkBlue : exports.Colors.gray800, weight: exports.EFontWeight.medium }, { children: label }))] })));
};

/**
 * Components
 */
var TabWrapper = styled__default["default"].div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  /* height: 52px; */\n  padding: 12px 24px;\n  background-color: ", ";\n  box-sizing: border-box;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: 4px;\n  border-style: solid;\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  /* height: 52px; */\n  padding: 12px 24px;\n  background-color: ", ";\n  box-sizing: border-box;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: 4px;\n  border-style: solid;\n  :hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? theme.colors.pink800 : 'transparente';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected ? theme.colors.pink900 : theme.colors.gray200;
});
var templateObject_1$D;

var Tab = function (_a) {
    var label = _a.label, selected = _a.selected, _b = _a.name, name = _b === void 0 ? '' : _b, onClick = _a.onClick, icon = _a.icon, args = __rest(_a, ["label", "selected", "name", "onClick", "icon"]);
    return (jsxRuntime.jsxs(TabWrapper, __assign({ onClick: onClick, id: name, itemID: name }, __assign({ selected: selected }, args), { children: [jsxRuntime.jsx(Text, __assign({ color: selected ? exports.Colors.light : exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: label })), icon ? (jsxRuntime.jsx(Icon, { icon: icon, color: selected ? exports.Colors.light : exports.Colors.darkBlue })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })));
};

var build = {exports: {}};

(()=>{var e={296:(e,t,r)=>{var o=/^\s+|\s+$/g,n=/^[-+]0x[0-9a-f]+$/i,i=/^0b[01]+$/i,c=/^0o[0-7]+$/i,u=parseInt,s="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,l="object"==typeof self&&self&&self.Object===Object&&self,a=s||l||Function("return this")(),f=Object.prototype.toString,p=Math.max,y=Math.min,d=function(){return a.Date.now()};function b(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function h(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==f.call(e)}(e))return NaN;if(b(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=b(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var r=i.test(e);return r||c.test(e)?u(e.slice(2),r?2:8):n.test(e)?NaN:+e}e.exports=function(e,t,r){var o,n,i,c,u,s,l=0,a=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function m(t){var r=o,i=n;return o=n=void 0,l=t,c=e.apply(i,r)}function O(e){var r=e-s;return void 0===s||r>=t||r<0||f&&e-l>=i}function w(){var e=d();if(O(e))return g(e);u=setTimeout(w,function(e){var r=t-(e-s);return f?y(r,i-(e-l)):r}(e));}function g(e){return u=void 0,v&&o?m(e):(o=n=void 0,c)}function P(){var e=d(),r=O(e);if(o=arguments,n=this,s=e,r){if(void 0===u)return function(e){return l=e,u=setTimeout(w,t),a?m(e):c}(s);if(f)return u=setTimeout(w,t),m(s)}return void 0===u&&(u=setTimeout(w,t)),c}return t=h(t)||0,b(r)&&(a=!!r.leading,i=(f="maxWait"in r)?p(h(r.maxWait)||0,t):i,v="trailing"in r?!!r.trailing:v),P.cancel=function(){void 0!==u&&clearTimeout(u),l=0,o=s=n=u=void 0;},P.flush=function(){return void 0===u?c:g(d())},P};},96:(e,t,r)=>{var o="Expected a function",n=NaN,i="[object Symbol]",c=/^\s+|\s+$/g,u=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,l=/^0o[0-7]+$/i,a=parseInt,f="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,p="object"==typeof self&&self&&self.Object===Object&&self,y=f||p||Function("return this")(),d=Object.prototype.toString,b=Math.max,h=Math.min,v=function(){return y.Date.now()};function m(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function O(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&d.call(e)==i}(e))return n;if(m(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=m(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(c,"");var r=s.test(e);return r||l.test(e)?a(e.slice(2),r?2:8):u.test(e)?n:+e}e.exports=function(e,t,r){var n=!0,i=!0;if("function"!=typeof e)throw new TypeError(o);return m(r)&&(n="leading"in r?!!r.leading:n,i="trailing"in r?!!r.trailing:i),function(e,t,r){var n,i,c,u,s,l,a=0,f=!1,p=!1,y=!0;if("function"!=typeof e)throw new TypeError(o);function d(t){var r=n,o=i;return n=i=void 0,a=t,u=e.apply(o,r)}function w(e){var r=e-l;return void 0===l||r>=t||r<0||p&&e-a>=c}function g(){var e=v();if(w(e))return P(e);s=setTimeout(g,function(e){var r=t-(e-l);return p?h(r,c-(e-a)):r}(e));}function P(e){return s=void 0,y&&n?d(e):(n=i=void 0,u)}function j(){var e=v(),r=w(e);if(n=arguments,i=this,l=e,r){if(void 0===s)return function(e){return a=e,s=setTimeout(g,t),f?d(e):u}(l);if(p)return s=setTimeout(g,t),d(l)}return void 0===s&&(s=setTimeout(g,t)),u}return t=O(t)||0,m(r)&&(f=!!r.leading,c=(p="maxWait"in r)?b(O(r.maxWait)||0,t):c,y="trailing"in r?!!r.trailing:y),j.cancel=function(){void 0!==s&&clearTimeout(s),a=0,n=l=i=s=void 0;},j.flush=function(){return void 0===s?u:P(v())},j}(e,t,{leading:n,maxWait:t,trailing:i})};},703:(e,t,r)=>{var o=r(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,t,r,n,i,c){if(c!==o){var u=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw u.name="Invariant Violation",u}}function t(){return e}e.isRequired=e;var r={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:n};return r.PropTypes=r,r};},697:(e,t,r)=>{e.exports=r(703)();},414:e=>{e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var i=t[o]={exports:{}};return e[o](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]});},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});};var o={};(()=>{r.r(o),r.d(o,{LazyLoadComponent:()=>A,LazyLoadImage:()=>ce,trackWindowScroll:()=>M});const e=React__default["default"];var t=r.n(e),n=r(697);const i=require$$1__default["default"];var c=r.n(i);function u(){return "undefined"!=typeof window&&"IntersectionObserver"in window&&"isIntersecting"in window.IntersectionObserverEntry.prototype}function s(e){return s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s(e)}function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,o);}return r}function a(e,t,r){return (t=p(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function f(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,p(o.key),o);}}function p(e){var t=function(e,t){if("object"!==s(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==s(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"===s(t)?t:String(t)}function y(e,t){return y=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},y(e,t)}function d(e){return d=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},d(e)}var b=function(e){e.forEach((function(e){e.isIntersecting&&e.target.onVisible();}));},h={},v=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&y(e,t);}(v,e);var r,o,n,i,p=(n=v,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=d(n);if(i){var r=d(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return function(e,t){if(t&&("object"===s(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}(this,e)});function v(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,v),(t=p.call(this,e)).supportsObserver=!e.scrollPosition&&e.useIntersectionObserver&&u(),t.supportsObserver){var r=e.threshold;t.observer=function(e){return h[e]=h[e]||new IntersectionObserver(b,{rootMargin:e+"px"}),h[e]}(r);}return t}return r=v,o=[{key:"componentDidMount",value:function(){this.placeholder&&this.observer&&(this.placeholder.onVisible=this.props.onVisible,this.observer.observe(this.placeholder)),this.supportsObserver||this.updateVisibility();}},{key:"componentWillUnmount",value:function(){this.observer&&this.placeholder&&this.observer.unobserve(this.placeholder);}},{key:"componentDidUpdate",value:function(){this.supportsObserver||this.updateVisibility();}},{key:"getPlaceholderBoundingBox",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.scrollPosition,t=this.placeholder.getBoundingClientRect(),r=c().findDOMNode(this.placeholder).style,o=parseInt(r.getPropertyValue("margin-left"),10)||0,n=parseInt(r.getPropertyValue("margin-top"),10)||0;return {bottom:e.y+t.bottom+n,left:e.x+t.left+o,right:e.x+t.right+o,top:e.y+t.top+n}}},{key:"isPlaceholderInViewport",value:function(){if("undefined"==typeof window||!this.placeholder)return !1;var e=this.props,t=e.scrollPosition,r=e.threshold,o=this.getPlaceholderBoundingBox(t),n=t.y+window.innerHeight,i=t.x,c=t.x+window.innerWidth,u=t.y;return Boolean(u-r<=o.bottom&&n+r>=o.top&&i-r<=o.right&&c+r>=o.left)}},{key:"updateVisibility",value:function(){this.isPlaceholderInViewport()&&this.props.onVisible();}},{key:"render",value:function(){var e=this,r=this.props,o=r.className,n=r.height,i=r.placeholder,c=r.style,u=r.width;if(i&&"function"!=typeof i.type)return t().cloneElement(i,{ref:function(t){return e.placeholder=t}});var s=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){a(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}({display:"inline-block"},c);return void 0!==u&&(s.width=u),void 0!==n&&(s.height=n),t().createElement("span",{className:o,ref:function(t){return e.placeholder=t},style:s},i)}}],o&&f(r.prototype,o),Object.defineProperty(r,"prototype",{writable:!1}),v}(t().Component);v.propTypes={onVisible:n.PropTypes.func.isRequired,className:n.PropTypes.string,height:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string]),placeholder:n.PropTypes.element,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,scrollPosition:n.PropTypes.shape({x:n.PropTypes.number.isRequired,y:n.PropTypes.number.isRequired}),width:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string])},v.defaultProps={className:"",placeholder:null,threshold:100,useIntersectionObserver:!0};const m=v;var O=r(296),w=r.n(O),g=r(96),P=r.n(g),j=function(e){var t=getComputedStyle(e,null);return t.getPropertyValue("overflow")+t.getPropertyValue("overflow-y")+t.getPropertyValue("overflow-x")};const T=function(e){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t instanceof HTMLElement;){if(/(scroll|auto)/.test(j(t)))return t;t=t.parentNode;}return window};function S(e){return S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},S(e)}var E=["delayMethod","delayTime"];function L(){return L=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);}return e},L.apply(this,arguments)}function _(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,(n=function(e,t){if("object"!==S(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==S(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(o.key),"symbol"===S(n)?n:String(n)),o);}var n;}function I(e,t){return I=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},I(e,t)}function x(e,t){if(t&&("object"===S(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return R(e)}function R(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function k(e){return k=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},k(e)}var D=function(){return "undefined"==typeof window?0:window.scrollX||window.pageXOffset},C=function(){return "undefined"==typeof window?0:window.scrollY||window.pageYOffset};const M=function(e){var r=function(r){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&I(e,t);}(a,r);var o,n,i,s,l=(i=a,s=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=k(i);if(s){var r=k(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return x(this,e)});function a(e){var r;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(r=l.call(this,e)).useIntersectionObserver=e.useIntersectionObserver&&u(),r.useIntersectionObserver)return x(r);var o=r.onChangeScroll.bind(R(r));return "debounce"===e.delayMethod?r.delayedScroll=w()(o,e.delayTime):"throttle"===e.delayMethod&&(r.delayedScroll=P()(o,e.delayTime)),r.state={scrollPosition:{x:D(),y:C()}},r.baseComponentRef=t().createRef(),r}return o=a,(n=[{key:"componentDidMount",value:function(){this.addListeners();}},{key:"componentWillUnmount",value:function(){this.removeListeners();}},{key:"componentDidUpdate",value:function(){"undefined"==typeof window||this.useIntersectionObserver||T(c().findDOMNode(this.baseComponentRef.current))!==this.scrollElement&&(this.removeListeners(),this.addListeners());}},{key:"addListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement=T(c().findDOMNode(this.baseComponentRef.current)),this.scrollElement.addEventListener("scroll",this.delayedScroll,{passive:!0}),window.addEventListener("resize",this.delayedScroll,{passive:!0}),this.scrollElement!==window&&window.addEventListener("scroll",this.delayedScroll,{passive:!0}));}},{key:"removeListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement.removeEventListener("scroll",this.delayedScroll),window.removeEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.removeEventListener("scroll",this.delayedScroll));}},{key:"onChangeScroll",value:function(){this.useIntersectionObserver||this.setState({scrollPosition:{x:D(),y:C()}});}},{key:"render",value:function(){var r=this.props,o=(r.delayMethod,r.delayTime,function(e,t){if(null==e)return {};var r,o,n=function(e,t){if(null==e)return {};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r]);}return n}(r,E)),n=this.useIntersectionObserver?null:this.state.scrollPosition;return t().createElement(e,L({forwardRef:this.baseComponentRef,scrollPosition:n},o))}}])&&_(o.prototype,n),Object.defineProperty(o,"prototype",{writable:!1}),a}(t().Component);return r.propTypes={delayMethod:n.PropTypes.oneOf(["debounce","throttle"]),delayTime:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool},r.defaultProps={delayMethod:"throttle",delayTime:300,useIntersectionObserver:!0},r};function N(e){return N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},N(e)}function B(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,(n=function(e,t){if("object"!==N(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==N(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(o.key),"symbol"===N(n)?n:String(n)),o);}var n;}function V(e,t){return V=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},V(e,t)}function W(e){return W=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},W(e)}var z=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&V(e,t);}(u,e);var r,o,n,i,c=(n=u,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=W(n);if(i){var r=W(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return function(e,t){if(t&&("object"===N(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}(this,e)});function u(e){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),c.call(this,e)}return r=u,(o=[{key:"render",value:function(){return t().createElement(m,this.props)}}])&&B(r.prototype,o),Object.defineProperty(r,"prototype",{writable:!1}),u}(t().Component);const $=M(z);function U(e){return U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},U(e)}function q(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,(n=function(e,t){if("object"!==U(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==U(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(o.key),"symbol"===U(n)?n:String(n)),o);}var n;}function F(e,t){return F=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},F(e,t)}function H(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Y(e){return Y=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Y(e)}var X=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&F(e,t);}(s,e);var r,o,n,i,c=(n=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=Y(n);if(i){var r=Y(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return function(e,t){if(t&&("object"===U(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return H(e)}(this,e)});function s(e){var t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),t=c.call(this,e);var r=e.afterLoad,o=e.beforeLoad,n=e.scrollPosition,i=e.visibleByDefault;return t.state={visible:i},i&&(o(),r()),t.onVisible=t.onVisible.bind(H(t)),t.isScrollTracked=Boolean(n&&Number.isFinite(n.x)&&n.x>=0&&Number.isFinite(n.y)&&n.y>=0),t}return r=s,(o=[{key:"componentDidUpdate",value:function(e,t){t.visible!==this.state.visible&&this.props.afterLoad();}},{key:"onVisible",value:function(){this.props.beforeLoad(),this.setState({visible:!0});}},{key:"render",value:function(){if(this.state.visible)return this.props.children;var e=this.props,r=e.className,o=e.delayMethod,n=e.delayTime,i=e.height,c=e.placeholder,s=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.width;return this.isScrollTracked||f&&u()?t().createElement(m,{className:r,height:i,onVisible:this.onVisible,placeholder:c,scrollPosition:s,style:l,threshold:a,useIntersectionObserver:f,width:p}):t().createElement($,{className:r,delayMethod:o,delayTime:n,height:i,onVisible:this.onVisible,placeholder:c,style:l,threshold:a,width:p})}}])&&q(r.prototype,o),Object.defineProperty(r,"prototype",{writable:!1}),s}(t().Component);X.propTypes={afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool},X.defaultProps={afterLoad:function(){return {}},beforeLoad:function(){return {}},useIntersectionObserver:!0,visibleByDefault:!1};const A=X;function G(e){return G="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},G(e)}var J=["afterLoad","beforeLoad","delayMethod","delayTime","effect","placeholder","placeholderSrc","scrollPosition","threshold","useIntersectionObserver","visibleByDefault","wrapperClassName","wrapperProps"];function K(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,o);}return r}function Q(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?K(Object(r),!0).forEach((function(t){Z(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):K(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function Z(e,t,r){return (t=re(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ee(){return ee=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);}return e},ee.apply(this,arguments)}function te(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,re(o.key),o);}}function re(e){var t=function(e,t){if("object"!==G(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==G(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"===G(t)?t:String(t)}function oe(e,t){return oe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},oe(e,t)}function ne(e){return ne=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},ne(e)}var ie=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&oe(e,t);}(u,e);var r,o,n,i,c=(n=u,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=ne(n);if(i){var r=ne(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return function(e,t){if(t&&("object"===G(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}(this,e)});function u(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),(t=c.call(this,e)).state={loaded:!1},t}return r=u,(o=[{key:"onImageLoad",value:function(){var e=this;return this.state.loaded?null:function(t){e.props.onLoad(t),e.props.afterLoad(),e.setState({loaded:!0});}}},{key:"getImg",value:function(){var e=this.props,r=(e.afterLoad,e.beforeLoad,e.delayMethod,e.delayTime,e.effect,e.placeholder,e.placeholderSrc,e.scrollPosition,e.threshold,e.useIntersectionObserver,e.visibleByDefault,e.wrapperClassName,e.wrapperProps,function(e,t){if(null==e)return {};var r,o,n=function(e,t){if(null==e)return {};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r]);}return n}(e,J));return t().createElement("img",ee({},r,{onLoad:this.onImageLoad()}))}},{key:"getLazyLoadImage",value:function(){var e=this.props,r=e.beforeLoad,o=e.className,n=e.delayMethod,i=e.delayTime,c=e.height,u=e.placeholder,s=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.visibleByDefault,y=e.width;return t().createElement(A,{beforeLoad:r,className:o,delayMethod:n,delayTime:i,height:c,placeholder:u,scrollPosition:s,style:l,threshold:a,useIntersectionObserver:f,visibleByDefault:p,width:y},this.getImg())}},{key:"getWrappedLazyLoadImage",value:function(e){var r=this.props,o=r.effect,n=r.height,i=r.placeholderSrc,c=r.width,u=r.wrapperClassName,s=r.wrapperProps,l=this.state.loaded,a=l?" lazy-load-image-loaded":"",f=l||!i?{}:{backgroundImage:"url(".concat(i,")"),backgroundSize:"100% 100%"};return t().createElement("span",ee({className:u+" lazy-load-image-background "+o+a,style:Q(Q({},f),{},{color:"transparent",display:"inline-block",height:n,width:c})},s),e)}},{key:"render",value:function(){var e=this.props,t=e.effect,r=e.placeholderSrc,o=e.visibleByDefault,n=e.wrapperClassName,i=e.wrapperProps,c=this.getLazyLoadImage();return (t||r)&&!o||n||i?this.getWrappedLazyLoadImage(c):c}}])&&te(r.prototype,o),Object.defineProperty(r,"prototype",{writable:!1}),u}(t().Component);ie.propTypes={onLoad:n.PropTypes.func,afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,delayMethod:n.PropTypes.string,delayTime:n.PropTypes.number,effect:n.PropTypes.string,placeholderSrc:n.PropTypes.string,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool,wrapperClassName:n.PropTypes.string,wrapperProps:n.PropTypes.object},ie.defaultProps={onLoad:function(){},afterLoad:function(){return {}},beforeLoad:function(){return {}},delayMethod:"throttle",delayTime:300,effect:"",placeholderSrc:null,threshold:100,useIntersectionObserver:!0,visibleByDefault:!1,wrapperClassName:""};const ce=ie;})(),build.exports=o;})();

var Image = function (_a) {
    var src = _a.src, alt = _a.alt, height = _a.height, width = _a.width, args = __rest(_a, ["src", "alt", "height", "width"]);
    return (jsxRuntime.jsx(build.exports.LazyLoadImage, __assign({}, {
        src: src,
        alt: alt,
        height: height,
        width: width,
    }, args)));
};

/**
 * Components
 */
var ListWrapper = styled__default["default"].div(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  > ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    > li {\n      display: -webkit-box;\n      display: -moz-box;\n      gap: 16px;\n      .dot {\n        display: block;\n        height: 8px;\n        width: 8px;\n        margin-top: 6px;\n        border-radius: 8px;\n        background-color: ", ";\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  > ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    > li {\n      display: -webkit-box;\n      display: -moz-box;\n      gap: 16px;\n      .dot {\n        display: block;\n        height: 8px;\n        width: 8px;\n        margin-top: 6px;\n        border-radius: 8px;\n        background-color: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
});
var templateObject_1$C;

exports.ECardDetailMode = void 0;
(function (ECardDetailMode) {
    ECardDetailMode["dark"] = "dark";
    ECardDetailMode["light"] = "light";
})(exports.ECardDetailMode || (exports.ECardDetailMode = {}));

var List = function (_a) {
    var title = _a.title, items = _a.items, _b = _a.mode, mode = _b === void 0 ? exports.ECardDetailMode.light : _b, args = __rest(_a, ["title", "items", "mode"]);
    var color = mode === exports.ECardDetailMode.dark ? exports.Colors.light : exports.Colors.darkBlue;
    return (jsxRuntime.jsxs(ListWrapper, __assign({}, args, { children: [title && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.bold, color: color }, { children: title }))), items.length && (jsxRuntime.jsx("ul", { children: items.map(function (item) { return (jsxRuntime.jsxs("li", { children: [jsxRuntime.jsx("span", { className: 'dot' }), jsxRuntime.jsx(Text, __assign({ color: color }, { children: item.label }))] })); }) }))] })));
};

/**
 * Components
 */
var DotsWrapper = styled__default["default"].div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(4, 0fr);\n  grid-template-rows: repeat(4, 0fr);\n  grid-gap: 24px;\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(5, 0fr);\n    grid-template-rows: repeat(5, 0fr);\n  }\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(6, 0fr);\n    grid-template-rows: repeat(6, 0fr);\n  }\n  > .dot {\n    height: 40px;\n    width: 40px;\n    background-color: ", ";\n    border-radius: 50%;\n  }\n  > .colored {\n    background-color: ", ";\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(4, 0fr);\n  grid-template-rows: repeat(4, 0fr);\n  grid-gap: 24px;\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(5, 0fr);\n    grid-template-rows: repeat(5, 0fr);\n  }\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(6, 0fr);\n    grid-template-rows: repeat(6, 0fr);\n  }\n  > .dot {\n    height: 40px;\n    width: 40px;\n    background-color: ", ";\n    border-radius: 50%;\n  }\n  > .colored {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
});
var templateObject_1$B;

var Dots = function (_a) {
    var count = _a.count, colored = _a.colored, args = __rest(_a, ["count", "colored"]);
    return (jsxRuntime.jsx(DotsWrapper, __assign({}, __assign({ count: count }, args), { children: __spreadArray([], Array(count), true).map(function (_, i) { return (jsxRuntime.jsx("div", { className: "dot ".concat(i < colored ? 'colored' : '') })); }) })));
};

/**
 * Components
 */
var LayoutContainerWrapper = styled__default["default"].div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 ", ";\n  @media (min-width: ", ") {\n    width: 85%;\n  }\n  @media (min-width: ", ") {\n    width: 1328px;\n  }\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 ", ";\n  @media (min-width: ", ") {\n    width: 85%;\n  }\n  @media (min-width: ", ") {\n    width: 1328px;\n  }\n"])), function (_a) {
    var padding = _a.padding;
    return (padding ? '24px' : '0px');
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xxl;
});
var templateObject_1$A;

var LayoutContainer = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '' : _b, _c = _a.padding, padding = _c === void 0 ? true : _c, children = _a.children, args = __rest(_a, ["id", "padding", "children"]);
    return (jsxRuntime.jsx(LayoutContainerWrapper, __assign({ id: id, padding: padding }, args, { children: children })));
};

/**
 * Components
 */
var TagWrapper = styled__default["default"].div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  width: fit-content;\n  padding: 6px 8px;\n  line-height: 0.5;\n  cursor: pointer;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  width: fit-content;\n  padding: 6px 8px;\n  line-height: 0.5;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
});
var templateObject_1$z;

var Tag = function (_a) {
    var label = _a.label, args = __rest(_a, ["label"]);
    return (jsxRuntime.jsx(TagWrapper, __assign({}, args, { children: jsxRuntime.jsx(Text, __assign({ color: exports.Colors.light, preset: exports.TextSizes.bodySm, weight: exports.EFontWeight.bold }, { children: label })) })));
};

/**
 * @public
 */
const MotionConfigContext = React.createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

const MotionContext = React.createContext({});

/**
 * @public
 */
const PresenceContext = React.createContext(null);

const isBrowser = typeof document !== "undefined";

const useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

const LazyContext = React.createContext({ strict: false });

function useVisualElement(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = React.useContext(MotionContext);
    const lazyContext = React.useContext(LazyContext);
    const presenceContext = React.useContext(PresenceContext);
    const reducedMotionConfig = React.useContext(MotionConfigContext).reducedMotion;
    const visualElementRef = React.useRef();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceContext,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    React.useInsertionEffect(() => {
        visualElement && visualElement.update(props, presenceContext);
    });
    useIsomorphicLayoutEffect(() => {
        visualElement && visualElement.render();
    });
    React.useEffect(() => {
        visualElement && visualElement.updateFeatures();
    });
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */
    const useAnimateChangesEffect = window.HandoffAppearAnimations
        ? useIsomorphicLayoutEffect
        : React.useEffect;
    useAnimateChangesEffect(() => {
        if (visualElement && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return React.useCallback((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
];
const variantProps = ["initial", ...variantPriorityOrder];

function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, React.useContext(MotionContext));
    return React.useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
};
const featureDefinitions = {};
for (const key in featureProps) {
    featureDefinitions[key] = {
        isEnabled: (props) => featureProps[key].some((name) => !!props[name]),
    };
}

function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}

const LayoutGroupContext = React.createContext({});

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = React.createContext({});

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */
        let MeasureLayout;
        const configAndProps = {
            ...React.useContext(MotionConfigContext),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        const context = useCreateMotionContext(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */
            const initialLayoutGroupConfig = React.useContext(SwitchLayoutGroupContext);
            const isStrict = React.useContext(LazyContext).strict;
            if (context.visualElement) {
                MeasureLayout = context.visualElement.loadFeatures(
                // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
            }
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (React__namespace.createElement(MotionContext.Provider, { value: context },
            MeasureLayout && context.visualElement ? (React__namespace.createElement(MeasureLayout, { visualElement: context.visualElement, ...configAndProps })) : null,
            useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)));
    }
    const ForwardRefComponent = React.forwardRef(MotionComponent);
    ForwardRefComponent[motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = React.useContext(LayoutGroupContext).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);

function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

const isMotionValue = (value) => Boolean(value && value.getVelocity);

const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
const numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */
    for (let i = 0; i < numTransforms; i++) {
        const key = transformPropOrder[i];
        if (transform[key] !== undefined) {
            const transformName = translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) {
        transformString += "translateZ(0)";
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}

const checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
const isCSSVariableName = checkStringStartsWith("--");
const isCSSVariableToken = checkStringStartsWith("var(--");
const cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

const number$3 = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number$3,
    transform: (v) => clamp(0, 1, v),
};
const scale = {
    ...number$3,
    default: 1,
};

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}

const createUnitType = (unit) => ({
    test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees$1 = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};

const int = {
    ...number$3,
    transform: Math.round,
};

const numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees$1,
    rotateX: degrees$1,
    rotateY: degrees$1,
    rotateZ: degrees$1,
    scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees$1,
    skewX: degrees$1,
    skewY: degrees$1,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariableName(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = numberValueTypes[key];
        const valueAsType = getValueAsType(value, valueType);
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0))
                transformIsNone = false;
        }
        else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return React.useMemo(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined &&
        (props.onTap || props.onTapStart || props.whileTap)) {
        htmlProps.tabIndex = 0;
    }
    htmlProps.style = style;
    return htmlProps;
}

/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return (key.startsWith("while") ||
        (key.startsWith("drag") && key !== "draggable") ||
        key.startsWith("layout") ||
        key.startsWith("onTap") ||
        key.startsWith("onPan") ||
        validMotionProps.has(key));
}

let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */
        if (key === "values" && typeof props.values === "object")
            continue;
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    const pathLength = px.transform(length);
    const pathSpacing = px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    if (attrScale !== undefined)
        attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = React.useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref,
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */
        const { children } = props;
        const renderedChildren = React.useMemo(() => (isMotionValue(children) ? children.get() : children), [children]);
        return React.createElement(Component, {
            ...elementProps,
            children: renderedChildren,
        });
    };
    return useRender;
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props, prevProps) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue(style[key]) ||
            (prevProps.style && isMotionValue(prevProps.style[key])) ||
            isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props, prevProps) {
    const newValues = scrapeMotionValuesFromProps$1(props, prevProps);
    for (const key in props) {
        if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
            const targetKey = transformPropOrder.indexOf(key) !== -1
                ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = React.useContext(MotionContext);
    const presenceContext = React.useContext(PresenceContext);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach((definition) => {
            const resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            const { transitionEnd, transition, ...target } = resolved;
            for (const key in target) {
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */
                    const index = isInitialAnimationBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (const key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement,
        Component,
    };
}

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}

const isPrimaryPointer = (event) => {
    if (event.pointerType === "mouse") {
        return typeof event.button !== "number" || event.button <= 0;
    }
    else {
        /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */
        return event.isPrimary !== false;
    }
};

function extractEventInfo(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"],
        },
    };
}
const addPointerInfo = (handler) => {
    return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}

function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const frameData = {
    delta: 0,
    timestamp: 0,
    isProcessing: false,
};

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frameData);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frameData.delta = useDefaultElapsed
        ? 1000 / 60
        : Math.max(Math.min(timestamp - frameData.timestamp, maxElapsed), 1);
    frameData.timestamp = timestamp;
    frameData.isProcessing = true;
    stepsOrder.forEach(processStep);
    frameData.isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        requestAnimationFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!frameData.isProcessing)
        requestAnimationFrame(processFrame);
};
const frame$1 = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
function cancelFrame(process) {
    stepsOrder.forEach((key) => steps[key].cancel(process));
}

function addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info) => {
        if (event.type === "touch" || isDragActive())
            return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) {
            node.animationState.setActive("whileHover", isActive);
        }
        if (props[callbackName]) {
            frame$1.update(() => props[callbackName](event, info));
        }
    };
    return addPointerEvent(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName],
    });
}
class HoverGesture extends Feature {
    mount() {
        this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
    unmount() { }
}

class FocusGesture extends Feature {
    constructor() {
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */
        try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        }
        catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
    }
    unmount() { }
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

const noop$1 = (any) => any;

function fireSyntheticPointerEvent(name, handler) {
    if (!handler)
        return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
class PressGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removeStartListeners = noop$1;
        this.removeEndListeners = noop$1;
        this.removeAccessibleListeners = noop$1;
        this.startPointerPress = (startEvent, startInfo) => {
            this.removeEndListeners();
            if (this.isPressing)
                return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo) => {
                if (!this.checkPressEnd())
                    return;
                const { onTap, onTapCancel } = this.node.getProps();
                frame$1.update(() => {
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */
                    !isNodeOrChild(this.node.current, endEvent.target)
                        ? onTapCancel && onTapCancel(endEvent, endInfo)
                        : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, { passive: !(props.onTap || props["onPointerUp"]) });
            const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props["onPointerCancel"]) });
            this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = () => {
            const handleKeydown = (keydownEvent) => {
                if (keydownEvent.key !== "Enter" || this.isPressing)
                    return;
                const handleKeyup = (keyupEvent) => {
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
                        return;
                    fireSyntheticPointerEvent("up", (event, info) => {
                        const { onTap } = this.node.getProps();
                        if (onTap) {
                            frame$1.update(() => onTap(event, info));
                        }
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
                fireSyntheticPointerEvent("down", (event, info) => {
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
            const handleBlur = () => {
                if (!this.isPressing)
                    return;
                fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart, whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", true);
        }
        if (onTapStart) {
            frame$1.update(() => onTapStart(event, info));
        }
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", false);
        }
        return !isDragActive();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd())
            return;
        const { onTapCancel } = this.node.getProps();
        if (onTapCancel) {
            frame$1.update(() => onTapCancel(event, info));
        }
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = addPointerEvent(this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props["onPointerStart"]) });
        const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

const thresholdNames = {
    some: 0,
    all: 1,
};
class InViewFeature extends Feature {
    constructor() {
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const onIntersectionUpdate = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (this.isInView === isIntersecting)
                return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && this.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                this.hasEnteredView = true;
            }
            if (this.node.animationState) {
                this.node.animationState.setActive("whileInView", isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined")
            return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) {
            this.startObserver();
        }
    }
    unmount() { }
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name) => viewport[name] !== prevViewport[name];
}

const gestureAnimations = {
    inView: {
        Feature: InViewFeature,
    },
    tap: {
        Feature: PressGesture,
    },
    focus: {
        Feature: FocusGesture,
    },
    hover: {
        Feature: HoverGesture,
    },
};

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key) => (current[key] = value.get()));
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity$1(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

let warning = noop$1;
let invariant = noop$1;
if (process.env.NODE_ENV !== "production") {
    warning = (check, message) => {
        if (!check && typeof console !== "undefined") {
            console.warn(message);
        }
    };
    invariant = (check, message) => {
        if (!check) {
            throw new Error(message);
        }
    };
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;
const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

const instantAnimationState = {
    current: false,
};

const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

function isWaapiSupportedEasing(easing) {
    return Boolean(!easing ||
        (typeof easing === "string" && supportedWaapiEasing[easing]) ||
        isBezierDefinition(easing) ||
        (Array.isArray(easing) && easing.every(isWaapiSupportedEasing)));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing) {
    if (!easing)
        return undefined;
    return isBezierDefinition(easing)
        ? cubicBezierAsString(easing)
        : Array.isArray(easing)
            ? easing.map(mapEasingToNativeEasing)
            : supportedWaapiEasing[easing];
}

function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
    const keyframeOptions = { [valueName]: keyframes };
    if (times)
        keyframeOptions.offset = times;
    const easing = mapEasingToNativeEasing(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */
    if (Array.isArray(easing))
        keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}

const featureTests = {
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
};
const results = {};
const supports = {};
/**
 * Generate features tests that cache their results.
 */
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}

function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1
        ? 0
        : keyframes.length - 1;
    return keyframes[index];
}

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop$1;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

const easeIn = cubicBezier(0.42, 0, 1, 1);
const easeOut = cubicBezier(0, 0, 0.58, 1);
const easeInOut = cubicBezier(0.42, 0, 0.58, 1);

const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);

const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn$1 = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn$1);

const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn$1(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

const easingLookup = {
    linear: noop$1,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn: backIn$1,
    backInOut,
    backOut,
    anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
    ...number$3,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba$1 = {
    test: isColorString("rgb", "red"),
    parse: splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        sanitize(alpha.transform(alpha$1)) +
        ")",
};

function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex$1 = {
    test: isColorString("#"),
    parse: parseHex,
    transform: rgba$1.transform,
};

const hsla$1 = {
    test: isColorString("hsl", "hue"),
    parse: splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            percent.transform(sanitize(saturation)) +
            ", " +
            percent.transform(sanitize(lightness)) +
            ", " +
            sanitize(alpha.transform(alpha$1)) +
            ")");
    },
};

const color$1 = {
    test: (v) => rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
    parse: (v) => {
        if (rgba$1.test(v)) {
            return rgba$1.parse(v);
        }
        else if (hsla$1.test(v)) {
            return hsla$1.parse(v);
        }
        else {
            return hex$1.parse(v);
        }
    },
    transform: (v) => {
        return isString(v)
            ? v
            : v.hasOwnProperty("red")
                ? rgba$1.transform(v)
                : hsla$1.transform(v);
    },
};

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mix = (from, to, progress) => -progress * from + progress * to + from;

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [hex$1, rgba$1, hsla$1];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    invariant(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === hsla$1) {
        // TODO Remove this cast - needed since Framer Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba$1.transform(blended);
    };
};

function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        isString(v) &&
        (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
const cssVarTokeniser = {
    regex: cssVariableRegex,
    countKey: "Vars",
    token: "${v}",
    parse: noop$1,
};
const colorTokeniser = {
    regex: colorRegex,
    countKey: "Colors",
    token: "${c}",
    parse: color$1.parse,
};
const numberTokeniser = {
    regex: floatRegex,
    countKey: "Numbers",
    token: "${n}",
    parse: number$3.parse,
};
function tokenise(info, { regex, countKey, token, parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches)
        return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0,
    };
    if (info.value.includes("var(--"))
        tokenise(info, cssVarTokeniser);
    tokenise(info, colorTokeniser);
    tokenise(info, numberTokeniser);
    return info;
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, numVars, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            if (i < numVars) {
                output = output.replace(cssVarTokeniser.token, v[i]);
            }
            else if (i < numVars + numColors) {
                output = output.replace(colorTokeniser.token, color$1.transform(v[i]));
            }
            else {
                output = output.replace(numberTokeniser.token, sanitize(v[i]));
            }
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parseComplexValue(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone: getAnimatableNone$1,
};

const mixImmediate = (origin, target) => (p) => `${p > 0 ? target : origin}`;
function getMixer(origin, target) {
    if (typeof origin === "number") {
        return (v) => mix(origin, target, v);
    }
    else if (color$1.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return origin.startsWith("var(")
            ? mixImmediate(origin, target)
            : mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = { ...origin, ...target };
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyseComplexValue(origin);
    const targetStats = analyseComplexValue(target);
    const canInterpolate = originStats.numVars === targetStats.numVars &&
        originStats.numColors === targetStats.numColors &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.values, targetStats.values), template);
    }
    else {
        warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return mixImmediate(origin, target);
    }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") {
        return mixNumber;
    }
    else if (typeof v === "string") {
        return color$1.test(v) ? mixColor : mixComplex;
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === "object") {
        return mixObject;
    }
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || noop$1 : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate$1(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */
    if (inputLength === 1)
        return () => output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = progress(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
        : interpolator;
}

function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress(0, remaining, i);
        offset.push(mix(min, 1, offsetProgress));
    }
}

function defaultOffset(arr) {
    const offset = [0];
    fillOffset(offset, arr.length - 1);
    return offset;
}

function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut", }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = {
        done: false,
        value: keyframeValues[0],
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length
        ? times
        : defaultOffset(keyframeValues), duration);
    const mapTimeToKeyframe = interpolate$1(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions)
            ? easingFunctions
            : defaultEasing(keyframeValues, easingFunctions),
    });
    return {
        calculatedDuration: duration,
        next: (t) => {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        },
    };
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration$1 = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = secondsToMilliseconds(duration);
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring({ keyframes, restDelta, restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    const initialVelocity = velocity ? -millisecondsToSeconds(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */
    const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return (target -
                envelope *
                    (((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) /
                        angularFreq) *
                        Math.sin(angularFreq * t) +
                        initialDelta * Math.cos(angularFreq * t)));
        };
    }
    else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t) => target -
            Math.exp(-undampedAngularFreq * t) *
                (initialDelta +
                    (initialVelocity + undampedAngularFreq * initialDelta) * t);
    }
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return (target -
                (envelope *
                    ((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) *
                        Math.sinh(freqForT) +
                        dampedAngularFreq *
                            initialDelta *
                            Math.cosh(freqForT))) /
                    dampedAngularFreq);
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */
                    if (dampingRatio < 1) {
                        currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
                    }
                    else {
                        currentVelocity = 0;
                    }
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
    };
}

function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed, }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin,
    };
    const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
    const nearestBoundary = (v) => {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t) => target + calcDelta(t);
    const applyFriction = (t) => {
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */
    let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t) => {
        if (!isOutOfBounds(state.value))
            return;
        timeReachedBoundary = t;
        spring$1 = spring({
            keyframes: [state.value, nearestBoundary(state.value)],
            velocity: calcGeneratorVelocity(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed,
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t) => {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */
            let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */
            if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
                return spring$1.next(t - timeReachedBoundary);
            }
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        },
    };
}

const frameloopDriver = (update) => {
    const passTimestamp = ({ timestamp }) => update(timestamp);
    return {
        start: () => frame$1.update(passTimestamp, true),
        stop: () => cancelFrame(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */
        now: () => frameData.isProcessing ? frameData.timestamp : performance.now(),
    };
};

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while (!state.done && duration < maxGeneratorDuration) {
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

const types = {
    decay: inertia,
    inertia,
    tween: keyframes,
    keyframes: keyframes,
    spring,
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */
function animateValue({ autoplay = true, delay = 0, driver = frameloopDriver, keyframes: keyframes$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Create a new finished Promise every time we enter the
     * finished state and resolve the old Promise. This is
     * WAAPI-compatible behaviour.
     */
    const updateFinishedPromise = () => {
        resolveFinishedPromise && resolveFinishedPromise();
        currentFinishedPromise = new Promise((resolve) => {
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = types[type] || keyframes;
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */
    let mapNumbersToKeyframes;
    if (generatorFactory !== keyframes &&
        typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = interpolate$1([0, 100], keyframes$1, {
            clamp: false,
        });
        keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({ ...options, keyframes: keyframes$1 });
    let mirroredGenerator;
    if (repeatType === "mirror") {
        mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [...keyframes$1].reverse(),
            velocity: -(options.velocity || 0),
        });
    }
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */
    if (generator.calculatedDuration === null && repeat) {
        generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const { calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp) => {
        if (startTime === null)
            return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */
        if (speed > 0)
            startTime = Math.min(startTime, timestamp);
        if (speed < 0)
            startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) {
            currentTime = holdTime;
        }
        else {
            // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
            // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
            // example.
            currentTime = Math.round(timestamp - startTime) * speed;
        }
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */
        if (playState === "finished" && holdTime === null) {
            currentTime = totalDuration;
        }
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */
            const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */
            let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */
            let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */
            if (!iterationProgress && progress >= 1) {
                iterationProgress = 1;
            }
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */
            const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) {
                        iterationProgress -= repeatDelay / resolvedDuration;
                    }
                }
                else if (repeatType === "mirror") {
                    frameGenerator = mirroredGenerator;
                }
            }
            let p = clamp(0, 1, iterationProgress);
            if (currentTime > totalDuration) {
                p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            }
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */
        const state = isInDelayPhase
            ? { done: false, value: keyframes$1[0] }
            : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) {
            state.value = mapNumbersToKeyframes(state.value);
        }
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) {
            done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        }
        const isAnimationFinished = holdTime === null &&
            (playState === "finished" || (playState === "running" && done));
        if (onUpdate) {
            onUpdate(state.value);
        }
        if (isAnimationFinished) {
            finish();
        }
        return state;
    };
    const stopAnimationDriver = () => {
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = () => {
        playState = "idle";
        stopAnimationDriver();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = () => {
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        updateFinishedPromise();
    };
    const play = () => {
        if (hasStopped)
            return;
        if (!animationDriver)
            animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) {
            startTime = now - holdTime;
        }
        else if (!startTime || playState === "finished") {
            startTime = now;
        }
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */
        playState = "running";
        animationDriver.start();
    };
    if (autoplay) {
        play();
    }
    const controls = {
        then(resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time() {
            return millisecondsToSeconds(currentTime);
        },
        set time(newTime) {
            newTime = secondsToMilliseconds(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) {
                holdTime = newTime;
            }
            else {
                startTime = animationDriver.now() - newTime / speed;
            }
        },
        get duration() {
            const duration = generator.calculatedDuration === null
                ? calcGeneratorDuration(generator)
                : generator.calculatedDuration;
            return millisecondsToSeconds(duration);
        },
        get speed() {
            return speed;
        },
        set speed(newSpeed) {
            if (newSpeed === speed || !animationDriver)
                return;
            speed = newSpeed;
            controls.time = millisecondsToSeconds(currentTime);
        },
        get state() {
            return playState;
        },
        play,
        pause: () => {
            playState = "paused";
            holdTime = currentTime;
        },
        stop: () => {
            hasStopped = true;
            if (playState === "idle")
                return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: () => {
            if (cancelTime !== null)
                tick(cancelTime);
            cancel();
        },
        complete: () => {
            playState = "finished";
        },
        sample: (elapsed) => {
            startTime = 0;
            return tick(elapsed);
        },
    };
    return controls;
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor",
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxDuration = 20000;
const requiresPregeneratedKeyframes = (valueName, options) => options.type === "spring" ||
    valueName === "backgroundColor" ||
    !isWaapiSupportedEasing(options.ease);
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    const canAccelerateAnimation = supports.waapi() &&
        acceleratedValues.has(valueName) &&
        !options.repeatDelay &&
        options.repeatType !== "mirror" &&
        options.damping !== 0 &&
        options.type !== "inertia";
    if (!canAccelerateAnimation)
        return false;
    /**
     * TODO: Unify with js/index
     */
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Create a new finished Promise every time we enter the
     * finished state and resolve the old Promise. This is
     * WAAPI-compatible behaviour.
     */
    const updateFinishedPromise = () => {
        currentFinishedPromise = new Promise((resolve) => {
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes, duration = 300, ease, times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = animateValue({
            ...options,
            repeat: 0,
            delay: 0,
        });
        let state = { done: false, value: keyframes[0] };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */
        let t = 0;
        while (!state.done && t < maxDuration) {
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = animateStyle(value.owner.current, valueName, keyframes, {
        ...options,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */
        ease: ease,
        times,
    });
    const cancelAnimation = () => animation.cancel();
    const safeCancel = () => {
        frame$1.update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */
    animation.onfinish = () => {
        value.set(getFinalKeyframe(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */
    return {
        then(resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time() {
            return millisecondsToSeconds(animation.currentTime || 0);
        },
        set time(newTime) {
            animation.currentTime = secondsToMilliseconds(newTime);
        },
        get speed() {
            return animation.playbackRate;
        },
        set speed(newSpeed) {
            animation.playbackRate = newSpeed;
        },
        get duration() {
            return millisecondsToSeconds(duration);
        },
        play: () => {
            if (hasStopped)
                return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */
            cancelFrame(cancelAnimation);
        },
        pause: () => animation.pause(),
        stop: () => {
            hasStopped = true;
            if (animation.playState === "idle")
                return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */
            const { currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = animateValue({
                    ...options,
                    autoplay: false,
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
            }
            safeCancel();
        },
        complete: () => animation.finish(),
        cancel: safeCancel,
    };
}

function createInstantAnimation({ keyframes, delay, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */
        return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (noop$1),
            pause: (noop$1),
            stop: (noop$1),
            then: (resolve) => {
                resolve();
                return Promise.resolve();
            },
            cancel: (noop$1),
            complete: (noop$1),
        };
    };
    return delay
        ? animateValue({
            keyframes: [0, 1],
            duration: 0,
            delay,
            onComplete: setValue,
        })
        : setValue();
}

const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
};
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
const ease = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else if (transformProps.has(valueKey)) {
        return valueKey.startsWith("scale")
            ? criticallyDampedSpring(keyframes[1])
            : underDampedSpring;
    }
    return ease;
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (key, value) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        (complex.test(value) || value === "0") && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...complex,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color: color$1,
    backgroundColor: color$1,
    outlineColor: color$1,
    fill: color$1,
    stroke: color$1,
    // Border props
    borderColor: color$1,
    borderTopColor: color$1,
    borderRightColor: color$1,
    borderBottomColor: color$1,
    borderLeftColor: color$1,
    filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone
        ? defaultValueType.getAnimatableNone(value)
        : undefined;
}

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);

function isNone(value) {
    if (typeof value === "number") {
        return value === 0;
    }
    else if (value !== null) {
        return value === "none" || value === "0" || isZeroValueString(value);
    }
}

function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = isAnimatable(valueName, target);
    let keyframes;
    if (Array.isArray(target)) {
        keyframes = [...target];
    }
    else {
        keyframes = [null, target];
    }
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < keyframes.length; i++) {
        /**
         * Fill null/wildcard keyframes
         */
        if (keyframes[i] === null) {
            keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        }
        if (isNone(keyframes[i])) {
            noneKeyframeIndexes.push(i);
        }
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" &&
            keyframes[i] !== "none" &&
            keyframes[i] !== "0") {
            animatableTemplateValue = keyframes[i];
        }
    }
    if (isTargetAnimatable &&
        noneKeyframeIndexes.length &&
        animatableTemplateValue) {
        for (let i = 0; i < noneKeyframeIndexes.length; i++) {
            const index = noneKeyframeIndexes[i];
            keyframes[index] = getAnimatableNone(valueName, animatableTemplateValue);
        }
    }
    return keyframes;
}

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}

const animateMotionValue = (valueName, value, target, transition = {}) => {
    return (onComplete) => {
        const valueTransition = getValueTransition(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */
        const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const keyframes = getKeyframes(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */
        const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
        const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
        warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v) => {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: () => {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */
        if (!isTransitionDefined(valueTransition)) {
            options = {
                ...options,
                ...getDefaultTransition(valueName, options),
            };
        }
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */
        if (options.duration) {
            options.duration = secondsToMilliseconds(options.duration);
        }
        if (options.repeatDelay) {
            options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
        }
        if (!isOriginAnimatable ||
            !isTargetAnimatable ||
            instantAnimationState.current ||
            valueTransition.type === false) {
            /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */
            return createInstantAnimation(instantAnimationState.current
                ? { ...options, delay: 0 }
                : options);
        }
        /**
         * Animate via WAAPI if possible.
         */
        if (value.owner &&
            value.owner.current instanceof HTMLElement &&
            !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
            if (acceleratedAnimation)
                return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */
        return animateValue(options);
    };
};

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);

function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        addUniqueItem(this.subscriptions, handler);
        return () => removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "10.12.18";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = frameData;
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                frame$1.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update velocity subscribers
            if (this.events.velocityChange) {
                this.events.velocityChange.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => frame$1.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) {
                    this.events.velocityChange.notify(this.getVelocity());
                }
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        if (process.env.NODE_ENV !== "production") {
            warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
        }
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") {
            return () => {
                unsubscribe();
                /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */
                frame$1.read(() => {
                    if (!this.events.change.getSize()) {
                        this.stop();
                    }
                });
            };
        }
        return unsubscribe;
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */
    jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect)
            this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(startAnimation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) {
            this.stopPassiveEffect();
        }
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number$3, px, percent, degrees$1, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color$1, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    const reversedLabels = [...variantLabels].reverse();
    reversedLabels.forEach((key) => {
        const variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        if (visualElement.variantChildren) {
            visualElement.variantChildren.forEach((child) => {
                setVariants(child, variantLabels);
            });
        }
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (let i = 0; i < numNewValues; i++) {
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value, { owner: visualElement }));
        if (origin[key] === undefined) {
            origin[key] = value;
        }
        if (value !== null)
            visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    const origin = {};
    for (const key in target) {
        const transitionOrigin = getOriginFromTransition(key, transition);
        if (transitionOrigin !== undefined) {
            origin[key] = transitionOrigin;
        }
        else {
            const value = visualElement.getValue(key);
            if (value) {
                origin[key] = value.get();
            }
        }
    }
    return origin;
}

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type &&
        visualElement.animationState &&
        visualElement.animationState.getState()[type];
    for (const key in target) {
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        const valueTransition = { delay, elapsed: 0, ...transition };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, frame$1);
            }
        }
        value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key)
            ? { type: false }
            : valueTransition));
        const animation = value.animation;
        if (isWillChangeMotionValue(willChange)) {
            willChange.add(key);
            animation.then(() => willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) {
        Promise.all(animations).then(() => {
            transitionEnd && setTarget(visualElement, transitionEnd);
        });
    }
    return animations;
}

function animateVariant(visualElement, variant, options = {}) {
    const resolved = resolveVariant(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => Promise.all(animateTarget(visualElement, resolved, options))
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(() => last());
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}

function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
    }
    return animation.then(() => visualElement.notify("AnimationComplete", definition));
}

const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (acc, definition) => {
        const resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type, ...options },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState(),
    };
}

class AnimationFeature extends Feature {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */
    constructor(node) {
        super(node);
        node.animationState || (node.animationState = createAnimationState(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        this.unmount();
        if (isAnimationControls(animate)) {
            this.unmount = animate.subscribe(this.node);
        }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */
    mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) {
            this.updateAnimationControlsSubscription();
        }
    }
    unmount() { }
}

let id$2 = 0;
class ExitAnimationFeature extends Feature {
    constructor() {
        super(...arguments);
        this.id = id$2++;
    }
    update() {
        if (!this.node.presenceContext)
            return;
        const { isPresent, onExitComplete, custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) {
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom });
        if (onExitComplete && !isPresent) {
            exitAnimation.then(() => onExitComplete(this.id));
        }
    }
    mount() {
        const { register } = this.node.presenceContext || {};
        if (register) {
            this.unmount = register(this.id);
        }
    }
    unmount() { }
}

const animations = {
    animation: {
        Feature: AnimationFeature,
    },
    exit: {
        Feature: ExitAnimationFeature,
    },
};

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = frameData;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            frame$1.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const { onEnd, onSessionEnd } = this.handlers;
            const panInfo = getPanInfo(event.type === "pointercancel"
                ? this.lastMoveEventInfo
                : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!isPrimaryPointer(event))
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = frameData;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        cancelFrame(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}

const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */
        const instance = node.instance;
        if (instance &&
            instance.style &&
            instance.style.display === "contents") {
            continue;
        }
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale))
        return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys$1 = ["x", "scaleX", "originX"];
const yKeys$1 = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false)
            return;
        const onSessionStart = (event) => {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (percent.test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = calcLength(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) {
                frame$1.update(() => onDragStart(event, info), false, true);
            }
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock && onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) {
            frame$1.update(() => onDragEnd(event, info));
        }
    }
    cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) {
            projection.isAnimationBlocked = false;
        }
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const { layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints && constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start(animateMotionValue(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints)) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

class DragGesture extends Feature {
    constructor(node) {
        super(node);
        this.removeGroupControls = noop$1;
        this.removeListeners = noop$1;
        this.controls = new VisualElementDragControls(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) {
            this.removeGroupControls = dragControls.subscribe(this.controls);
        }
        this.removeListeners = this.controls.addListeners() || noop$1;
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

const asyncHandler = (handler) => (event, info) => {
    if (handler) {
        frame$1.update(() => handler(event, info));
    }
};
class PanGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removePointerDownListener = noop$1;
    }
    onPointerDown(pointerDownEvent) {
        this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info) => {
                delete this.session;
                if (onPanEnd) {
                    frame$1.update(() => onPanEnd(event, info));
                }
            },
        };
    }
    mount() {
        this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = React.useContext(PresenceContext);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = React.useId();
    React.useEffect(() => register(id), []);
    const safeToRemove = () => onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};

const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        const shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = mix(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        return template(shadow);
    },
};

class MeasureLayoutWithContext extends React__default["default"].Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                frame$1.postRender(() => {
                    const stack = projection.getStack();
                    if (!stack || !stack.members.length) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(() => {
                if (!projection.currentAnimation && projection.isLead()) {
                    this.safeToRemove();
                }
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = React.useContext(LayoutGroupContext);
    return (React__default["default"].createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: React.useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, circOut);
const easeCrossfadeOut = compress(0.5, 0.95, noop$1);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}

class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            const { options, resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) {
                resumingFrom.options.onExitComplete &&
                    resumingFrom.options.onExitComplete();
            }
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}

function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}

const compareByDepth = (a, b) => a.depth - b.depth;

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelFrame(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frame$1.read(checkElapsed, true);
    return () => cancelFrame(checkElapsed);
}

function record(data) {
    if (window.MotionDebug) {
        window.MotionDebug.record(data);
    }
}

function isSVGElement(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
    motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

const transformAxes = ["", "X", "Y", "Z"];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id$1 = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */
const projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0,
};
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = id$1++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */
            this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */
            this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */
                projectionFrameData.totalNodes =
                    projectionFrameData.resolvedTargetDeltas =
                        projectionFrameData.recalculatedProjection =
                            0;
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                record(projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance)
                return;
            this.isSVG = isSVGElement(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = this.options.transition ||
                        visualElement.getDefaultTransition() ||
                        defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEquals(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (this.options.layoutRoot ||
                        (this.resumeFrom && this.resumeFrom.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion ||
                            this.options.layoutRoot) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged) {
                            finishAnimation(this);
                        }
                        if (this.isLead() && this.options.onExitComplete) {
                            this.options.onExitComplete();
                        }
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            cancelFrame(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return (this.isAnimationBlocked ||
                (this.parent && this.parent.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) {
                    node.willUpdate(false);
                }
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) {
                this.nodes.forEach(clearIsLayoutDirty);
            }
            this.isUpdating = false;
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */
            const now = performance.now();
            frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
            frameData.timestamp = now;
            frameData.isProcessing = true;
            steps.update.process(frameData);
            steps.preRender.process(frameData);
            steps.render.process(frameData);
            frameData.isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(() => this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            frame$1.preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            frame$1.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement &&
                visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot: checkIsScrollRoot(this.instance),
                    offset: measureScroll(this.instance),
                };
            }
        }
        resetTransform() {
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                translateAxis(box.x, scroll.offset.x);
                translateAxis(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.isRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */
                        if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent)
                return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */
            if (this.relativeParent.resolvedRelativeTargetAt !==
                frameData.timestamp) {
                this.relativeParent.resolveTargetDelta(true);
            }
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            const canSkip = !(forceRecalculation ||
                (isShared && this.isSharedProjectionDirty) ||
                this.isProjectionDirty ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) ||
                this.attemptToResolveRelativeTarget);
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            this.resolvedRelativeTargetAt = frameData.timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    relativeParent.layout &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                this.relativeParent &&
                this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * Increase debug counter for resolved target deltas
             */
            projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues)) {
                return undefined;
            }
            if (this.parent.isProjecting()) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        isProjecting() {
            return Boolean((this.relativeTarget ||
                this.targetDelta ||
                this.options.layoutRoot) &&
                this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */
            if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
                canSkip = false;
            }
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */
            if (isShared &&
                (this.isSharedProjectionDirty || this.isTransformDirty)) {
                canSkip = false;
            }
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */
            if (this.resolvedRelativeTargetAt === frameData.timestamp) {
                canSkip = false;
            }
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean((this.parent && this.parent.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */
            if (lead.layout &&
                !lead.target &&
                (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
            }
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */
                if (this.projectionTransform) {
                    this.projectionDelta = createDelta();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */
            projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot
                ? snapshot.latestValues
                : {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            if (!this.relativeParent ||
                !this.relativeParent.options.layoutRoot) {
                this.relativeTarget = this.relativeTargetOrigin = undefined;
            }
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest) => {
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    this.relativeParent &&
                    this.relativeParent.layout) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */
                    if (prevRelativeTarget &&
                        boxEquals(this.relativeTarget, prevRelativeTarget)) {
                        this.isProjectionDirty = false;
                    }
                    if (!prevRelativeTarget)
                        prevRelativeTarget = createBox();
                    copyBoxInto(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) {
                this.resumingFrom.currentAnimation.stop();
            }
            if (this.pendingAnimation) {
                cancelFrame(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = frame$1.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animateSingleValue(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: () => {
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity
                    ? config.shouldPreserveFollowOpacity(node)
                    : undefined,
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ) {
                hasRotate = true;
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate)
                return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */
                const corrected = styles.transform === "none"
                    ? valuesToRender[key]
                    : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
                /**
                 * Ensure relative target gets resized and rerendererd
                 */
                if (node.relativeTarget && !node.currentAnimation) {
                    node.isProjectionDirty = true;
                    node.relativeTarget[axis].max =
                        node.relativeTarget[axis].min + length;
                }
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */
    projectionFrameData.totalNodes++;
    if (!node.parent)
        return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */
    if (!node.isProjecting()) {
        node.isProjectionDirty = node.parent.isProjectionDirty;
    }
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */
    node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty ||
        node.parent.isProjectionDirty ||
        node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty =
        node.isSharedProjectionDirty =
            node.isTransformDirty =
                false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}

const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode = createProjectionNode({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode({});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});

const drag = {
    pan: {
        Feature: PanGesture,
    },
    drag: {
        Feature: DragGesture,
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token, fallback] = match;
    return [token, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariableToken(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element))
        return { target, transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = { ...transitionEnd };
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value) => {
        const current = value.get();
        if (!isCSSVariableToken(current))
            return;
        const resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (const key in target) {
        const current = target[key];
        if (!isCSSVariableToken(current))
            continue;
        const resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd)
            transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) {
            transitionEnd[key] = current;
        }
    }
    return { target, transitionEnd };
}

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY",
]);
const isPositionalKey = (key) => positionalKeys.has(key);
const hasPositionalKey = (target) => {
    return Object.keys(target).some(isPositionalKey);
};
const isNumOrPxType = (v) => v === number$3 || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    /**
     * Record origins before we render and update styles
     */
    changedKeys.forEach((key) => {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key) => {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
    target = { ...target };
    transitionEnd = { ...transitionEnd };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        let from = origin[key];
        let fromType = findDimensionValueType(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (let i = fromIndex; i < numKeyframes; i++) {
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */
                if (to[i] === null)
                    break;
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0
            ? window.pageYOffset
            : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(([key, value]) => {
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if (isBrowser && scrollY !== null) {
            window.scrollTo({ top: scrollY });
        }
        return { target: convertedTarget, transitionEnd };
    }
    else {
        return { target, transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target, transitionEnd };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
    const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!isBrowser)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}

function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            if (isWillChangeMotionValue(willChange)) {
                willChange.add(key);
            }
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (process.env.NODE_ENV === "development") {
                warnOnce(nextValue.version === "10.12.18", `Attempting to mix Framer Motion versions ${nextValue.version} with 10.12.18 may not work as expected.`);
            }
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, motionValue(nextValue, { owner: element }));
            if (isWillChangeMotionValue(willChange)) {
                willChange.remove(key);
            }
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, { owner: element }));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

const visualElementStore = new WeakMap();

const featureNames = Object.keys(featureDefinitions);
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
const numVariantProps = variantProps.length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    constructor({ parent, props, presenceContext, reducedMotionConfig, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */
        this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = () => frame$1.render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
                if (isWillChangeMotionValue(willChange)) {
                    willChange.add(key);
                }
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        visualElementStore.set(instance, this);
        if (this.projection && !this.projection.instance) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = this.parent.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (process.env.NODE_ENV !== "production") {
            warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
        }
        if (this.parent)
            this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        visualElementStore.delete(this.current);
        this.projection && this.projection.unmount();
        cancelFrame(this.notifyUpdate);
        cancelFrame(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        for (const key in this.features) {
            this.features[key].unmount();
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate &&
                frame$1.update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type) {
            return 0;
        }
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */
        if (process.env.NODE_ENV !== "production" &&
            preloadedFeatures &&
            isStrict) {
            const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
            renderedProps.ignoreStrict
                ? warning(false, strictMessage)
                : invariant(false, strictMessage);
        }
        for (let i = 0; i < numFeatures; i++) {
            const name = featureNames[i];
            const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent, } = featureDefinitions[name];
            if (ProjectionNode)
                ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) {
                    this.features[name] = new FeatureConstructor(this);
                }
                if (MeasureLayoutComponent) {
                    MeasureLayout = MeasureLayoutComponent;
                }
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot, } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) ||
                    (dragConstraints && isRefObject(dragConstraints)),
                visualElement: this,
                scheduleRender: () => this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */
                animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
                layoutRoot,
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for (const key in this.features) {
            const feature = this.features[key];
            if (feature.isMounted) {
                feature.update();
            }
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
    makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) {
            this.handleChildMotionValue();
        }
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode
            ? this
            : this.parent
                ? this.parent.getClosestVariantNode()
                : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) {
            return this.parent ? this.parent.getVariantContext() : undefined;
        }
        if (!this.isControllingVariants) {
            const context = this.parent
                ? this.parent.getVariantContext() || {}
                : {};
            if (this.props.initial !== undefined) {
                context.initial = this.props.initial;
            }
            return context;
        }
        const context = {};
        for (let i = 0; i < numVariantProps; i++) {
            const name = variantProps[i];
            const prop = this.props[name];
            if (isVariantLabel(prop) || prop === false) {
                context[name] = prop;
            }
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren &&
                closestVariantNode.variantChildren.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = motionValue(defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key) {
        return this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object"
            ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
            : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !isMotionValue(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].notify(...args);
        }
    }
}

class DOMVisualElement extends VisualElement {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(this, target, origin);
            const parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target,
        };
    }
}

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = getComputedStyle$1(instance);
            const value = (isCSSVariableName(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return scrapeMotionValuesFromProps$1(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if (isMotionValue(children)) {
            this.childSubscription = children.on("change", (latest) => {
                if (this.current)
                    this.current.textContent = `${latest}`;
            });
        }
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderHTML(instance, renderState, styleProp, projection);
    }
}

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return createBox();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return scrapeMotionValuesFromProps(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

const createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
        : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
};

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

const preloadedFeatures = {
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layout,
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
const motion = /*@__PURE__*/ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, preloadedFeatures, createDomVisualElement));

function stopAnimation(visualElement) {
    visualElement.values.forEach((value) => value.stop());
}
/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */
    const subscribers = new Set();
    const controls = {
        subscribe(visualElement) {
            subscribers.add(visualElement);
            return () => void subscribers.delete(visualElement);
        },
        start(definition, transitionOverride) {
            invariant(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement) => {
                animations.push(animateVisualElement(visualElement, definition, {
                    transitionOverride,
                }));
            });
            return Promise.all(animations);
        },
        set(definition) {
            invariant(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement) => {
                setValues(visualElement, definition);
            });
        },
        stop() {
            subscribers.forEach((visualElement) => {
                stopAnimation(visualElement);
            });
        },
        mount() {
            hasMounted = true;
            return () => {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}

/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    const controls = useConstant(animationControls);
    useIsomorphicLayoutEffect(controls.mount, []);
    return controls;
}
const useAnimation = useAnimationControls;

/**
 * Components
 */
styled__default["default"].div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  position: relative;\n  height: calc(100vh - 40px);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: relative;\n  height: calc(100vh - 40px);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var AlertContainer = styled__default["default"](motion.div)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: ", "cc;\n  z-index: 9999;\n"], ["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: ", "cc;\n  z-index: 9999;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
});
var AlertWrapper = styled__default["default"](motion.div)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  width: 420px;\n  border-radius: 2px;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: 15px 25px 30px 25px;\n  border-width: 1px;\n  gap: 5px;\n"], ["\n  width: 420px;\n  border-radius: 2px;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: 15px 25px 30px 25px;\n  border-width: 1px;\n  gap: 5px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
});
styled__default["default"].div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var AlertRightSide = styled__default["default"].div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n  padding-top: 8px;\n  br {\n    content: '';\n    margin: 5px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n  padding-top: 8px;\n  br {\n    content: '';\n    margin: 5px;\n  }\n"])));
var AlertHeader = styled__default["default"].div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  > div {\n    margin-right: -10px;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  > div {\n    margin-right: -10px;\n  }\n"])));
var AlertBody = styled__default["default"].div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n"], ["\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n"])));
var AlertFooter = styled__default["default"].div(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n"])));
var templateObject_1$y, templateObject_2$a, templateObject_3$8, templateObject_4$7, templateObject_5$6, templateObject_6$5, templateObject_7$4, templateObject_8$4;

// Component generated with util/vox-create-component.js
exports.EAlertType = void 0;
(function (EAlertType) {
    EAlertType["error"] = "error";
    EAlertType["success"] = "success";
})(exports.EAlertType || (exports.EAlertType = {}));

// Imgs
// export { default as ImgCoffe } from '../assets/imgs/vox-img-coffee.svg';
// export { default as ImgRolling } from '../assets/imgs/vox-img-rolling.svg';
// export { default as ImgMeditating } from '../assets/imgs/vox-img-meditating.svg';
// export { default as ImgChartLine } from '../assets/imgs/vox-img-chart-line.svg';
// export { default as ImgCoin } from '../assets/imgs/vox-img-coin.svg';
// export { default as ImgComposition } from '../assets/imgs/vox-img-composition.svg';
// export { default as ImgFileCheck } from '../assets/imgs/vox-img-file-check.svg';
// export { default as ImgFileComment } from '../assets/imgs/vox-img-file-comment.svg';
// export { default as ImgFileHeart } from '../assets/imgs/vox-img-file-heart.svg';
// export { default as ImgFileSearch } from '../assets/imgs/vox-img-file-search.svg';
// export { default as ImgFileWrite } from '../assets/imgs/vox-img-file-write.svg';
// export { default as ImgHand } from '../assets/imgs/vox-img-hand.svg';
// export { default as ImgHeartBeat } from '../assets/imgs/vox-img-heart-beat.svg';
// export { default as ImgLamp } from '../assets/imgs/vox-img-lamp.svg';
var ImgVoxLogoLarge = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-logo-large.svg';
var ImgVoxLogoPink = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-logo-pink.svg';
// Ods
var ImgOds001 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-1.svg';
var ImgOds002 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-2.svg';
var ImgOds003 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-3.svg';
var ImgOds004 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-4.svg';
var ImgOds005 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-5.svg';
var ImgOds006 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-6.svg';
var ImgOds007 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-7.svg';
var ImgOds008 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-8.svg';
var ImgOds009 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-9.svg';
var ImgOds010 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-10.svg';
var ImgOds011 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-11.svg';
var ImgOds012 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-12.svg';
var ImgOds013 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-13.svg';
var ImgOds014 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-14.svg';
var ImgOds015 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-15.svg';
var ImgOds016 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-16.svg';
var ImgOds017 = 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/theme/vox-ods-17.svg';

// Functions
var getImageODS = function (ods) {
    switch (ods) {
        case 1:
            return ImgOds001;
        case 2:
            return ImgOds002;
        case 3:
            return ImgOds003;
        case 4:
            return ImgOds004;
        case 5:
            return ImgOds005;
        case 6:
            return ImgOds006;
        case 7:
            return ImgOds007;
        case 8:
            return ImgOds008;
        case 9:
            return ImgOds009;
        case 10:
            return ImgOds010;
        case 11:
            return ImgOds011;
        case 12:
            return ImgOds012;
        case 13:
            return ImgOds013;
        case 14:
            return ImgOds014;
        case 15:
            return ImgOds015;
        case 16:
            return ImgOds016;
        default:
            return ImgOds017;
    }
};
var getLabelODS = function (ods) {
    switch (ods) {
        case 1:
            return 'Erradicação da pobreza';
        case 2:
            return 'Fome zero e agricultura sustentável';
        case 3:
            return 'Saúde e bem-estar';
        case 4:
            return 'Educação de qualidade';
        case 5:
            return 'Igualdade de gênero';
        case 6:
            return 'Água potável e saneamento';
        case 7:
            return 'Energia limpa e acessível';
        case 8:
            return 'Trabalho decente e crescimento económico';
        case 9:
            return 'Indústria, inovação e infraestrutura';
        case 10:
            return 'Redução das desigualdades';
        case 11:
            return 'Cidades e comunidades sustentáveis';
        case 12:
            return 'Consumo e produção responsáveis';
        case 13:
            return 'Parcerias e meios de implementação';
        case 14:
            return 'Paz, justiça e instituições eficazes';
        case 15:
            return 'Vida terrestre';
        case 16:
            return 'Vida na água';
        default:
            return 'Ação contra a mudança global do clima';
    }
};
var regexForOnlyOneNumber = function (value) {
    var r = /\b([0-9])\b/g;
    return r.test(value);
};
// Animations
var opacityAnimation = {
    hidden: {
        opacity: 0,
        transition: {
            ease: 'easeOut',
        },
    },
    visible: {
        opacity: 1,
        transition: {
            ease: 'easeIn',
        },
    },
};
var showFromRightAnimation = {
    hidden: {
        translateX: '100%',
        transition: {
            ease: 'easeOut',
        },
    },
    visible: {
        translateX: '0%',
        transition: {
            ease: 'easeIn',
        },
    },
};
var showFromBottomAnimation = {
    hidden: {
        translateY: '100%',
        opacity: 0,
        transition: {
            ease: 'easeOut',
        },
    },
    visible: {
        translateY: '0%',
        opacity: 1,
        transition: {
            ease: 'easeIn',
        },
    },
};

var Alert = function (_a) {
    var title = _a.title, message = _a.message, _b = _a.type; _b === void 0 ? exports.EAlertType.success : _b; var primaryAction = _a.primaryAction, primaryActionLabel = _a.primaryActionLabel, secondaryAction = _a.secondaryAction, secondaryActionLabel = _a.secondaryActionLabel; _a.image; var _d = _a.onCloseAlert, onCloseAlert = _d === void 0 ? function () { } : _d, args = __rest(_a, ["title", "message", "type", "primaryAction", "primaryActionLabel", "secondaryAction", "secondaryActionLabel", "image", "onCloseAlert"]);
    var shouldRenderFooter = primaryActionLabel || secondaryActionLabel;
    var controlOverlayAnimation = useAnimation();
    var controlAlertAnimation = useAnimation();
    var closeAlert = function () {
        controlOverlayAnimation.start('hidden');
        controlAlertAnimation.start('hidden');
        setTimeout(function () {
            onCloseAlert();
        }, 300);
    };
    React.useEffect(function () {
        controlOverlayAnimation.start('visible');
        controlAlertAnimation.start('visible');
    }, [controlOverlayAnimation, controlAlertAnimation]);
    return (jsxRuntime.jsx(AlertContainer, __assign({}, args, { initial: 'hidden', animate: controlOverlayAnimation, variants: opacityAnimation }, { children: jsxRuntime.jsxs(AlertWrapper, __assign({ initial: 'hidden', animate: controlAlertAnimation, transition: { duration: 0.2 }, variants: {
                hidden: {
                    opacity: 0,
                    translateY: 100,
                    transition: { ease: 'easeOut' },
                },
                visible: {
                    opacity: 1,
                    translateY: -10,
                    transition: { ease: 'easeIn' },
                },
            } }, { children: [jsxRuntime.jsx(AlertHeader, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.close, color: exports.Colors.darkBlue, onClick: closeAlert }) }), jsxRuntime.jsx(AlertBody, { children: jsxRuntime.jsxs(AlertRightSide, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, weight: exports.EFontWeight.medium }, { children: title })), jsxRuntime.jsx("br", {}), jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: message }))] }) }), shouldRenderFooter && (jsxRuntime.jsxs(AlertFooter, { children: [secondaryActionLabel && secondaryAction && (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.outline, label: secondaryActionLabel, onClick: secondaryAction, color: exports.Colors.darkBlue })), primaryActionLabel && primaryAction && (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.solid, label: primaryActionLabel, onClick: primaryAction, color: exports.Colors.darkBlue }))] }))] })) })));
};

/**
 * Frames
 */
var toColor = styled.keyframes(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  from {\n    filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n    transform: scale(1)\n  }\n  to {\n    filter: grayscale(0) contrast(1.5) brightness(1) saturate(1);\n    transform: scale(1.05)\n  }\n"], ["\n  from {\n    filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n    transform: scale(1)\n  }\n  to {\n    filter: grayscale(0) contrast(1.5) brightness(1) saturate(1);\n    transform: scale(1.05)\n  }\n"])));
var toGrey = styled.keyframes(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  from {\n   filter: grayscale(0) contrast(1.5) brightness(1) saturate(1);\n   transform: scale(1.05)\n  }\n  to {\n    filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n    transform: scale(1)\n  }\n"], ["\n  from {\n   filter: grayscale(0) contrast(1.5) brightness(1) saturate(1);\n   transform: scale(1.05)\n  }\n  to {\n    filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n    transform: scale(1)\n  }\n"])));
var rotateFrame = styled.keyframes(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n"], ["\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n"])));
/**
 * Components
 */
var CardData = styled__default["default"].div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  border-width: 2px;\n  border-color: ", ";\n  border-style: solid;\n  border-radius: 4px;\n  overflow: hidden;\n"], ["\n  border-width: 2px;\n  border-color: ", ";\n  border-style: solid;\n  border-radius: 4px;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var CardWrapper = styled__default["default"].div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  cursor: ", ";\n  flex: 1;\n  gap: 32px;\n\n  & > .loading {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ", "90;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    & > .spinner {\n      width: 24px;\n      height: 24px;\n      animation: ", " 1s linear infinite;\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  cursor: ", ";\n  flex: 1;\n  gap: 32px;\n\n  & > .loading {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ", "90;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    & > .spinner {\n      width: 24px;\n      height: 24px;\n      animation: ", " 1s linear infinite;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
}, function (_a) {
    var disable = _a.disable, loading = _a.loading;
    return disable || loading ? 'default' : 'pointer';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, rotateFrame);
var CardContent$1 = styled__default["default"].div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  padding: 32px 24px 48px 24px;\n  flex-direction: column;\n  z-index: 2;\n  gap: 32px;\n  min-height: 256px;\n  @media (min-width: ", ") {\n  }\n"], ["\n  flex: 1;\n  display: flex;\n  padding: 32px 24px 48px 24px;\n  flex-direction: column;\n  z-index: 2;\n  gap: 32px;\n  min-height: 256px;\n  @media (min-width: ", ") {\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var CardOverlay$1 = styled__default["default"].div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  position: absolute;\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  top: -75%;\n  right: -50%;\n  z-index: 1;\n"], ["\n  position: absolute;\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  top: -75%;\n  right: -50%;\n  z-index: 1;\n"])));
var CardImageBackground = styled__default["default"].div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(", ");\n  background-position: center;\n  background-size: cover;\n  z-index: 0;\n  filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n  animation: ", "\n    0.5s ease-in-out forwards;\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(", ");\n  background-position: center;\n  background-size: cover;\n  z-index: 0;\n  filter: grayscale(1) contrast(1.5) brightness(0.8) saturate(3);\n  animation: ", "\n    0.5s ease-in-out forwards;\n"])), function (_a) {
    var backgroundImage = _a.backgroundImage;
    return backgroundImage || '';
}, function (_a) {
    var hover = _a.hover, loading = _a.loading, disable = _a.disable;
    return hover && !loading && !disable ? toColor : toGrey;
});
var CardHeader = styled__default["default"].div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  min-height: 4em;\n"], ["\n  min-height: 4em;\n"])));
var CardHeaderTitle = styled__default["default"].div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var CardBody$1 = styled__default["default"].div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"])));
var CardBodyData = styled__default["default"].div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var CardFooter$1 = styled__default["default"].div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 56px;\n  padding: 0 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 56px;\n  padding: 0 16px;\n"])));
var templateObject_1$x, templateObject_2$9, templateObject_3$7, templateObject_4$6, templateObject_5$5, templateObject_6$4, templateObject_7$3, templateObject_8$3, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1;

// Component generated with util/vox-create-component.js
exports.ECardType = void 0;
(function (ECardType) {
    ECardType["large"] = "Large";
    ECardType["compact"] = "Compact";
})(exports.ECardType || (exports.ECardType = {}));

var uniqid$2 = require('uniqid');
var Card$1 = function (_a) {
    var title = _a.title, label = _a.label, _b = _a.type, type = _b === void 0 ? exports.ECardType.large : _b, data = _a.data, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, loading = _a.loading, _d = _a.disable, disable = _d === void 0 ? false : _d, backgroundImage = _a.backgroundImage, footer = _a.footer, args = __rest(_a, ["title", "label", "type", "data", "onClick", "loading", "disable", "backgroundImage", "footer"]);
    var _e = React.useState(false), hover = _e[0], setHover = _e[1];
    var handleMouseEnter = React.useCallback(function () {
        setHover(true);
    }, []);
    var handleMouseLeave = React.useCallback(function () {
        setHover(false);
    }, []);
    return (jsxRuntime.jsxs(CardData, { children: [jsxRuntime.jsxs(CardWrapper, __assign({ onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: function () {
                    if (!loading && !disable) {
                        onClick();
                    }
                }, className: 'vox-card', disable: disable }, args, { children: [loading && (jsxRuntime.jsx("span", __assign({ className: 'loading' }, { children: jsxRuntime.jsx("span", __assign({ className: 'spinner' }, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.cached, color: exports.Colors.light }) })) }))), jsxRuntime.jsxs(CardContent$1, { children: [label || title ? (jsxRuntime.jsx(CardHeader, { children: jsxRuntime.jsxs(CardHeaderTitle, { children: [label && (jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, color: exports.Colors.light }, { children: label }))), jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4, weight: exports.EFontWeight.medium, color: exports.Colors.light }, { children: title }))] }) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), jsxRuntime.jsx(CardBody$1, { children: data &&
                                    type === exports.ECardType.large &&
                                    data.map(function (_a) {
                                        var summary = _a.summary, detail = _a.detail;
                                        return (jsxRuntime.jsxs(CardBodyData, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4, weight: exports.EFontWeight.bold, color: exports.Colors.light }, { children: summary })), jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, preset: exports.TextSizes.bodyMd, color: exports.Colors.light }, { children: detail }))] }, uniqid$2()));
                                    }) })] }), jsxRuntime.jsx(CardOverlay$1, {}), jsxRuntime.jsx(CardImageBackground, __assign({}, { hover: hover, disable: disable, loading: loading, backgroundImage: backgroundImage }))] })), jsxRuntime.jsx(CardFooter$1, { children: footer })] }));
};

/**
 * Components
 */
var AnalysisWrapper = styled__default["default"].div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: fit-content;\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 20px 20px 20px;\n    position: relative;\n    width: 200px;\n    height: 200px;\n    cursor: pointer;\n    > .icon {\n      position: absolute;\n      left: 20px;\n      top: -20px;\n    }\n    > .body {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .footer {\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: fit-content;\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 20px 20px 20px;\n    position: relative;\n    width: 200px;\n    height: 200px;\n    cursor: pointer;\n    > .icon {\n      position: absolute;\n      left: 20px;\n      top: -20px;\n    }\n    > .body {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .footer {\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
});
var templateObject_1$w;

var Analysis = function (_a) {
    _a.icon; var title = _a.title, description = _a.description, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, linkText = _a.linkText, args = __rest(_a, ["icon", "title", "description", "onClick", "linkText"]);
    var imgControl = useAnimation();
    return (jsxRuntime.jsx(AnalysisWrapper, __assign({}, args, { onMouseEnter: function () { return imgControl.set('spin'); }, onMouseLeave: function () { return imgControl.set('init'); } }, { children: jsxRuntime.jsxs("div", __assign({ className: 'content', onClick: onClick }, { children: [jsxRuntime.jsx("div", { className: 'icon' }), jsxRuntime.jsxs("div", __assign({ className: 'body' }, { children: [title && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm, weight: exports.EFontWeight.bold, color: exports.Colors.pink800 }, { children: title }))), description && jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: description }))] })), jsxRuntime.jsx("div", __assign({ className: 'footer' }, { children: jsxRuntime.jsx(Text, __assign({ color: exports.Colors.pink800, weight: exports.EFontWeight.bold }, { children: linkText || 'Ver mais' })) }))] })) })));
};

/**
 * Components
 */
var CalendarWrapper = styled__default["default"](motion.div)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  width: 116px;\n  height: 116px;\n  background-color: ", ";\n  border-radius: ", "px;\n  overflow: hidden;\n  display: flex;\n  cursor: pointer;\n  .content {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 15px;\n    .check {\n    }\n    .label {\n      width: 100%;\n      text-align: right;\n      user-select: none;\n    }\n  }\n"], ["\n  width: 116px;\n  height: 116px;\n  background-color: ", ";\n  border-radius: ", "px;\n  overflow: hidden;\n  display: flex;\n  cursor: pointer;\n  .content {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 15px;\n    .check {\n    }\n    .label {\n      width: 100%;\n      text-align: right;\n      user-select: none;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
});
var templateObject_1$v;

/**
 * Components
 */
var CheckBoxWrapper = styled__default["default"].div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n"], ["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n"])));
var CheckBoxCheck = styled__default["default"].div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 2px;\n  border-width: 2px;\n  border-style: solid;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  border-color: ", ";\n  box-sizing: content-box;\n  background-color: ", ";\n  position: relative;\n"], ["\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 2px;\n  border-width: 2px;\n  border-style: solid;\n  display: flex;\n  justify-items: center;\n  align-items: center;\n  border-color: ", ";\n  box-sizing: content-box;\n  background-color: ", ";\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme, dark = _a.dark, disable = _a.disable, isChecked = _a.isChecked;
    return isChecked
        ? 'transparent'
        : disable
            ? theme.colors.gray800
            : dark
                ? theme.colors.cyan
                : theme.colors.dark200;
}, function (_a) {
    var theme = _a.theme, isChecked = _a.isChecked, dark = _a.dark, disable = _a.disable;
    return isChecked && disable
        ? theme.colors.gray800
        : isChecked && !dark
            ? theme.colors.pink800
            : isChecked && dark
                ? theme.colors.cyan
                : 'transparent';
});
var CheckBoxLabel = styled__default["default"].div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  margin-left: 15px;\n  margin-top: 2px;\n  flex: 1;\n  position: relative;\n"], ["\n  margin-left: 15px;\n  margin-top: 2px;\n  flex: 1;\n  position: relative;\n"])));
var CheckHelpWrapper = styled__default["default"].div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: -1rem;\n"], ["\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: -1rem;\n"])));
var templateObject_1$u, templateObject_2$8, templateObject_3$6, templateObject_4$5;

var Calendar = function (_a) {
    var onClick = _a.onClick, label = _a.label, value = _a.value, args = __rest(_a, ["onClick", "label", "value"]);
    var _b = React__default["default"].useState(false), check = _b[0], setCheck = _b[1];
    var toggleCheck = function () {
        setCheck(!check);
        onClick(value);
    };
    return (jsxRuntime.jsx(CalendarWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'content', onClick: toggleCheck }, { children: [jsxRuntime.jsx("div", __assign({ className: 'check' }, { children: jsxRuntime.jsx(CheckBoxCheck, { isChecked: check }) })), jsxRuntime.jsx("div", __assign({ className: 'label' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, color: exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: label })) }))] })) })));
};

/**
 * Components
 */
var CompanyWrapper = styled__default["default"].div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  .content {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    padding-top: 15px;\n    padding-bottom: 20px;\n    .header {\n    }\n    .body {\n      display: flex;\n      gap: 25px;\n      border-bottom-width: 1px;\n      .data {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        flex: 1;\n      }\n    }\n  }\n"], ["\n  .content {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    padding-top: 15px;\n    padding-bottom: 20px;\n    .header {\n    }\n    .body {\n      display: flex;\n      gap: 25px;\n      border-bottom-width: 1px;\n      .data {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        flex: 1;\n      }\n    }\n  }\n"])));
var templateObject_1$t;

var GetCompanyIcon = function (icon) {
    switch (icon) {
        case 'HEALTH':
            return exports.Icons.ecg_heart;
        case 'FINANCIAL':
            return exports.Icons.auto_graph;
        case 'WATER':
            return exports.Icons.water_drop;
        default:
            return exports.Icons.school;
    }
};

var Company = function (_a) {
    var name = _a.name, description = _a.description, icon = _a.icon, logo = _a.logo, args = __rest(_a, ["name", "description", "icon", "logo"]);
    return (jsxRuntime.jsx(CompanyWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'header' }, { children: jsxRuntime.jsx(Icon, { icon: GetCompanyIcon(icon) }) })), jsxRuntime.jsxs("div", __assign({ className: 'body' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4, weight: exports.EFontWeight.bold }, { children: name })), description && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg }, { children: description })))] })), logo && (jsxRuntime.jsx("div", __assign({ className: 'logo' }, { children: jsxRuntime.jsx("img", { src: logo, alt: "vox-impact-".concat(name), width: 80 }) })))] }))] })) })));
};

/**
 * Components
 */
var InfoWrapper = styled__default["default"].div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: fit-content;\n  .content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    position: relative;\n    cursor: pointer;\n    > .icon {\n      ", "\n    }\n    > .body {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      padding: 25px 35px 35px ", "px;\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: fit-content;\n  .content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    position: relative;\n    cursor: pointer;\n    > .icon {\n      ", "\n    }\n    > .body {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      padding: 25px 35px 35px ", "px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
}, function (_a) {
    var isLeft = _a.isLeft;
    return isLeft
        ? "\n        padding: 25px 0 25px 20px;\n      "
        : "\n      position: absolute;\n\t\t\t\tright: 20px;\n\t\t\t\ttop: -20px;\n      ";
}, function (_a) {
    var isLeft = _a.isLeft;
    return (isLeft ? 20 : 35);
});
var templateObject_1$s;

var Info = function (_a) {
    var title = _a.title, description = _a.description; _a.icon; var _c = _a.type, type = _c === void 0 ? 'LEFT' : _c, args = __rest(_a, ["title", "description", "icon", "type"]);
    var imgControl = useAnimation();
    var onHanldeMouseEnter = React.useCallback(function () { return imgControl.set('spin'); }, []);
    var onHanldeMouseLeave = React.useCallback(function () { return imgControl.set('init'); }, []);
    return (jsxRuntime.jsx(InfoWrapper, __assign({}, args, { isLeft: type === 'LEFT', onMouseEnter: onHanldeMouseEnter, onMouseLeave: onHanldeMouseLeave }, { children: jsxRuntime.jsx("div", __assign({ className: 'content' }, { children: jsxRuntime.jsxs("div", __assign({ className: 'body' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, color: exports.Colors.pink800, weight: exports.EFontWeight.medium }, { children: title })), jsxRuntime.jsx(Text, __assign({ color: exports.Colors.gray800, weight: exports.EFontWeight.regular }, { children: description }))] })) })) })));
};

/**
 * Components
 */
var InformationWrapper = styled__default["default"].div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    > .info {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .icon {\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    > .info {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .icon {\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
});
var templateObject_1$r;

var Information = function (_a) {
    var label = _a.label, description = _a.description, _b = _a.type, type = _b === void 0 ? 'DOCUMENT' : _b, args = __rest(_a, ["label", "description", "type"]);
    return (jsxRuntime.jsx(InformationWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'info' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg }, { children: label })), jsxRuntime.jsx(Text, __assign({ color: exports.Colors.gray800 }, { children: description }))] })), jsxRuntime.jsx("div", __assign({ className: 'icon' }, { children: jsxRuntime.jsx(Icon, { icon: type === 'DOCUMENT' ? exports.Icons.folder_open : exports.Icons.auto_graph }) }))] })) })));
};

/**
 * Components
 */
var MessageWrapper = styled__default["default"].div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject([""], [""])));
var templateObject_1$q;

var Message = function (props) {
    return jsxRuntime.jsx(MessageWrapper, __assign({}, props));
};

/**
 * Components
 */
var NotificationWrapper = styled__default["default"].div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    gap: 15px;\n    > .icon {\n    }\n    > .info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .check {\n      position: relative;\n      background-color: ", ";\n      height: 14px;\n      width: 14px;\n      border-width: 2px;\n      border-color: ", ";\n      border-style: solid;\n      border-radius: 100%;\n      &:after {\n        ", "\n        width: 4px;\n        height: 8px;\n        border-radius: 1px;\n        border-width: 2px;\n        border-right-style: solid;\n        border-bottom-style: solid;\n        border-color: ", ";\n        box-sizing: content-box;\n        position: absolute;\n        transform: rotate(45deg) translateX(-25%) translateY(25%);\n        left: 50%;\n      }\n    }\n  }\n"], ["\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    gap: 15px;\n    > .icon {\n    }\n    > .info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .check {\n      position: relative;\n      background-color: ", ";\n      height: 14px;\n      width: 14px;\n      border-width: 2px;\n      border-color: ", ";\n      border-style: solid;\n      border-radius: 100%;\n      &:after {\n        ", "\n        width: 4px;\n        height: 8px;\n        border-radius: 1px;\n        border-width: 2px;\n        border-right-style: solid;\n        border-bottom-style: solid;\n        border-color: ", ";\n        box-sizing: content-box;\n        position: absolute;\n        transform: rotate(45deg) translateX(-25%) translateY(25%);\n        left: 50%;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
}, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked ? theme.colors.dark200 : 'transparent';
}, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked ? theme.colors.dark200 : theme.colors.pink800;
}, function (_a) {
    var checked = _a.checked;
    return (checked ? 'content: "";' : '');
}, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked ? theme.colors.light : 'transparent';
});
var templateObject_1$p;

// Component generated with util/vox-create-component.js
exports.ENotificationType = void 0;
(function (ENotificationType) {
    ENotificationType["financial"] = "FINANCIAL";
    ENotificationType["profile"] = "PROFILE";
})(exports.ENotificationType || (exports.ENotificationType = {}));

var Notification = function (_a) {
    var label = _a.label, description = _a.description, onClick = _a.onClick, checked = _a.checked, _b = _a.type, type = _b === void 0 ? exports.ENotificationType.financial : _b, args = __rest(_a, ["label", "description", "onClick", "checked", "type"]);
    var _c = React__default["default"].useState(!!checked), check = _c[0], setCheck = _c[1];
    var toggle = function () {
        if (!check) {
            setCheck(true);
            onClick();
        }
    };
    return (jsxRuntime.jsx(NotificationWrapper, __assign({ checked: check }, args, { onClick: toggle }, { children: jsxRuntime.jsxs("div", __assign({ className: 'content', onClick: onClick }, { children: [jsxRuntime.jsx("div", __assign({ className: 'icon' }, { children: jsxRuntime.jsx(Icon, { icon: type === exports.ENotificationType.profile ? exports.Icons.person : exports.Icons.savings }) })), jsxRuntime.jsxs("div", __assign({ className: 'info' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: !description ? exports.TextSizes.bodyMd : exports.TextSizes.bodyLg }, { children: label })), jsxRuntime.jsx(Text, __assign({ color: exports.Colors.gray800 }, { children: description }))] })), jsxRuntime.jsx("div", { className: 'check' })] })) })));
};

/**
 * Components
 */
var ImpactHistoryWrapper = styled__default["default"](motion.div)(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  border-radius: 4px;\n  ", "\n  overflow: hidden;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  width: 100%;\n  min-height: 256px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 25px;\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n  .title,\n  .desc {\n    z-index: 2;\n  }\n  .loading {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"], ["\n  border-radius: 4px;\n  ", "\n  overflow: hidden;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  width: 100%;\n  min-height: 256px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 25px;\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n  .title,\n  .desc {\n    z-index: 2;\n  }\n  .loading {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])), function (_a) {
    var theme = _a.theme, image = _a.image;
    return !image
        ? "background-color: ".concat(theme.colors.darkBlue, ";")
        : "background-image: url(".concat(image, ");");
});
var CardOverlay = styled__default["default"].div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  position: absolute;\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  top: -75%;\n  right: -50%;\n  z-index: 1;\n"], ["\n  position: absolute;\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  top: -75%;\n  right: -50%;\n  z-index: 1;\n"])));
var templateObject_1$o, templateObject_2$7;

var ImpactHistory = function (_a) {
    var image = _a.image, title = _a.title, description = _a.description, loading = _a.loading, args = __rest(_a, ["image", "title", "description", "loading"]);
    return (jsxRuntime.jsxs(ImpactHistoryWrapper, __assign({ image: image }, args, { initial: 'hidden', whileHover: 'visible', transition: {
            type: 'spring',
            duration: 1,
            bounce: 0.25,
            damping: 25,
        }, variants: {
            hidden: {
                backgroundSize: '100%',
            },
            visible: {
                backgroundSize: '115%',
            },
        } }, { children: [loading ? (jsxRuntime.jsx(motion.div, __assign({ id: 'history-loading', className: 'loading' }, { children: jsxRuntime.jsx(motion.div, __assign({ animate: 'rotate', transition: {
                        repeat: Infinity,
                        duration: 1,
                        ease: 'linear',
                    }, variants: {
                        rotate: {
                            rotate: 360,
                            zIndex: 2,
                        },
                    } }, { children: jsxRuntime.jsx("div", __assign({ style: {
                            width: 24,
                            height: 24,
                        } }, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.sync, color: exports.Colors.light }) })) })) }))) : (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(motion.div, __assign({ className: 'title' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, weight: exports.EFontWeight.bold, color: exports.Colors.light }, { children: title })) })), jsxRuntime.jsx(motion.div, __assign({ className: 'desc' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.medium, color: exports.Colors.cyan }, { children: description })) }))] })), jsxRuntime.jsx(CardOverlay, {})] })));
};

/**
 * Components
 */
var GraphWrapper = styled__default["default"].div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  margin: 0 auto;\n  .header {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    padding: 0 100px;\n    .description {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      .values {\n        display: flex;\n        gap: 16px;\n        align-items: center;\n        .profitability {\n          background-color: ", ";\n          border-radius: 2px;\n          padding: 4px 4px;\n          span {\n            color: ", ";\n          }\n          &.positive {\n            background-color: ", ";\n            span {\n              color: ", ";\n            }\n          }\n        }\n      }\n    }\n    .tags {\n      background-color: ", ";\n      padding: 6px;\n      border-radius: 2px;\n      height: fit-content;\n      ul {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-direction: row;\n        gap: 2px;\n        li {\n          display: flex;\n          padding: 2px 7px 3px 7px;\n          box-sizing: border-box;\n          border-radius: 4px;\n          cursor: pointer;\n          border-width: 2px;\n          border-color: ", ";\n          border-style: solid;\n          &:hover {\n            background-color: ", ";\n          }\n          &.selected {\n            border-color: ", ";\n          }\n        }\n      }\n    }\n  }\n  .body {\n    position: relative;\n    .legends {\n      position: absolute;\n      left: 100px;\n      top: 8px;\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      margin-top: 10px;\n      z-index: -1;\n      width: 100%;\n      > .legend {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        .line {\n          height: 4px;\n          border-radius: 2px;\n          width: 10px;\n        }\n      }\n    }\n  }\n  svg {\n    font-family: ", ";\n    text {\n      font-family: ", ";\n      color: ", ";\n      &.title {\n        fill: ", ";\n      }\n      &.title,\n      &.value {\n        font-weight: 700;\n      }\n      &.label {\n        font-weight: 300;\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  margin: 0 auto;\n  .header {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    padding: 0 100px;\n    .description {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      .values {\n        display: flex;\n        gap: 16px;\n        align-items: center;\n        .profitability {\n          background-color: ", ";\n          border-radius: 2px;\n          padding: 4px 4px;\n          span {\n            color: ", ";\n          }\n          &.positive {\n            background-color: ", ";\n            span {\n              color: ", ";\n            }\n          }\n        }\n      }\n    }\n    .tags {\n      background-color: ", ";\n      padding: 6px;\n      border-radius: 2px;\n      height: fit-content;\n      ul {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-direction: row;\n        gap: 2px;\n        li {\n          display: flex;\n          padding: 2px 7px 3px 7px;\n          box-sizing: border-box;\n          border-radius: 4px;\n          cursor: pointer;\n          border-width: 2px;\n          border-color: ", ";\n          border-style: solid;\n          &:hover {\n            background-color: ", ";\n          }\n          &.selected {\n            border-color: ", ";\n          }\n        }\n      }\n    }\n  }\n  .body {\n    position: relative;\n    .legends {\n      position: absolute;\n      left: 100px;\n      top: 8px;\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      margin-top: 10px;\n      z-index: -1;\n      width: 100%;\n      > .legend {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        .line {\n          height: 4px;\n          border-radius: 2px;\n          width: 10px;\n        }\n      }\n    }\n  }\n  svg {\n    font-family: ", ";\n    text {\n      font-family: ", ";\n      color: ", ";\n      &.title {\n        fill: ", ";\n      }\n      &.title,\n      &.value {\n        font-weight: 700;\n      }\n      &.label {\n        font-weight: 300;\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.cyan;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark100;
});
var templateObject_1$n;

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
}

function ascendingComparator(f) {
  return function(d, x) {
    return ascending$1(f(d), x);
  };
}

var ascendingBisect = bisector(ascending$1);
var bisectRight = ascendingBisect.right;

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function max(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
}

function min(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
}

var slice$1 = Array.prototype.slice;

function identity$3(x) {
  return x;
}

var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon$2 = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number$2(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$3) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number$2)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "currentColor"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "currentColor")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "currentColor")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon$2)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon$2)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? (tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1)
            : (tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1));

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames$1(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames$1(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$1(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get$1(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set$1(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
}

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

function creator(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
}

function none() {}

function selector(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}

function selection_select(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function empty() {
  return [];
}

function selectorAll(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}

function selection_selectAll(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection$1(subgroups, parents);
}

function matcher(selector) {
  return function() {
    return this.matches(selector);
  };
}

function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection$1(subgroups, this._parents);
}

function sparse(update) {
  return new Array(update.length);
}

function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

function constant$3(x) {
  return function() {
    return x;
  };
}

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

function selection_data(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$3(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}

function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove(); else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}

function selection_merge(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection$1(merges, this._parents);
}

function selection_order() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
}

function selection_sort(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection$1(sortgroups, this._parents).order();
}

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}

function selection_nodes() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}

function selection_node() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
}

function selection_size() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}

function selection_empty() {
  return !this.node();
}

function selection_each(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
}

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction$1(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS$1(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

function selection_attr(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS$1 : attrRemove$1) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)))(fullname, value));
}

function defaultView(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
}

function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction$1(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

function selection_style(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove$1 : typeof value === "function"
            ? styleFunction$1
            : styleConstant$1)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
}

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

function selection_property(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
}

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

function selection_classed(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
}

function textRemove() {
  this.textContent = "";
}

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

function selection_text(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction$1
          : textConstant$1)(value))
      : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

function selection_html(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
}

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
}

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}

var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

function selection_on(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
}

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

function selection_dispatch(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
}

var root = [null];

function Selection$1(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection$1([[document.documentElement]], root);
}

Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

function select(selector) {
  return typeof selector === "string"
      ? new Selection$1([[document.querySelector(selector)]], [document.documentElement])
      : new Selection$1([[selector]], root);
}

function sourceEvent() {
  var current = event, source;
  while (source = current.sourceEvent) current = source;
  return current;
}

function point(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
}

function mouse(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
}

function selectAll(selector) {
  return typeof selector === "string"
      ? new Selection$1([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection$1([selector == null ? [] : selector], root);
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

function constant$2(x) {
  return function() {
    return x;
  };
}

function linear$2(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$2(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$2(a, d) : constant$2(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolateValue(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$2(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date$1
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var frame = 0, // is an animation frame pending?
    timeout$1 = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout$1) timeout$1 = clearTimeout(timeout$1);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

function timeout(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}

var emptyOn = dispatch("start", "end", "cancel", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function schedule(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}

function init(node, id) {
  var schedule = get(node, id);
  if (schedule.state > CREATED) throw new Error("too late; already scheduled");
  return schedule;
}

function set(node, id) {
  var schedule = get(node, id);
  if (schedule.state > STARTED) throw new Error("too late; already running");
  return schedule;
}

function get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout(start);

      // Interrupt the active transition, if any.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions.
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(node, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

function interrupt(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
}

function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

function transition_tween(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
}

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get(node, id).value[name];
  };
}

function interpolate(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
}

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrConstantNS(fullname, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function attrFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function attrFunctionNS(fullname, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}

function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}

function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}

function attrTweenNS(fullname, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

function transition_delay(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get(this.node(), id).delay;
}

function durationFunction(id, value) {
  return function() {
    set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set(this, id).duration = value;
  };
}

function transition_duration(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get(this.node(), id).duration;
}

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set(this, id).ease = value;
  };
}

function transition_ease(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get(this.node(), id).ease;
}

function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
}

function transition_merge(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
}

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

function transition_on(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
}

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
}

function transition_selectAll(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
}

var Selection = selection.prototype.constructor;

function transition_selection() {
  return new Selection(this._groups, this._parents);
}

function styleNull(name, interpolate) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, string10 = string1);
  };
}

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, interpolate, value1) {
  var string00,
      string1 = value1 + "",
      interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null
        : string0 === string00 ? interpolate0
        : interpolate0 = interpolate(string00 = string0, value1);
  };
}

function styleFunction(name, interpolate, value) {
  var string00,
      string10,
      interpolate0;
  return function() {
    var string0 = styleValue(this, name),
        value1 = value(this),
        string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null
        : string0 === string00 && string1 === string10 ? interpolate0
        : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
  };
}

function styleMaybeRemove(id, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
  return function() {
    var schedule = set(this, id),
        on = schedule.on,
        listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);

    schedule.on = on1;
  };
}

function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
      .styleTween(name, styleNull(name, i))
      .on("end.style." + name, styleRemove(name))
    : typeof value === "function" ? this
      .styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value)))
      .each(styleMaybeRemove(this._id, name))
    : this
      .styleTween(name, styleConstant(name, i, value), priority)
      .on("end.style." + name, null);
}

function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}

function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}

function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

function transition_text(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
}

function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}

function textTween(value) {
  var t0, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
    return t0;
  }
  tween._value = value;
  return tween;
}

function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, textTween(value));
}

function transition_transition() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
}

function transition_end() {
  var on0, on1, that = this, id = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {value: reject},
        end = {value: function() { if (--size === 0) resolve(); }};

    that.each(function() {
      var schedule = set(this, id),
          on = schedule.on;

      // If this node shared a dispatch with the previous node,
      // just assign the updated shared dispatch and we’re done!
      // Otherwise, copy-on-write.
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end);
      }

      schedule.on = on1;
    });
  });
}

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  end: transition_end
};

function linear$1(t) {
  return +t;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return (t = +t) * t * (s * (t - 1) + t);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

((function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((t + 1) * s + t) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
}))(overshoot);

((function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
}))(overshoot);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

function selection_transition(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
}

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var pi = Math.PI,
    tau = 2 * pi,
    epsilon$1 = 1e-6,
    tauEpsilon = tau - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

var prefix = "$";

function Map$1() {}

Map$1.prototype = map$2.prototype = {
  constructor: Map$1,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$2(object, f) {
  var map = new Map$1;

  // Copy constructor.
  if (object instanceof Map$1) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

function Set$1() {}

var proto = map$2.prototype;

Set$1.prototype = {
  constructor: Set$1,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function responseJson(response) {
  if (!response.ok) throw new Error(response.status + " " + response.statusText);
  if (response.status === 204 || response.status === 205) return;
  return response.json();
}

function json(input, init) {
  return fetch(input, init).then(responseJson);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": formatDecimal,
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

function identity$1(x) {
  return x;
}

var map$1 = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$1(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$1 : formatGroup(map$1.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$1 : formatNumerals(map$1.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$1;
var format;
var formatPrefix;

defaultLocale$1({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function defaultSource() {
  return Math.random();
}

((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
}))(defaultSource);

var normal = (function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(defaultSource);

((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
}))(defaultSource);

var irwinHall = (function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(defaultSource);

((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
}))(defaultSource);

((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
}))(defaultSource);

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

var array = Array.prototype;

var map = array.map;
var slice = array.slice;

var implicit = {name: "implicit"};

function ordinal() {
  var index = map$2(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$2();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function constant$1(x) {
  return function() {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$1(isNaN(b) ? NaN : 0.5);
}

function clamper(domain) {
  var a = domain[0], b = domain[domain.length - 1], t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = interpolateValue,
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map.call(_, number$1), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = slice.call(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous(transform, untransform) {
  return transformer()(transform, untransform);
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous(identity, identity);

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var utcMillisecond = millisecond;
millisecond.range;

var durationSecond$1 = 1e3;
var durationMinute$1 = 6e4;
var durationHour$1 = 36e5;
var durationDay$1 = 864e5;
var durationWeek$1 = 6048e5;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function(start, end) {
  return (end - start) / durationSecond$1;
}, function(date) {
  return date.getUTCSeconds();
});

var utcSecond = second;
second.range;

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getMinutes();
});

var timeMinute = minute;
minute.range;

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$1 - date.getMinutes() * durationMinute$1);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getHours();
});

var timeHour = hour;
hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
}, function(date) {
  return date.getDate() - 1;
});

var timeDay = day;
day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

sunday.range;
monday.range;
tuesday.range;
wednesday.range;
thursday.range;
friday.range;
saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var timeMonth = month;
month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var timeYear = year;
year.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDay$1 = utcDay;
utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYear$1 = utcYear;
utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay$1.count(utcYear$1(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear$1(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear$1(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale;
var timeFormat;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  locale.parse;
  locale.utcFormat;
  locale.utcParse;
  return locale;
}

var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = continuous(identity, identity),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(tickStep(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map.call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(timeYear, timeMonth, sunday, timeDay, timeHour, timeMinute, utcSecond, utcMillisecond, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function constant(x) {
  return function constant() {
    return x;
  };
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

function line() {
  var x$1 = x,
      y$1 = y,
      defined = constant(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function area() {
  var x0 = x,
      x1 = null,
      y0 = constant(0),
      y1 = y,
      defined = constant(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon
      && Math.abs(y - lArc.circle.cy) < epsilon) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon
      && Math.abs(y - rArc.circle.cy) < epsilon) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

new Transform(1, 0, 0);

Transform.prototype;

var Area = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale, data = _a.data, color = _a.color, disableAnimation = _a.disableAnimation, props = __rest(_a, ["xScale", "yScale", "data", "color", "disableAnimation"]);
    var ref = React__default["default"].useRef(null);
    React__default["default"].useEffect(function () {
        if (disableAnimation) {
            select(ref.current).attr('opacity', 1);
            return;
        }
        select(ref.current)
            .transition()
            .duration(750)
            .ease(backIn)
            .attr('opacity', 1);
    }, [disableAnimation]);
    var d = React__default["default"].useMemo(function () {
        var area$1 = area()
            .x(function (_a) {
            var date = _a.date;
            return xScale(date);
        })
            .y1(function (_a) {
            var value = _a.value;
            return yScale(value);
        })
            .y0(function () { return yScale(yScale.domain()[0]); });
        return area$1(data);
    }, [xScale, yScale, data]);
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("path", __assign({ ref: ref, d: d, fill: "url(#gradient-".concat(color, ")"), opacity: 0 }, props)), jsxRuntime.jsx("defs", { children: jsxRuntime.jsxs("linearGradient", __assign({ id: "gradient-".concat(color), x1: '0%', x2: '0%', y1: '0%', y2: '90%' }, { children: [jsxRuntime.jsx("stop", { offset: '0%', stopColor: color, stopOpacity: 0.2 }), jsxRuntime.jsx("stop", { offset: '90%', stopColor: color, stopOpacity: 0 })] })) })] }));
};

json('https://cdn.jsdelivr.net/npm/d3-time-format@3/locale/pt-BR.json').then(function (locale) { return defaultLocale(locale); });
formatLocale$1({
    currency: ['R$', ''],
    decimal: '.',
    grouping: [3],
    thousands: ',',
});
var formatPriceBR = function (price) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);
};

var Axis = function (_a) {
    var type = _a.type, scale = _a.scale, ticks = _a.ticks, transform = _a.transform, tickFormat = _a.tickFormat, disableAnimation = _a.disableAnimation, anchorEl = _a.anchorEl, props = __rest(_a, ["type", "scale", "ticks", "transform", "tickFormat", "disableAnimation", "anchorEl"]);
    var ref = React__default["default"].useRef(null);
    var theme = styled.useTheme();
    React__default["default"].useEffect(function () {
        var axisGenerator = type === 'left' ? axisLeft : axisBottom;
        var axis = axisGenerator(scale).ticks(ticks).tickFormat(tickFormat);
        var axisGroup = select(ref.current);
        if (disableAnimation)
            axisGroup.call(axis);
        else
            axisGroup.transition().duration(750).ease(linear$1).call(axis);
        if (['left', 'right'].includes(type))
            axisGroup.select('.domain').remove();
        axisGroup.selectAll('line').remove();
        axisGroup.select('.domain').attr('stroke', theme.colors.gray400);
        axisGroup
            .selectAll('text')
            .attr('opacity', 1)
            .attr('fill', theme.colors.darkBlue)
            .attr('font-size', theme.textSizes.body)
            .attr('font-weight', 600);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scale, ticks, tickFormat, disableAnimation]);
    React__default["default"].useEffect(function () {
        select(anchorEl)
            .on('mouseout.axisX', function () {
            select(ref.current)
                .selectAll('text')
                .attr('opacity', 1)
                .attr('fill', theme.colors.darkBlue)
                .attr('font-size', theme.textSizes.body)
                .style('font-weight', 600);
        })
            .on('mousemove.axisX', function () {
            var x = mouse(anchorEl)[0];
            var xDate = scale.invert(x);
            var textElements = select(ref.current).selectAll('text');
            var data = textElements.data();
            var index = bisector(function (d) { return d; }).left(data, xDate);
            textElements.attr('fill', function (d, i) {
                return d && i === index - 1 ? theme.colors.pink800 : theme.colors.darkBlue;
            });
        });
    }, [anchorEl, scale]);
    return jsxRuntime.jsx("g", __assign({ ref: ref, transform: transform }, props));
};

var GridLine = function (_a) {
    var type = _a.type, scale = _a.scale, ticks = _a.ticks, size = _a.size, transform = _a.transform, disableAnimation = _a.disableAnimation, props = __rest(_a, ["type", "scale", "ticks", "size", "transform", "disableAnimation"]);
    var ref = React__default["default"].useRef(null);
    var theme = styled.useTheme();
    React__default["default"].useEffect(function () {
        var axisGenerator = type === 'vertical' ? axisBottom : axisLeft;
        var axis = axisGenerator(scale).ticks(ticks).tickSize(-size);
        var gridGroup = select(ref.current);
        if (disableAnimation)
            gridGroup.call(axis);
        else
            gridGroup.transition().duration(750).ease(linear$1).call(axis);
        gridGroup.select('.domain').remove();
        gridGroup.selectAll('text').remove();
        gridGroup
            .selectAll('line')
            .attr('stroke', theme.colors.gray400)
            .attr('stroke-dasharray', '8 8');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scale, ticks, size, disableAnimation]);
    return jsxRuntime.jsx("g", __assign({ ref: ref, transform: transform }, props));
};

var Line = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale, color = _a.color, data = _a.data, animation = _a.animation, props = __rest(_a, ["xScale", "yScale", "color", "data", "animation"]);
    var ref = React__default["default"].useRef(null);
    // Define different types of animation that we can use
    var animateLeft = React__default["default"].useCallback(function () {
        var totalLength = ref.current.getTotalLength();
        select(ref.current)
            .attr('opacity', 1)
            .attr('stroke-dasharray', "".concat(totalLength, ",").concat(totalLength))
            .attr('stroke-dashoffset', totalLength)
            .transition()
            .duration(750)
            .ease(linear$1)
            .attr('stroke-dashoffset', 0);
    }, []);
    var animateFadeIn = React__default["default"].useCallback(function () {
        select(ref.current)
            .transition()
            .duration(750)
            .ease(linear$1)
            .attr('opacity', 1);
    }, []);
    var noneAnimation = React__default["default"].useCallback(function () {
        select(ref.current).attr('opacity', 1);
    }, []);
    React__default["default"].useEffect(function () {
        switch (animation) {
            case 'left':
                animateLeft();
                break;
            case 'fadeIn':
                animateFadeIn();
                break;
            case 'none':
            default:
                noneAnimation();
                break;
        }
    }, [animateLeft, animateFadeIn, noneAnimation, animation]);
    // Recalculate line length if scale has changed
    React__default["default"].useEffect(function () {
        if (ref.current && animation === 'left') {
            var totalLength = ref.current.getTotalLength();
            select(ref.current).attr('stroke-dasharray', "".concat(totalLength, ",").concat(totalLength));
        }
    }, [ref, xScale, yScale, animation]);
    var line$1 = line()
        .x(function (d) { return xScale(d.date); })
        .y(function (d) { return yScale(d.value); });
    return (jsxRuntime.jsx("path", __assign({ ref: ref, d: line$1(data), stroke: color, strokeWidth: 3, fill: 'none', opacity: 0 }, props)));
};

var Tooltip = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale, width = _a.width, height = _a.height, data = _a.data, margin = _a.margin, anchorEl = _a.anchorEl; _a.children; var props = __rest(_a, ["xScale", "yScale", "width", "height", "data", "margin", "anchorEl", "children"]);
    var theme = styled.useTheme();
    var ref = React__default["default"].useRef(null);
    var drawLine = React__default["default"].useCallback(function (x) {
        select(ref.current)
            .select('.tooltipLine')
            .attr('x1', x)
            .attr('x2', x)
            .attr('y1', -margin)
            .attr('y2', height);
    }, [ref, height, margin]);
    var drawContent = React__default["default"].useCallback(function (x, y) {
        var tooltipContent = select(ref.current).select('.tooltipContent');
        var tooltipArrow = select(ref.current).select('.tooltipArrow');
        tooltipContent.attr('transform', function (cur, i, nodes) {
            var _a, _b;
            var nodeWidth = ((_b = (_a = nodes[i]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) || 0;
            var translateX = nodeWidth + x > width ? x - nodeWidth + margin / 2 : x - margin / 2;
            return "translate(".concat(translateX, ", ").concat(y - 210, ")");
        });
        tooltipArrow.attr('transform', function (cur, i, nodes) {
            var _a, _b;
            var nodeWidth = ((_b = (_a = nodes[i]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) || 0;
            var translateX = nodeWidth + x - 41 > width
                ? x - 41 - nodeWidth - margin * 2
                : x + 41 + margin * 2;
            return "translate(".concat(translateX, ", ").concat(y - 146, ")");
        });
        tooltipContent
            .select('.contentTitle')
            .text(timeFormat('%b %d, %Y')(xScale.invert(x)));
    }, [xScale, margin, width]);
    var drawBackground = React__default["default"].useCallback(function () {
        // reset background size to defaults
        var contentBackground = select(ref.current)
            .select('.contentBackground');
        // contentBackground.attr("width", 125).attr("height", 40);
        contentBackground.attr('width', 210).attr('height', 220);
        // calculate new background size
        var tooltipContentElement = select(ref.current)
            .select('.tooltipContent')
            .node();
        if (!tooltipContentElement)
            return;
        var contentSize = tooltipContentElement.getBoundingClientRect();
        contentBackground
            .attr('width', contentSize.width)
            .attr('height', contentSize.height);
    }, []);
    var onChangePosition = React__default["default"].useCallback(function (d, i, isVisible) {
        selectAll('.performanceItemValue')
            .filter(function (td, tIndex) {
            return !td && tIndex === i;
        })
            .text(isVisible ? formatPriceBR(d.value) : '');
        if (d.profitability) {
            selectAll('.profitabilityValue')
                .filter(function (td, tIndex) {
                return !td && tIndex === i;
            })
                .text(d.value && !isVisible ? 'No data' : d.profitability
            // d.value && !isVisible ? "No data" : formatPercent(d.profitability)
            )
                .attr('fill', d.positive ? '#14C87D' : theme.colors.red);
        }
    }, []);
    var followPoints = React__default["default"].useCallback(function () {
        var x = mouse(anchorEl)[0];
        var xDate = xScale.invert(x);
        var bisectDate = bisector(function (d) { return d.date; }).left;
        var baseXPos = 0;
        var baseYPos = 0;
        // draw circles on line
        select(ref.current)
            .selectAll('.tooltipLinePoint')
            .attr('transform', function (cur, i) {
            var index = bisectDate(data[i].items, xDate, 1);
            var d0 = data[i].items[index - 1];
            var d1 = data[i].items[index];
            var d = xDate - (d0 === null || d0 === void 0 ? void 0 : d0.date) > (d1 === null || d1 === void 0 ? void 0 : d1.date) - xDate ? d1 : d0;
            if (d.date === undefined && d.value === undefined) {
                // move point out of container
                return 'translate(-100,-100)';
            }
            var xPos = xScale(d.date);
            if (i === 0) {
                baseXPos = xPos;
            }
            var isVisible = true;
            if (xPos !== baseXPos) {
                isVisible = false;
            }
            var yPos = yScale(d.value);
            baseYPos = baseYPos || yPos;
            onChangePosition(d, i, isVisible);
            return !cur && isVisible
                ? "translate(".concat(xPos, ", ").concat(yPos, ")")
                : 'translate(-100,-100)';
        });
        drawLine(baseXPos);
        drawContent(baseXPos, baseYPos);
        drawBackground();
    }, [
        anchorEl,
        drawLine,
        drawContent,
        drawBackground,
        xScale,
        yScale,
        data,
        onChangePosition,
    ]);
    React__default["default"].useEffect(function () {
        select(anchorEl)
            .on('mouseout.tooltip', function () {
            select(ref.current).attr('opacity', 0);
        })
            .on('mouseover.tooltip', function () {
            select(ref.current).attr('opacity', 1);
        })
            .on('mousemove.tooltip', function () {
            select(ref.current).selectAll('.tooltipLinePoint');
            followPoints();
        });
    }, [anchorEl, followPoints]);
    if (!data.length)
        return null;
    return (jsxRuntime.jsxs("g", __assign({ ref: ref, opacity: 0 }, props, { children: [jsxRuntime.jsx("line", { className: 'tooltipLine', stroke: theme.colors.pink800, strokeWidth: 2, strokeDasharray: '10, 10' }), jsxRuntime.jsxs("g", __assign({ className: 'tooltipContent' }, { children: [jsxRuntime.jsx("rect", { className: 'contentBackground', rx: 4, ry: 4, opacity: 1, fill: theme.colors.light, stroke: theme.colors.gray200, strokeWidth: 2 }), jsxRuntime.jsx("text", { className: 'contentTitle title', color: theme.colors.gray400, transform: 'translate(20,30)', fill: 'currentColor' }), jsxRuntime.jsx("g", __assign({ className: 'content', strokeWidth: 1, transform: 'translate(10,65)' }, { children: (function () {
                            return data.map(function (_a, i) {
                                var name = _a.name, label = _a.label, color = _a.color;
                                return (jsxRuntime.jsxs("g", __assign({ width: 170 }, { children: [jsxRuntime.jsx("text", __assign({ fontSize: 12, className: 'performanceItemName label', transform: "translate(10,".concat(40 * i - 10, ")") }, { children: label })), jsxRuntime.jsx("text", { className: 'performanceItemValue value', fontSize: 18, transform: "translate(10,".concat(40 * i + 10, ")"), fill: color }), jsxRuntime.jsxs("g", __assign({ transform: 'translate(10,110)' }, { children: [jsxRuntime.jsx("text", __assign({ fontSize: 12, className: 'label', fill: theme.colors.gray400 }, { children: "Rentabilidade de" })), jsxRuntime.jsx("text", { className: 'profitabilityValue value', transform: 'translate(0,20)' })] }))] }), name));
                            });
                        })() }))] })), jsxRuntime.jsx("g", __assign({ className: 'tooltipArrow', height: 20, width: 20 }, { children: jsxRuntime.jsx("rect", { height: 20, width: 20, opacity: 1, fill: theme.colors.light, stroke: theme.colors.gray200, strokeWidth: '2', strokeDasharray: '0 20 40 0', y: 200, x: 0, transform: 'rotate(45)' }) })), data.map(function (_a) {
                var name = _a.name, color = _a.color;
                return (jsxRuntime.jsx("circle", { className: 'tooltipLinePoint', r: 2, fill: "".concat(color, "00"), opacity: 0 }, name));
            })] })));
};

var Overlay = React__default["default"].forwardRef(function (_a, ref) {
    var width = _a.width, height = _a.height, children = _a.children;
    return (jsxRuntime.jsxs("g", __assign({ cursor: 'pointer' }, { children: [children, jsxRuntime.jsx("rect", { ref: ref, width: width, height: height, opacity: 0 })] })));
});

var useGraphController = function (_a) {
    var data = _a.data, width = _a.width, height = _a.height;
    var xMin = React__default["default"].useMemo(function () { return min(data, function (_a) {
        var items = _a.items;
        return min(items, function (_a) {
            var date = _a.date;
            return date;
        });
    }); }, [data]);
    var xMax = React__default["default"].useMemo(function () { return max(data, function (_a) {
        var items = _a.items;
        return max(items, function (_a) {
            var date = _a.date;
            return date;
        });
    }); }, [data]);
    var xScale = React__default["default"].useMemo(function () { return time().domain([xMin, xMax]).range([0, width]); }, [xMin, xMax, width]);
    var yMin = React__default["default"].useMemo(function () { return min(data, function (_a) {
        var items = _a.items;
        return min(items, function (_a) {
            var value = _a.value;
            return value;
        });
    }); }, [data]);
    var yMax = React__default["default"].useMemo(function () { return max(data, function (_a) {
        var items = _a.items;
        return max(items, function (_a) {
            var value = _a.value;
            return value;
        });
    }); }, [data]);
    var yScale = React__default["default"].useMemo(function () {
        var indention = (yMax / 2 - yMin) * 0.5;
        return linear()
            .domain([yMin - indention, yMax + indention])
            .range([height, 0]);
    }, [height, yMin, yMax]);
    var yScaleForAxis = React__default["default"].useMemo(function () {
        return band()
            .domain([yMin, yMax / 2, yMax])
            .range([height, 0]);
    }, [height, yMin, yMax]);
    var numberKFormat = function (num) {
        return Math.abs(num) > 999
            ? (Math.sign(num) * (Math.abs(num) / 1000)).toFixed(1) + 'k'
            : Math.sign(num) * Math.abs(num);
    };
    var yTickFormat = function (d) {
        return d
            ? "".concat(parseFloat(d) >= 0 ? '+' : '').concat(numberKFormat(d))
            : d === 0
                ? '0.0'
                : '';
    };
    var xTickFormat = function (d) { return (d ? "".concat(timeFormat('%b %Y')(d)) : ''); };
    return {
        yTickFormat: yTickFormat,
        xTickFormat: xTickFormat,
        xScale: xScale,
        yScale: yScale,
        yScaleForAxis: yScaleForAxis,
    };
};

var Graph = function (_a) {
    var width = _a.width, height = _a.height, graphData = _a.graphData, tags = _a.tags, cash = _a.cash, profitability = _a.profitability, date = _a.date, positive = _a.positive; _a.loading; var args = __rest(_a, ["width", "height", "graphData", "tags", "cash", "profitability", "date", "positive", "loading"]);
    // Constants
    var margin = 100;
    var svgWidth = width + margin * 2;
    var svgHeight = (height + margin) * 1.2;
    // Ref
    var graphRef = React__default["default"].useRef(null);
    var overlayRef = React__default["default"].useRef(null);
    // State
    var _b = React__default["default"].useState(null), overlay = _b[0], setOverlay = _b[1];
    // const [ticks, setTicks] = React.useState(3);
    var _c = React__default["default"].useState(tags ? tags.length : 0), tag = _c[0], setTag = _c[1];
    var _d = React__default["default"].useState(graphData), data = _d[0], setData = _d[1];
    // Adding color
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Controllers
    var _e = useGraphController({
        data: data,
        width: width,
        height: height,
    }), yTickFormat = _e.yTickFormat, xTickFormat = _e.xTickFormat, yScaleForAxis = _e.yScaleForAxis, xScale = _e.xScale, yScale = _e.yScale;
    React__default["default"].useEffect(function () {
        if (overlayRef && overlayRef.current) {
            setOverlay(overlayRef.current);
        }
    }, [overlayRef]);
    React__default["default"].useEffect(function () {
        if (tags && tag) {
            var t_1 = tags[tag - 1];
            var newData = graphData.map(function (d) {
                var itemsClone = __spreadArray([], d.items, true);
                var items = itemsClone.splice(itemsClone.length - t_1.value, itemsClone.length);
                return __assign(__assign({}, d), { items: items });
            });
            setData(newData);
        }
        // if (tags) setTicks(tags[tag].value);
    }, [tag, tags, graphData]);
    return (jsxRuntime.jsxs(GraphWrapper, __assign({}, args, { children: [jsxRuntime.jsxs("div", __assign({ className: 'header' }, { children: [cash && profitability && date && (jsxRuntime.jsxs("div", __assign({ className: 'description' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'data' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.medium, color: exports.Colors.gray500 }, { children: date })) })), jsxRuntime.jsxs("div", __assign({ className: 'values' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'cash' }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, preset: exports.TextSizes.heading4 }, { children: cash })) })), jsxRuntime.jsx("div", __assign({ className: "profitability ".concat(positive ? 'positive' : 'negative') }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.bold }, { children: profitability })) }))] }))] }))), tags && (jsxRuntime.jsx("div", __assign({ className: 'tags' }, { children: jsxRuntime.jsx("ul", { children: tags.map(function (t, i) { return (jsxRuntime.jsx(Button, { label: t.label, color: exports.Colors.darkBlue, preset: tag === i + 1 ? exports.EButtonPreset.solid : exports.EButtonPreset.link, onClick: function () { return setTag(i + 1); }, compact: true }, t.id)); }) }) })))] })), jsxRuntime.jsxs("div", __assign({ className: 'body' }, { children: [data && (jsxRuntime.jsx("div", __assign({ className: 'legends' }, { children: data.map(function (_a) {
                            var id = _a.id, label = _a.label, color = _a.color;
                            return (jsxRuntime.jsxs("div", __assign({ className: 'legend' }, { children: [jsxRuntime.jsx("span", { className: 'line', style: { backgroundColor: "".concat(color) } }), jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, weight: exports.EFontWeight.bold }, { children: label }))] }), id));
                        }) }))), jsxRuntime.jsx("svg", __assign({ ref: graphRef }, { width: svgWidth, height: svgHeight }, { children: jsxRuntime.jsxs("g", __assign({ transform: "translate(".concat(margin, ",").concat(margin * 1.5, ")") }, { children: [jsxRuntime.jsx(GridLine, { type: 'vertical', scale: xScale, ticks: 3, size: svgHeight, transform: "translate(0, ".concat(height, ")") }), jsxRuntime.jsx(GridLine, { type: 'horizontal', scale: yScaleForAxis, ticks: 3, size: width, transform: "translate(0, 25)" }), data.map(function (_a) {
                                    var name = _a.name, _b = _a.items, items = _b === void 0 ? [] : _b, color = _a.color;
                                    return (jsxRuntime.jsx(Line, { data: items, xScale: xScale, yScale: yScale, color: color, animation: 'none', transform: "translate(0, 25)" }, name));
                                }), jsxRuntime.jsx(Axis, { type: 'left', scale: yScaleForAxis, transform: "translate(0, 25)", ticks: 3, tickFormat: yTickFormat }), data.map(function (_a) {
                                    var items = _a.items, color = _a.color, name = _a.name;
                                    return (jsxRuntime.jsx(Area, { data: items, color: color, xScale: xScale, yScale: yScale, transform: "translate(0, 25)" }, "area-".concat(name)));
                                }), jsxRuntime.jsxs(Overlay, __assign({ ref: overlayRef }, { width: width, height: height }, { children: [jsxRuntime.jsx(Axis, { type: 'bottom', scale: xScale, transform: "translate(0, ".concat(height, ")"), ticks: 3, tickFormat: xTickFormat, anchorEl: overlay }), jsxRuntime.jsx(Tooltip, { className: 'tooltip', anchorEl: overlay, width: width, height: height, margin: margin / 2, xScale: xScale, yScale: yScale, data: data })] }))] })) }))] }))] })));
};

/**
 * Components
 */
var ConfigWrapper = styled__default["default"].div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    > .info {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .toggle {\n    }\n  }\n"], ["\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  > .content {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 16px;\n    > .info {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n    }\n    > .toggle {\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
});
var templateObject_1$m;

/**
 * Components
 */
var ToggleWrapper = styled__default["default"](motion.div)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  height: 16px;\n  width: 32px;\n  display: flex;\n  cursor: pointer;\n  .content {\n    display: flex;\n    flex: 1;\n    position: relative;\n    border-width: 2px;\n    border-style: solid;\n    border-color: ", ";\n    box-sizing: border-box;\n    border-radius: 16px;\n    .toggle {\n      height: 16px;\n      width: 16px;\n      border-radius: 16px;\n      background-color: ", ";\n      position: absolute;\n      top: -2px;\n      left: -2px;\n    }\n  }\n"], ["\n  height: 16px;\n  width: 32px;\n  display: flex;\n  cursor: pointer;\n  .content {\n    display: flex;\n    flex: 1;\n    position: relative;\n    border-width: 2px;\n    border-style: solid;\n    border-color: ", ";\n    box-sizing: border-box;\n    border-radius: 16px;\n    .toggle {\n      height: 16px;\n      width: 16px;\n      border-radius: 16px;\n      background-color: ", ";\n      position: absolute;\n      top: -2px;\n      left: -2px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
});
var templateObject_1$l;

var Toggle = React__default["default"].forwardRef(function (_a, ref) {
    var onChange = _a.onChange, isSelected = _a.isSelected, args = __rest(_a, ["onChange", "isSelected"]);
    var _b = React__default["default"].useState(false), selected = _b[0], setSelected = _b[1];
    var toggle = function () {
        onChange(selected);
        setSelected(!selected);
    };
    React__default["default"].useImperativeHandle(ref, function () {
        return {
            toggle: toggle,
            selected: selected,
        };
    });
    return (jsxRuntime.jsx(ToggleWrapper, __assign({}, args, { onClick: toggle }, { children: jsxRuntime.jsx(motion.div, __assign({ className: 'content', initial: 'disable', animate: selected || isSelected ? 'enable' : 'disable', variants: {
                disable: {},
                enable: {
                    borderColor: exports.Colors.pink600,
                },
            } }, { children: jsxRuntime.jsx(motion.span, { className: 'toggle', initial: 'disable', animate: selected || isSelected ? 'enable' : 'disable', variants: {
                    disable: {
                        x: -2,
                    },
                    enable: {
                        x: 16,
                        backgroundColor: exports.Colors.pink800,
                    },
                } }) })) })));
});

var Config = function (_a) {
    var label = _a.label, description = _a.description, actived = _a.actived, onChange = _a.onChange, args = __rest(_a, ["label", "description", "actived", "onChange"]);
    var toggleRef = React__default["default"].useRef();
    var toggle = function () {
        if (toggleRef && toggleRef.current) {
            toggleRef.current.toggle();
            onChange(toggleRef.current.selected);
        }
    };
    return (jsxRuntime.jsx(ConfigWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'content', onClick: toggle }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'info' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: !description ? exports.TextSizes.bodyMd : exports.TextSizes.bodyLg }, { children: label })), description && jsxRuntime.jsx(Text, __assign({ color: exports.Colors.gray800 }, { children: description }))] })), jsxRuntime.jsx("div", __assign({ className: 'toggle' }, { children: jsxRuntime.jsx(Toggle, { isSelected: actived, onChange: onChange, ref: toggleRef }) }))] })) })));
};

var voxUiTheme = {
    fontFamily: '"Red Hat Display", sans-serif',
    secondaryfontFamily: '"Playfair Display", "Nunito Sans", sans-serif',
    colors: __assign({}, exports.Colors),
    textSizes: __assign({}, exports.TextSizes),
    textLineHeight: __assign({}, exports.TextLineHeight),
    imgs: {
        logoLarge: ImgVoxLogoLarge,
        voxLogoPink: ImgVoxLogoPink,
        ods1: ImgOds001,
        ods2: ImgOds002,
        ods3: ImgOds003,
        ods4: ImgOds004,
        ods5: ImgOds005,
        ods6: ImgOds006,
        ods7: ImgOds007,
        ods8: ImgOds008,
        ods9: ImgOds009,
        ods10: ImgOds010,
        ods11: ImgOds011,
        ods12: ImgOds012,
        ods13: ImgOds013,
        ods14: ImgOds014,
        ods15: ImgOds015,
        ods16: ImgOds016,
        ods17: ImgOds017,
    },
    borderRadius: {
        button: 2,
        card: 4,
    },
    padding: {
        menuItem: {
            left: 10,
            right: 15,
        },
    },
    breakpoints: {
        xs: exports.BreakPoints.xs,
        sm: exports.BreakPoints.sm,
        md: exports.BreakPoints.md,
        lg: exports.BreakPoints.lg,
        xl: exports.BreakPoints.xl,
        xxl: exports.BreakPoints.xxl,
    },
};

var UIThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? voxUiTheme : _b, children = _a.children;
    return jsxRuntime.jsx(styled.ThemeProvider, __assign({ theme: theme }, { children: children }));
};

/**
 * Components
 */
var InputWrapper$2 = styled__default["default"].div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  position: relative;\n  flex: 1;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  position: relative;\n  flex: 1;\n  width: ", ";\n"])), function (_a) {
    var block = _a.block;
    return (block ? '100%' : 'auto');
});
var InputLabelWrapper$1 = styled__default["default"].label(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  margin-bottom: 6px;\n  padding-left: 2px;\n"], ["\n  margin-bottom: 6px;\n  padding-left: 2px;\n"])));
var InputBodyWrapper$1 = styled__default["default"].div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  width: 100%;\n"], ["\n  display: flex;\n  position: relative;\n  width: 100%;\n"])));
var InputField$1 = styled__default["default"].input(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  background-color: ", ";\n  border: none;\n  border-bottom-width: ", "px;\n  border-bottom-color: ", ";\n  border-bottom-style: solid;\n  box-sizing: border-box;\n  border-radius: 2px;\n  min-height: 64px;\n  padding-right: ", "px;\n  text-decoration: none;\n  flex: 1;\n  font-size: ", "px;\n  color: ", ";\n  line-height: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  width: 100%;\n  caret-color: ", ";\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::placeholder {\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border-bottom-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border: none;\n  border-bottom-width: ", "px;\n  border-bottom-color: ", ";\n  border-bottom-style: solid;\n  box-sizing: border-box;\n  border-radius: 2px;\n  min-height: 64px;\n  padding-right: ", "px;\n  text-decoration: none;\n  flex: 1;\n  font-size: ", "px;\n  color: ", ";\n  line-height: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  width: 100%;\n  caret-color: ", ";\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::placeholder {\n    color: ", ";\n    font-size: ", "px;\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border-bottom-color: ", ";\n  }\n"])), function (_a) {
    var dark = _a.dark, disabled = _a.disabled;
    return disabled && dark
        ? exports.Colors.darkBlue200
        : disabled && !dark
            ? exports.Colors.gray200
            : exports.Colors.transparent;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0 : 2);
}, function (_a) {
    var theme = _a.theme, hasError = _a.hasError;
    return hasError ? theme.colors.red : theme.colors.gray500;
}, function (_a) {
    var hasRightAddon = _a.hasRightAddon;
    return (hasRightAddon ? 50 : 16);
}, function (_a) {
    var theme = _a.theme;
    return theme.textSizes.bodyLg;
}, function (_a) {
    var theme = _a.theme, dark = _a.dark, disabled = _a.disabled;
    return theme.colors[dark ? 'light' : disabled ? 'gray800' : 'dark200'];
}, function (_a) {
    var theme = _a.theme;
    return theme.textLineHeight.bodyLg;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'text');
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign || 'left';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme, dark = _a.dark;
    return dark ? theme.colors.gray500 : theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.textSizes.bodyLg;
}, function (_a) {
    var theme = _a.theme, hasError = _a.hasError;
    return hasError ? theme.colors.red : theme.colors.pink800;
});
var InputHelpWrapper$1 = styled__default["default"].div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  margin-top: 8px;\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  transform: translateY(150%);\n  line-height: 10px;\n  padding-top: 2px;\n"], ["\n  margin-top: 8px;\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  transform: translateY(150%);\n  line-height: 10px;\n  padding-top: 2px;\n"])));
var InputRightAddon = styled__default["default"].div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  align-items: center;\n  bottom: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  right: 16px;\n  top: 0;\n"], ["\n  align-items: center;\n  bottom: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  right: 16px;\n  top: 0;\n"])));
var templateObject_1$k, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$4, templateObject_6$3;

exports.EInputTypes = void 0;
(function (EInputTypes) {
    EInputTypes[EInputTypes["text"] = 0] = "text";
    EInputTypes[EInputTypes["password"] = 1] = "password";
    EInputTypes[EInputTypes["url"] = 2] = "url";
    EInputTypes[EInputTypes["tel"] = 3] = "tel";
    EInputTypes[EInputTypes["email"] = 4] = "email";
    EInputTypes[EInputTypes["number"] = 5] = "number";
})(exports.EInputTypes || (exports.EInputTypes = {}));
exports.EInputAlign = void 0;
(function (EInputAlign) {
    EInputAlign[EInputAlign["left"] = 0] = "left";
    EInputAlign[EInputAlign["center"] = 1] = "center";
    EInputAlign[EInputAlign["right"] = 2] = "right";
})(exports.EInputAlign || (exports.EInputAlign = {}));

var Input$1 = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, isTexthidden = _a.isTexthidden, _c = _a.type; _c === void 0 ? exports.EInputTypes.text : _c; var placeholder = _a.placeholder, hasError = _a.hasError, _d = _a.errorMessage, errorMessage = _d === void 0 ? 'Aconteceu um error' : _d, hasHelp = _a.hasHelp, helpMessage = _a.helpMessage, _e = _a.hasIcon, hasIcon = _e === void 0 ? false : _e, _f = _a.icon, icon = _f === void 0 ? null : _f, label = _a.label, isDisabled = _a.isDisabled, dark = _a.dark, block = _a.block, removeWhiteSpaces = _a.removeWhiteSpaces, args = __rest(_a, ["name", "isTexthidden", "type", "placeholder", "hasError", "errorMessage", "hasHelp", "helpMessage", "hasIcon", "icon", "label", "isDisabled", "dark", "block", "removeWhiteSpaces"]);
    var _g = React.useState(false), showText = _g[0], setShowText = _g[1];
    return (jsxRuntime.jsxs(InputWrapper$2, __assign({}, { block: block }, { children: [label && (jsxRuntime.jsx(InputLabelWrapper$1, __assign({ htmlFor: name }, { children: jsxRuntime.jsx(Text, __assign({ color: dark ? exports.Colors.gray500 : exports.Colors.darkBlue, preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.medium }, { children: label })) }))), jsxRuntime.jsxs(InputBodyWrapper$1, { children: [jsxRuntime.jsx(InputField$1, __assign({ type: isTexthidden && !showText ? 'password' : 'text', name: name, id: name, disabled: isDisabled, placeholder: placeholder, hasRightAddon: !!(hasIcon && icon), hasError: hasError, ref: ref, dark: dark, autoComplete: 'off', autoCorrect: '', "aria-autocomplete": 'none', onKeyUp: function (inp) {
                            var value = inp.currentTarget.value;
                            inp.currentTarget.value =
                                inp.code === 'Space' && removeWhiteSpaces
                                    ? value.replace(/\s/g, '')
                                    : value;
                        } }, args)), isTexthidden || (hasIcon && icon) ? (jsxRuntime.jsx(InputRightAddon, __assign({ onClick: function () { return (isTexthidden ? setShowText(!showText) : {}); } }, { children: jsxRuntime.jsx(Icon, { icon: isTexthidden && !showText
                                ? exports.Icons.visibility_off
                                : isTexthidden && showText
                                    ? exports.Icons.visibility
                                    : icon || exports.Icons.expand_more, color: isDisabled && dark
                                ? exports.Colors.darkBlue100
                                : isDisabled && !dark
                                    ? exports.Colors.gray200
                                    : dark
                                        ? exports.Colors.light
                                        : exports.Colors.darkBlue }) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] }), (hasError && errorMessage) || (hasHelp && helpMessage) ? (jsxRuntime.jsx(InputHelpWrapper$1, { children: jsxRuntime.jsx(Text, __assign({ color: hasError ? exports.Colors.red : exports.Colors.gray500, weight: exports.EFontWeight.medium }, { children: hasError ? errorMessage : helpMessage })) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })));
});

/**
 * Components
 */
var InputWrapper$1 = styled__default["default"].div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  position: relative;\n  flex: 1;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  position: relative;\n  flex: 1;\n"])));
var InputLabelWrapper = styled__default["default"].label(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  margin-bottom: 6px;\n  padding-left: 2px;\n"], ["\n  margin-bottom: 6px;\n  padding-left: 2px;\n"])));
var InputBodyWrapper = styled__default["default"].div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  width: 100%;\n"], ["\n  display: flex;\n  position: relative;\n  width: 100%;\n"])));
var InputField = styled__default["default"].textarea(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  box-sizing: border-box;\n  border-radius: 2px;\n  min-height: 52px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-decoration: none;\n  flex: 1;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  font-family: ", ";\n  width: 100%;\n  caret-color: ", ";\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  box-sizing: border-box;\n  border-radius: 2px;\n  min-height: 52px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-decoration: none;\n  flex: 1;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  font-family: ", ";\n  width: 100%;\n  caret-color: ", ";\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.gray200 : 'transparent';
}, function (_a) {
    var hasError = _a.hasError, disabled = _a.disabled;
    return !hasError || disabled ? 0 : 2;
}, function (_a) {
    var theme = _a.theme, hasError = _a.hasError;
    return hasError ? theme.colors.red : theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.textSizes.bodyMd;
}, function (_a) {
    var theme = _a.theme;
    return theme.textLineHeight.bodyMd;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'text');
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign || 'left';
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme, hasError = _a.hasError;
    return hasError ? theme.colors.red : theme.colors.dark200;
});
var InputHelpWrapper = styled__default["default"].div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  margin-top: 6px;\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: 2px;\n"], ["\n  margin-top: 6px;\n  padding-left: 2px;\n  position: absolute;\n  left: 0;\n  bottom: 2px;\n"])));
var templateObject_1$j, templateObject_2$5, templateObject_3$4, templateObject_4$3, templateObject_5$3;

var Input = React__default["default"].forwardRef(function (_a, ref) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, placeholder = _a.placeholder, hasError = _a.hasError, _c = _a.errorMessage, errorMessage = _c === void 0 ? 'Aconteceu um error' : _c, hasHelp = _a.hasHelp, helpMessage = _a.helpMessage, label = _a.label, isDisabled = _a.isDisabled, _d = _a.rows, rows = _d === void 0 ? 4 : _d, args = __rest(_a, ["name", "placeholder", "hasError", "errorMessage", "hasHelp", "helpMessage", "label", "isDisabled", "rows"]);
    return (jsxRuntime.jsxs(InputWrapper$1, { children: [label && (jsxRuntime.jsx(InputLabelWrapper, __assign({ htmlFor: name }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: label })) }))), jsxRuntime.jsx(InputBodyWrapper, { children: jsxRuntime.jsx(InputField, __assign({ name: name, id: name, disabled: isDisabled, placeholder: placeholder, hasError: hasError, ref: ref, rows: rows }, args)) }), (hasError && errorMessage) || (hasHelp && helpMessage) ? (jsxRuntime.jsx(InputHelpWrapper, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm, color: hasError ? exports.Colors.red : exports.Colors.gray800 }, { children: hasError ? errorMessage : helpMessage })) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] }));
});

/**
 * Components
 */
var MenuWrapper = styled__default["default"].div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px;\n  border-radius: 2px;\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px;\n  border-radius: 2px;\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var MenuItem = styled__default["default"].div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  height: 52px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: ", "px;\n  padding-right: 30px;\n  &:nth-child(1n + 2) {\n    border-top-width: 1px;\n    border-top-style: solid;\n    border-top-color: ", ";\n  }\n  &:hover {\n    background-color: ", "45;\n  }\n"], ["\n  height: 52px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: ", "px;\n  padding-right: 30px;\n  &:nth-child(1n + 2) {\n    border-top-width: 1px;\n    border-top-style: solid;\n    border-top-color: ", ";\n  }\n  &:hover {\n    background-color: ", "45;\n  }\n"])), function (_a) {
    var icon = _a.icon;
    return (icon ? 20 : 30);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var templateObject_1$i, templateObject_2$4;

// import { MenuItem } from "./../../ui/MenuItem/MenuItem";
var uniqid$1 = require('uniqid');
var EMPTY_MENU = 'Não há dados';
var Menu = function (_a) {
    var itens = _a.itens; _a.onClickItem; var args = __rest(_a, ["itens", "onClickItem"]);
    return (jsxRuntime.jsx(MenuWrapper, __assign({ role: 'menu' }, args, { children: itens ? (itens.map(function (_a) {
            _a.link; var disabled = _a.disabled, label = _a.label, selected = _a.selected, onClick = _a.onClick, leftIcon = _a.leftIcon, actionName = _a.actionName, args = __rest(_a, ["link", "disabled", "label", "selected", "onClick", "leftIcon", "actionName"]);
            return (React.createElement(MenuItem, __assign({}, __assign({ disabled: disabled, icon: leftIcon }, args), { key: uniqid$1(), onClick: disabled || !onClick ? function () { } : function () { return onClick(); } }, (actionName !== '' ? { 'data-vox-action': actionName } : {})),
                leftIcon && (jsxRuntime.jsx(Icon, { color: selected ? exports.Colors.pink800 : exports.Colors.darkBlue, icon: leftIcon })),
                jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, color: selected ? exports.Colors.pink800 : exports.Colors.darkBlue, weight: exports.EFontWeight.medium }, { children: label }))));
        })) : (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: exports.Colors.darkBlue }, { children: EMPTY_MENU }))) })));
};

// Component generated with util/vox-create-component.js
exports.EModalMode = void 0;
(function (EModalMode) {
    EModalMode[EModalMode["FULL"] = 0] = "FULL";
    EModalMode[EModalMode["LATERAL"] = 1] = "LATERAL";
})(exports.EModalMode || (exports.EModalMode = {}));

/**
 * Components
 */
var ModalWrapper = styled__default["default"](motion.div)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"], ["\n  position: fixed;\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"])));
var ModalOverlay = styled__default["default"](motion.div)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  background-color: ", "cc;\n  z-index: 9998;\n"], ["\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  background-color: ", "cc;\n  z-index: 9998;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
});
var ModalContent = styled__default["default"](motion.div)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100vw;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ", ";\n  z-index: 9999;\n  position: relative;\n  @media (min-width: ", ") {\n    width: ", ";\n    ", ";\n  }\n  @media (min-width: ", ") {\n    width: 75%;\n  }\n  @media (min-width: ", ") {\n    width: 1160px;\n  }\n"], ["\n  background-color: ", ";\n  width: 100vw;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ", ";\n  z-index: 9999;\n  position: relative;\n  @media (min-width: ", ") {\n    width: ", ";\n    ", ";\n  }\n  @media (min-width: ", ") {\n    width: 75%;\n  }\n  @media (min-width: ", ") {\n    width: 1160px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var mode = _a.mode;
    return mode === exports.EModalMode.FULL ? '80%' : 'calc(520px - 100px)';
}, function (_a) {
    var mode = _a.mode;
    return mode === exports.EModalMode.FULL
        ? "\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\tmargin-top: 80px;\n\t\t\t\t\tmargin-bottom: 60px;\n\t\t\t\t\tmax-height: calc(100vh - 120px);\n\t\t\t\t\t"
        : "\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\tpadding: 65px 50px 20px 50px;\n\t\t\t\t\tmax-height: calc(100vh - 65px);\n\t\t\t\t";
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xxl;
});
var ModalHeader = styled__default["default"].div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 40px 24px 24px 24px;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 40px 24px 24px 24px;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
});
var ModalHeaderText = styled__default["default"].div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-right: 40px;\n  @media (max-width: 320px) {\n    [data-type='title'] {\n      span {\n        font-size: 24px;\n        line-height: 32px;\n      }\n    }\n  }\n  @media (min-width: ", ") and (max-width: ", ") {\n    [data-type='title'] {\n      span {\n        font-size: 36px;\n        line-height: 38px;\n      }\n    }\n  }\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-right: 40px;\n  @media (max-width: 320px) {\n    [data-type='title'] {\n      span {\n        font-size: 24px;\n        line-height: 32px;\n      }\n    }\n  }\n  @media (min-width: ", ") and (max-width: ", ") {\n    [data-type='title'] {\n      span {\n        font-size: 36px;\n        line-height: 38px;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
});
var ModalHeaderClose = styled__default["default"].div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  background-color: ", ";\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  [role='button'] {\n    transform: translateX(50%) translateY(-25%);\n  }\n  @media (min-width: ", ") {\n    position: absolute;\n    [role='button'] {\n      transform: translateX(0%) translateY(0%);\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  background-color: ", ";\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  [role='button'] {\n    transform: translateX(50%) translateY(-25%);\n  }\n  @media (min-width: ", ") {\n    position: absolute;\n    [role='button'] {\n      transform: translateX(0%) translateY(0%);\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
});
var ModalBody = styled__default["default"].div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  width: 100%;\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n  box-sizing: border-box;\n"], ["\n  width: 100%;\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n  box-sizing: border-box;\n"])));
var ModalFooter = styled__default["default"].div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 16px;\n  background-color: ", ";\n  padding: 16px 24px 24px 24px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 16px;\n  background-color: ", ";\n  padding: 16px 24px 24px 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var templateObject_1$h, templateObject_2$3, templateObject_3$3, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2;

var Modal = function (_a) {
    var children = _a.children, title = _a.title, subTitle = _a.subTitle, _b = _a.primaryAction, primaryAction = _b === void 0 ? function () { } : _b, primaryActionLabel = _a.primaryActionLabel, _c = _a.secondaryAction, secondaryAction = _c === void 0 ? function () { } : _c, secondaryActionLabel = _a.secondaryActionLabel, hasCancelButton = _a.hasCancelButton, closeModalAction = _a.closeModalAction, _d = _a.mode, mode = _d === void 0 ? exports.EModalMode.FULL : _d, args = __rest(_a, ["children", "title", "subTitle", "primaryAction", "primaryActionLabel", "secondaryAction", "secondaryActionLabel", "hasCancelButton", "closeModalAction", "mode"]);
    var shouldRenderFooter = primaryActionLabel || secondaryActionLabel;
    // Animation controls
    var controlOverlayAnimation = useAnimation();
    var controlContentAnimation = useAnimation();
    // Animation Transition
    var allAnimationTransition = {
        duration: 0.2,
        type: 'spring',
        bounce: 0,
    };
    // Effects
    React__default["default"].useEffect(function () {
        controlOverlayAnimation.start('visible');
        controlContentAnimation.start('visible');
        return function () { };
    }, [controlOverlayAnimation, controlContentAnimation]);
    // Handlers
    var closeModal = function (customAction) {
        controlContentAnimation.start('hidden');
        controlOverlayAnimation.start('hidden');
        setTimeout(function () {
            closeModalAction();
            customAction && customAction();
        }, 400);
    };
    return (jsxRuntime.jsxs(ModalWrapper, __assign({}, args, { children: [jsxRuntime.jsx(ModalOverlay, { initial: 'hidden', animate: controlOverlayAnimation, variants: opacityAnimation, onClick: function () { return closeModal(); }, transition: allAnimationTransition }), jsxRuntime.jsxs(ModalContent, __assign({ initial: 'hidden', animate: controlContentAnimation, variants: mode === exports.EModalMode.LATERAL
                    ? showFromRightAnimation
                    : showFromBottomAnimation, transition: allAnimationTransition, mode: mode }, { children: [jsxRuntime.jsx(ModalHeaderClose, __assign({ onClick: function () { return closeModal(); } }, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.close }) })), (title || subTitle) && (jsxRuntime.jsx(ModalHeader, { children: jsxRuntime.jsxs(ModalHeaderText, { children: [subTitle && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: exports.Colors.gray500, weight: exports.EFontWeight.medium, "data-type": 'subtitle' }, { children: subTitle }))), title && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading5, weight: exports.EFontWeight.bold, "data-type": 'title' }, { children: title })))] }) })), jsxRuntime.jsx(ModalBody, { children: children }), shouldRenderFooter && (jsxRuntime.jsxs(ModalFooter, { children: [(secondaryActionLabel || hasCancelButton) && (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.outline, color: exports.Colors.darkBlue, label: hasCancelButton ? 'Cancelar' : secondaryActionLabel, onClick: function () { return closeModal(secondaryAction); } })), primaryActionLabel && (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.solid, color: exports.Colors.darkBlue, label: primaryActionLabel, onClick: function () { return closeModal(primaryAction); } }))] }))] }))] })));
};

/**
 * Components
 */
var TabListWrapper = styled__default["default"].div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  /* border-bottom: 1px solid ", "; */\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  /* border-bottom: 1px solid ", "; */\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var templateObject_1$g;

var uniqid = require('uniqid');
var TabList = function (_a) {
    var tabs = _a.tabs, onSelectTab = _a.onSelectTab, args = __rest(_a, ["tabs", "onSelectTab"]);
    var _b = React.useState(), currentTab = _b[0], setCurrentTab = _b[1];
    if (!tabs) {
        return jsxRuntime.jsx(Text, { children: "N\u00E3o h\u00E1 Tabs disponiveis" });
    }
    var onTabClick = function (tab) {
        setCurrentTab(tab.name);
        onSelectTab(tab.name);
    };
    return (jsxRuntime.jsx(TabListWrapper, __assign({}, args, { children: tabs.map(function (item) { return (jsxRuntime.jsx(Tab, { onClick: function () { return onTabClick(item); }, name: item.name, label: item.label, selected: (currentTab || tabs[0].name) === item.name }, uniqid())); }) })));
};

var CheckBox = React__default["default"].forwardRef(function (_a, inRef) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, label = _a.label, _c = _a.isChecked, isChecked = _c === void 0 ? false : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, errorMessage = _a.errorMessage, _e = _a.hasHelp, hasHelp = _e === void 0 ? false : _e, helpMessage = _a.helpMessage, onClick = _a.onClick, dark = _a.dark, _f = _a.disable, disable = _f === void 0 ? false : _f, children = _a.children, _g = _a.color, color = _g === void 0 ? exports.Colors.darkBlue : _g, args = __rest(_a, ["name", "label", "isChecked", "hasError", "errorMessage", "hasHelp", "helpMessage", "onClick", "dark", "disable", "children", "color"]);
    // States
    var _h = React__default["default"].useState(isChecked), checked = _h[0], setChecked = _h[1];
    // Refs
    var ref = React__default["default"].useRef(null);
    React__default["default"].useImperativeHandle(inRef, function () { return ref.current; }, [ref]);
    // handle
    var handleCheck = function (check) {
        var _a;
        if (disable)
            return;
        setChecked(check);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsxs(CheckBoxWrapper, __assign({ onClick: function () { return handleCheck(!checked); } }, { children: [jsxRuntime.jsx(CheckBoxCheck, __assign({ isChecked: checked, dark: dark, disable: disable }, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.done, color: exports.Colors.light, size: exports.EIconSize.small }) })), jsxRuntime.jsxs(CheckBoxLabel, { children: [jsxRuntime.jsxs("div", __assign({ className: 'label' }, { children: [label && !children && (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.bold, color: dark ? exports.Colors.light : color }, { children: label }))), children] })), (hasError && errorMessage) || (hasHelp && helpMessage) ? (jsxRuntime.jsx(CheckHelpWrapper, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, color: hasError ? exports.Colors.red : color, weight: exports.EFontWeight.medium, onClick: onClick, style: {
                                        opacity: disable ? 0.5 : 1,
                                    } }, { children: hasError ? errorMessage : helpMessage })) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })] })), jsxRuntime.jsx("input", __assign({ name: name, type: 'checkbox', id: name, style: { display: 'none' }, defaultChecked: checked, ref: ref }, args))] }));
});

/**
 * Components
 */
var InputBlocksWrapper = styled__default["default"].div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  position: relative;\n  flex: 1;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 24px;\n  position: relative;\n  flex: 1;\n"])));
var InputBlockInputsContainer = styled__default["default"].div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  /* flex-wrap: wrap; */\n  /* width: fit-content; */\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  /* flex-wrap: wrap; */\n  /* width: fit-content; */\n"])));
var InputWrapper = styled__default["default"].div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var templateObject_1$f, templateObject_2$2, templateObject_3$2;

var InputBlocks = function (_a) {
    var label = _a.label, size = _a.size, hasError = _a.hasError, errorMessage = _a.errorMessage, hasHelp = _a.hasHelp, helpMessage = _a.helpMessage, onFillComplete = _a.onFillComplete, isDisabled = _a.isDisabled, dark = _a.dark, args = __rest(_a, ["label", "size", "hasError", "errorMessage", "hasHelp", "helpMessage", "onFillComplete", "isDisabled", "dark"]);
    // States
    var _b = React__default["default"].useState([]), values = _b[0], setValues = _b[1];
    var _c = React__default["default"].useState(1), position = _c[0], setPosition = _c[1];
    // Create input block list
    var inputBlockSize = Array.apply(null, Array(size));
    // handlers
    /**
     * Find the next dom element
     * @param i : index to find the input element
     * @returns
     */
    var getNextInputElement = function (i) {
        return document.querySelector("input[name=vox-input-block-".concat(i, "]"));
    };
    /**
     * Update values
     * @param direction : Determine if go to the right or left;
     * @param value : is the value to setup
     * @param e : HTMLInputElement
     */
    var updateValues = function (direction, value, e) {
        var newValues = __spreadArray([], values, true);
        if (direction === 'right' && position) {
            newValues.splice(position - 1, 1, value);
        }
        else if (direction === 'left' && position) {
            newValues.splice(position - 1, 1);
        }
        setValues(newValues);
        e && e.select();
    };
    /**
     * Event to check input changes
     * @param e : HTMLInputElement
     */
    var handleInputChange = function (e) {
        var _a = e.target, maxLength = _a.maxLength, value = _a.value;
        // Next input logic
        if (value === undefined || value === '' || value === null) {
            updateValues('left', null, getNextInputElement(position - 1));
        }
        else if (regexForOnlyOneNumber(value) &&
            value.length === maxLength &&
            position <= size) {
            updateValues('right', value, getNextInputElement(position + 1));
        }
        else {
            e.target.value = e.target.value.slice(0, -1);
        }
    };
    /**
     * Event to check backspace event
     * @param e : HTMLInputElement
     */
    var onKeyUp = function (e) {
        if (e.key === 'Backspace' && values.length < position) {
            var nextfield = getNextInputElement(position - 1);
            nextfield && nextfield.select();
        }
    };
    // Effects
    React__default["default"].useEffect(function () {
        if (onFillComplete) {
            var fullValue = values.join('');
            onFillComplete(fullValue);
        }
        return function () { };
    }, [values, onFillComplete, size]);
    React__default["default"].useEffect(function () {
        if (hasError) {
            var nextfield = getNextInputElement(1);
            nextfield && nextfield.select();
        }
    }, [hasError]);
    return (jsxRuntime.jsxs(InputBlocksWrapper, __assign({}, args, { children: [jsxRuntime.jsx(InputLabelWrapper$1, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: dark ? exports.Colors.light : exports.Colors.darkBlue }, { children: label })) }), jsxRuntime.jsx(InputBlockInputsContainer, { children: inputBlockSize.map(function (_v, i) {
                    var keyIndex = i + 1;
                    var keyName = "vox-input-block-".concat(keyIndex);
                    return (jsxRuntime.jsx(InputWrapper, { children: jsxRuntime.jsx(InputField$1, { disabled: isDisabled, hasError: hasError, name: keyName, type: 'number', textAlign: 'center', maxLength: 1, minLength: 1, onFocus: function (e) {
                                e.target.select();
                                setPosition(keyIndex);
                            }, onChange: handleInputChange, onKeyUp: onKeyUp, tabIndex: keyIndex, dark: dark }) }, keyName));
                }) }), (hasError && errorMessage) || (hasHelp && helpMessage) ? (jsxRuntime.jsx(InputHelpWrapper$1, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm, color: hasError ? exports.Colors.red : dark ? exports.Colors.cyan : exports.Colors.gray800, weight: exports.EFontWeight.regular }, { children: hasError ? errorMessage : helpMessage })) })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })));
};

/**
 * Components
 */
var DataFundWrapper = styled__default["default"].div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  /* min-height: 56px; */\n  background-color: ", ";\n  border-radius: 2px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  display: flex;\n  flex-direction: row;\n  padding: 12px 24px;\n  cursor: ", ";\n  :hover {\n    background-color: ", ";\n  }\n  .row {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    @media (min-width: ", ") {\n      align-items: center;\n      display: flex;\n      flex-direction: row;\n      gap: 0;\n    }\n    .percent {\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 96px;\n      }\n    }\n    .fund {\n      width: 100%;\n      @media (min-width: ", ") {\n        width: calc(45% - 96px);\n      }\n    }\n    .tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 30%;\n      }\n    }\n    .ods {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 25%;\n      }\n    }\n  }\n"], ["\n  /* min-height: 56px; */\n  background-color: ", ";\n  border-radius: 2px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: ", ";\n  display: flex;\n  flex-direction: row;\n  padding: 12px 24px;\n  cursor: ", ";\n  :hover {\n    background-color: ", ";\n  }\n  .row {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    @media (min-width: ", ") {\n      align-items: center;\n      display: flex;\n      flex-direction: row;\n      gap: 0;\n    }\n    .percent {\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 96px;\n      }\n    }\n    .fund {\n      width: 100%;\n      @media (min-width: ", ") {\n        width: calc(45% - 96px);\n      }\n    }\n    .tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 30%;\n      }\n    }\n    .ods {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      width: 100%;\n      @media (min-width: ", ") {\n        width: 25%;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var hasAction = _a.hasAction;
    return (hasAction ? 'pointer' : 'default');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray100;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$e;

var DataFund = function (_a) {
    var percent = _a.percent, fundName = _a.fundName, _b = _a.tags, tags = _b === void 0 ? [] : _b, _c = _a.ods, ods = _c === void 0 ? [] : _c, onClick = _a.onClick, args = __rest(_a, ["percent", "fundName", "tags", "ods", "onClick"]);
    return (jsxRuntime.jsx(DataFundWrapper, __assign({}, args, { hasAction: !!onClick }, { children: jsxRuntime.jsxs("div", __assign({ className: 'row', onClick: function () { return (onClick ? onClick() : {}); } }, { children: [jsxRuntime.jsx("div", __assign({ className: 'percent data' }, { children: jsxRuntime.jsxs(Text, __assign({ preset: exports.TextSizes.bodyMd, color: exports.Colors.pink800, weight: exports.EFontWeight.bold }, { children: [percent, "%"] })) })), jsxRuntime.jsx("div", __assign({ className: 'fund data' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, weight: exports.EFontWeight.medium }, { children: fundName })) })), tags.length ? (jsxRuntime.jsx("div", __assign({ className: 'tags data' }, { children: tags.map(function (tag) { return (jsxRuntime.jsx(Tag, { label: tag }, "".concat(tag.trim()))); }) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), ods.length ? (jsxRuntime.jsx("div", __assign({ className: 'ods data' }, { children: ods.map(function (o) { return (jsxRuntime.jsx(Image, { src: getImageODS(o), alt: getLabelODS(o), width: 32, height: 32 }, o)); }) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}))] })) })));
};

/**
 * Components
 */
var HeaderWrapper = styled__default["default"].div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  align-items: center;\n  ul {\n    list-style: none;\n    display: flex !important;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    li {\n      position: relative;\n    }\n  }\n  .dot {\n    height: 6px;\n    width: 6px;\n    border-radius: 100%;\n  }\n  .content,\n  .list {\n    width: 90%;\n    @media (min-width: ", ") {\n      width: 85%;\n    }\n    @media (min-width: ", ") {\n      width: 75%;\n    }\n    @media (min-width: ", ") {\n      width: 1160px;\n    }\n  }\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    @media (min-width: ", ") {\n      min-height: 512px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      padding: 4px 0;\n      .logo {\n        cursor: pointer;\n      }\n      .menu {\n        .link {\n          display: none;\n          border-radius: 4px;\n          @media (min-width: ", ") {\n            display: flex;\n            align-items: center;\n          }\n        }\n        .link.clean:after {\n          content: none;\n        }\n      }\n      .links {\n        gap: 20px;\n        display: flex;\n        li {\n          height: 100%;\n        }\n        li:not(.menu) {\n          display: none;\n          @media (min-width: ", ") {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 8px;\n          }\n        }\n        li.menu {\n          display: flex;\n          align-items: center;\n          @media (min-width: ", ") {\n            display: none;\n          }\n        }\n        .notification {\n          position: absolute;\n          background-color: ", ";\n          top: 0px;\n          right: 0px;\n        }\n        .sub-menu {\n          right: -40px;\n          top: 100%;\n          left: auto;\n          transform: translateX(0%);\n          &:after {\n            top: -10px;\n            right: 32px;\n            left: auto;\n          }\n        }\n        &.sensitive {\n          .hidden {\n            width: 110px;\n            height: 20px;\n            background-color: ", ";\n          }\n        }\n      }\n    }\n    .body {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: end;\n      padding-top: 56px;\n      padding-bottom: 24px;\n      overflow-x: hidden;\n      gap: 24px;\n      @media (min-width: ", ") {\n        flex-direction: row;\n        padding-bottom: 64px;\n        gap: 96px;\n      }\n      .user-data {\n        width: 100%;\n        @media (min-width: ", ") {\n          flex: 1.5;\n        }\n        @media (min-width: ", ") {\n          flex: 1.5;\n        }\n      }\n      .user-money {\n        margin-top: 15px;\n        width: 100%;\n        @media (min-width: ", ") {\n          margin-top: 25px;\n          margin-top: 0;\n          text-align: right;\n          flex: 1;\n        }\n        .profitability {\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          justify-content: flex-start;\n          .dot {\n            background-color: ", ";\n          }\n          /* @media (min-width: ", ") {\n            justify-content: flex-end;\n          } */\n        }\n        .total {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n        }\n        &.sensitive {\n          .hidden {\n            background-color: ", ";\n          }\n          .total {\n            display: flex;\n            flex-direction: column;\n            margin-bottom: 5px;\n            align-items: flex-end;\n            gap: 5px;\n            .hidden {\n              width: 160px;\n              height: 30px;\n              background-color: ", ";\n            }\n          }\n          .profitability {\n            .hidden {\n              width: 40px;\n              height: 10px;\n              background-color: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n  .shortcuts {\n    background-color: ", ";\n    height: 56px;\n    width: 100%;\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-color: ", ";\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    display: none;\n    @media (min-width: ", ") {\n      display: flex;\n    }\n    .list {\n      gap: 8px;\n      li {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .dot {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n  .sub-menu {\n    position: absolute;\n    background-color: ", ";\n    padding: 20px 20px 25px 20px;\n    display: flex !important;\n    flex-direction: column;\n    top: 200%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: ", "px;\n    border: 1px solid ", ";\n    z-index: 9998;\n    width: 280px;\n    gap: 25px;\n    /* &:after {\n      content: '';\n      height: 18px;\n      width: 18px;\n      background-color: #ffffff;\n      position: absolute;\n      top: -10px;\n      left: 50%;\n      transform: translateX(-50%) rotate(45deg);\n      z-index: 9999;\n      border-top-width: 1px;\n      border-top-style: solid;\n      border-top-color: ", ";\n      border-left-width: 1px;\n      border-left-style: solid;\n      border-left-color: ", ";\n    } */\n    &:before {\n      content: '';\n      height: 28px;\n      width: 100%;\n      background-color: transparent;\n      position: absolute;\n      top: -28px;\n    }\n    li {\n      width: 100%;\n      .title {\n        span:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n    .item {\n      display: flex;\n      gap: 10px;\n      flex: 1;\n      .icon {\n      }\n      .data {\n        .title {\n          margin-bottom: 5px;\n          display: flex;\n          align-items: center;\n          &:after {\n            content: '';\n            height: 8px;\n            width: 8px;\n            /* transform: rotate(45deg) translateX(4px) translateY(-4px);\n            border-top-width: 1px;\n            border-top-style: solid;\n            border-top-color: ", ";\n            border-right-width: 1px;\n            border-right-style: solid;\n            border-right-color: ", "; */\n          }\n        }\n        .desc {\n        }\n        .shorts {\n          margin-top: 20px;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 15px;\n          li {\n          }\n        }\n      }\n    }\n  }\n  .menu-modal {\n    display: flex;\n    flex-direction: column;\n    /* gap: 25px; */\n    .header {\n      margin-bottom: 10px;\n    }\n    .body {\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  align-items: center;\n  ul {\n    list-style: none;\n    display: flex !important;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    li {\n      position: relative;\n    }\n  }\n  .dot {\n    height: 6px;\n    width: 6px;\n    border-radius: 100%;\n  }\n  .content,\n  .list {\n    width: 90%;\n    @media (min-width: ", ") {\n      width: 85%;\n    }\n    @media (min-width: ", ") {\n      width: 75%;\n    }\n    @media (min-width: ", ") {\n      width: 1160px;\n    }\n  }\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    @media (min-width: ", ") {\n      min-height: 512px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      padding: 4px 0;\n      .logo {\n        cursor: pointer;\n      }\n      .menu {\n        .link {\n          display: none;\n          border-radius: 4px;\n          @media (min-width: ", ") {\n            display: flex;\n            align-items: center;\n          }\n        }\n        .link.clean:after {\n          content: none;\n        }\n      }\n      .links {\n        gap: 20px;\n        display: flex;\n        li {\n          height: 100%;\n        }\n        li:not(.menu) {\n          display: none;\n          @media (min-width: ", ") {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 8px;\n          }\n        }\n        li.menu {\n          display: flex;\n          align-items: center;\n          @media (min-width: ", ") {\n            display: none;\n          }\n        }\n        .notification {\n          position: absolute;\n          background-color: ", ";\n          top: 0px;\n          right: 0px;\n        }\n        .sub-menu {\n          right: -40px;\n          top: 100%;\n          left: auto;\n          transform: translateX(0%);\n          &:after {\n            top: -10px;\n            right: 32px;\n            left: auto;\n          }\n        }\n        &.sensitive {\n          .hidden {\n            width: 110px;\n            height: 20px;\n            background-color: ", ";\n          }\n        }\n      }\n    }\n    .body {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-items: end;\n      padding-top: 56px;\n      padding-bottom: 24px;\n      overflow-x: hidden;\n      gap: 24px;\n      @media (min-width: ", ") {\n        flex-direction: row;\n        padding-bottom: 64px;\n        gap: 96px;\n      }\n      .user-data {\n        width: 100%;\n        @media (min-width: ", ") {\n          flex: 1.5;\n        }\n        @media (min-width: ", ") {\n          flex: 1.5;\n        }\n      }\n      .user-money {\n        margin-top: 15px;\n        width: 100%;\n        @media (min-width: ", ") {\n          margin-top: 25px;\n          margin-top: 0;\n          text-align: right;\n          flex: 1;\n        }\n        .profitability {\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          justify-content: flex-start;\n          .dot {\n            background-color: ", ";\n          }\n          /* @media (min-width: ", ") {\n            justify-content: flex-end;\n          } */\n        }\n        .total {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n        }\n        &.sensitive {\n          .hidden {\n            background-color: ", ";\n          }\n          .total {\n            display: flex;\n            flex-direction: column;\n            margin-bottom: 5px;\n            align-items: flex-end;\n            gap: 5px;\n            .hidden {\n              width: 160px;\n              height: 30px;\n              background-color: ", ";\n            }\n          }\n          .profitability {\n            .hidden {\n              width: 40px;\n              height: 10px;\n              background-color: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n  .shortcuts {\n    background-color: ", ";\n    height: 56px;\n    width: 100%;\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-color: ", ";\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    display: none;\n    @media (min-width: ", ") {\n      display: flex;\n    }\n    .list {\n      gap: 8px;\n      li {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .dot {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n  .sub-menu {\n    position: absolute;\n    background-color: ", ";\n    padding: 20px 20px 25px 20px;\n    display: flex !important;\n    flex-direction: column;\n    top: 200%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: ", "px;\n    border: 1px solid ", ";\n    z-index: 9998;\n    width: 280px;\n    gap: 25px;\n    /* &:after {\n      content: '';\n      height: 18px;\n      width: 18px;\n      background-color: #ffffff;\n      position: absolute;\n      top: -10px;\n      left: 50%;\n      transform: translateX(-50%) rotate(45deg);\n      z-index: 9999;\n      border-top-width: 1px;\n      border-top-style: solid;\n      border-top-color: ", ";\n      border-left-width: 1px;\n      border-left-style: solid;\n      border-left-color: ", ";\n    } */\n    &:before {\n      content: '';\n      height: 28px;\n      width: 100%;\n      background-color: transparent;\n      position: absolute;\n      top: -28px;\n    }\n    li {\n      width: 100%;\n      .title {\n        span:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n    .item {\n      display: flex;\n      gap: 10px;\n      flex: 1;\n      .icon {\n      }\n      .data {\n        .title {\n          margin-bottom: 5px;\n          display: flex;\n          align-items: center;\n          &:after {\n            content: '';\n            height: 8px;\n            width: 8px;\n            /* transform: rotate(45deg) translateX(4px) translateY(-4px);\n            border-top-width: 1px;\n            border-top-style: solid;\n            border-top-color: ", ";\n            border-right-width: 1px;\n            border-right-style: solid;\n            border-right-color: ", "; */\n          }\n        }\n        .desc {\n        }\n        .shorts {\n          margin-top: 20px;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 15px;\n          li {\n          }\n        }\n      }\n    }\n  }\n  .menu-modal {\n    display: flex;\n    flex-direction: column;\n    /* gap: 25px; */\n    .header {\n      margin-bottom: 10px;\n    }\n    .body {\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xxl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.cyan;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray800;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius.card;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
});
var templateObject_1$d;

var Header = function (_a) {
    var menu = _a.menu, links = _a.links, profitability = _a.profitability, message = _a.message, shortcuts = _a.shortcuts, _b = _a.status, status = _b === void 0 ? 'NORMAL' : _b, sensitiveContent = _a.sensitiveContent, showMiniProfitability = _a.showMiniProfitability, _c = _a.onLogoClick, onLogoClick = _c === void 0 ? function () { } : _c, currentMenuItem = _a.currentMenuItem, args = __rest(_a, ["menu", "links", "profitability", "message", "shortcuts", "status", "sensitiveContent", "showMiniProfitability", "onLogoClick", "currentMenuItem"]);
    var headerRef = React__default["default"].useRef(null);
    // const [submenu, setSubmenu] = React.useState<any>(null);
    var _d = React__default["default"].useState(false), vertical = _d[0], setVertical = _d[1];
    var showVerticalMenu = function () { return setVertical(!vertical); };
    // TODO: Automatizar modo compact do header com scroll
    return (jsxRuntime.jsxs(HeaderWrapper, __assign({}, args, { ref: headerRef }, { children: [jsxRuntime.jsxs(LayoutContainer, { children: [jsxRuntime.jsxs(motion.div, __assign({ className: 'content', id: 'content', initial: 'large', animate: status === 'NORMAL' ? '' : 'compact', transition: {
                            type: 'spring',
                            stiffness: 700,
                            damping: 50,
                        }, variants: {
                            compact: {
                                height: 52,
                            },
                        } }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'header' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'logo', onClick: onLogoClick }, { children: jsxRuntime.jsx(Image, { src: 'https://frontend-assets-voxri.s3.sa-east-1.amazonaws.com/vox-pink.png', width: status === 'NORMAL' ? 120 : 100 }) })), jsxRuntime.jsx("ul", __assign({ className: 'links' }, { children: jsxRuntime.jsx("li", __assign({ className: 'menu', onClick: function () { return showVerticalMenu(); } }, { children: jsxRuntime.jsx(Button, { label: '', onClick: function () { return showVerticalMenu(); }, preset: exports.EButtonPreset.link, color: exports.Colors.light, rightAddon: exports.Icons.menu }) })) }))] })), jsxRuntime.jsxs(motion.div, __assign({ className: 'body', initial: 'large', animate: status === 'NORMAL' ? 'large' : 'compact', exit: 'exit', variants: {
                                    large: {
                                        display: 'flex',
                                        opacity: 1,
                                    },
                                    compact: {
                                        display: 'none',
                                        opacity: 0,
                                    },
                                    exit: {
                                        opacity: 0,
                                    },
                                } }, { children: [jsxRuntime.jsx("div", __assign({ className: 'user-data' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading1, color: exports.Colors.pink800, weight: exports.EFontWeight.medium }, { children: message })) })), profitability && profitability.total && !showMiniProfitability ? (jsxRuntime.jsxs("div", __assign({ className: "user-money ".concat(sensitiveContent ? 'sensitive' : '') }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'total' }, { children: [jsxRuntime.jsx(Text, __assign({ color: exports.Colors.gray500, weight: exports.EFontWeight.medium, preset: exports.TextSizes.bodyMd }, { children: "Patrim\u00F4nio" })), sensitiveContent ? (jsxRuntime.jsx("span", { className: 'hidden' })) : (jsxRuntime.jsx("div", __assign({ className: 'profitability' }, { children: jsxRuntime.jsx(Text, __assign({ color: exports.Colors.light, preset: exports.TextSizes.heading4, weight: exports.EFontWeight.bold }, { children: profitability.total })) })))] })), jsxRuntime.jsxs("div", __assign({ className: 'profitability' }, { children: [profitability.gained && !sensitiveContent ? (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading5, weight: exports.EFontWeight.medium, color: profitability.status === 'POSITIVE'
                                                            ? exports.Colors.cyan
                                                            : exports.Colors.red }, { children: profitability.gained }))) : (jsxRuntime.jsx("span", { className: 'hidden' })), profitability.percent && (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("span", { className: 'dot', style: {
                                                                    backgroundColor: exports.Colors.gray500,
                                                                } }), sensitiveContent ? (jsxRuntime.jsx("span", { className: 'hidden' })) : (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading5, weight: exports.EFontWeight.medium, color: profitability.status === 'POSITIVE'
                                                                    ? exports.Colors.cyan
                                                                    : exports.Colors.red }, { children: profitability.percent })))] }))] }))] }))) : (jsxRuntime.jsx("div", { className: 'user-money' }))] }))] })), vertical && (jsxRuntime.jsx(Modal, __assign({ title: 'Seu menu de navega\u00E7\u00E3o', subTitle: 'VOX Capital', closeModalAction: showVerticalMenu }, { children: jsxRuntime.jsxs("div", __assign({ className: 'menu-modal' }, { children: [jsxRuntime.jsx(Menu, { itens: menu.map(function (_a) {
                                        var name = _a.name, label = _a.label, onClick = _a.onClick, icon = _a.icon;
                                        return ({
                                            name: name,
                                            label: label,
                                            onClick: onClick ? onClick : function () { },
                                            leftIcon: icon,
                                            selected: name === currentMenuItem,
                                        });
                                    }), onClickItem: function () { } }), links.map(function (m) {
                                    return m.submenu ? (jsxRuntime.jsx("div", { children: jsxRuntime.jsx("div", __assign({ className: 'body' }, { children: jsxRuntime.jsx(Menu, { itens: m.submenu.map(function (_a) {
                                                    var name = _a.name, label = _a.label, onClick = _a.onClick, icon = _a.icon;
                                                    return ({
                                                        name: name,
                                                        label: label,
                                                        onClick: onClick,
                                                        leftIcon: icon,
                                                    });
                                                }), onClickItem: function () { } }) })) }, m.name)) : (jsxRuntime.jsx(jsxRuntime.Fragment, {}));
                                })] })) })))] }), shortcuts && (jsxRuntime.jsx(motion.div, __assign({ className: 'shortcuts' }, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsx("ul", __assign({ className: 'list' }, { children: menu.map(function (m) { return (jsxRuntime.jsx("li", __assign({ id: m.name, className: "link ".concat(!m.submenu ? 'clean' : '') }, { children: jsxRuntime.jsx(Button, { label: m.label, onClick: m.submenu || !m.onClick ? function () { } : m.onClick, preset: exports.EButtonPreset.link, color: m.name === currentMenuItem
                                    ? exports.Colors.darkBlue200
                                    : exports.Colors.dark100, underline: m.name === currentMenuItem, rightAddon: m.submenu ? exports.Icons.expand_more : m.icon }) }), m.name)); }) })) }) })))] })));
};

/**
 * Components
 */
var HeaderHomeWrapper = styled__default["default"].div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .home-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding-bottom: 40px;\n    @media (min-width: ", ") {\n      gap: 72px;\n      padding-bottom: 96px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        align-items: center;\n        gap: 0;\n        @media (min-width: ", ") {\n          gap: 16px;\n        }\n        .language {\n          text-align: center;\n          .icon {\n            height: 24px;\n          }\n          .text {\n            display: none;\n            @media (min-width: ", ") {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 32px;\n      @media (min-width: ", ") {\n        gap: 72px;\n        flex-direction: row;\n      }\n      .title {\n        flex: 1;\n      }\n      .data {\n        flex: 1;\n        margin-top: 0px;\n        @media (min-width: ", ") {\n          margin-top: 56px;\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n          .meta {\n            display: flex;\n            gap: 16px;\n          }\n        }\n        .actions {\n          margin-top: 40px;\n        }\n      }\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .home-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding-bottom: 40px;\n    @media (min-width: ", ") {\n      gap: 72px;\n      padding-bottom: 96px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        align-items: center;\n        gap: 0;\n        @media (min-width: ", ") {\n          gap: 16px;\n        }\n        .language {\n          text-align: center;\n          .icon {\n            height: 24px;\n          }\n          .text {\n            display: none;\n            @media (min-width: ", ") {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 32px;\n      @media (min-width: ", ") {\n        gap: 72px;\n        flex-direction: row;\n      }\n      .title {\n        flex: 1;\n      }\n      .data {\n        flex: 1;\n        margin-top: 0px;\n        @media (min-width: ", ") {\n          margin-top: 56px;\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n          .meta {\n            display: flex;\n            gap: 16px;\n          }\n        }\n        .actions {\n          margin-top: 40px;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
});
var templateObject_1$c;

var HeaderHome = function (_a) {
    var logo = _a.logo, language = _a.language, languageAction = _a.languageAction, title = _a.title, description = _a.description, owner = _a.owner, date = _a.date, _b = _a.action, label = _b.label, onClick = _b.onClick, args = __rest(_a, ["logo", "language", "languageAction", "title", "description", "owner", "date", "action"]);
    return (jsxRuntime.jsx(HeaderHomeWrapper, __assign({}, args, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'home-container' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'header' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'logo' }, { children: jsxRuntime.jsx(Image, { src: logo, width: 120 }) })), jsxRuntime.jsxs("div", __assign({ className: 'actions' }, { children: [jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.link, color: exports.Colors.light, label: label, onClick: onClick, rightAddon: exports.Icons.north_east }), languageAction && language && (jsxRuntime.jsxs("div", __assign({ className: 'language hover:cursor-pointer', onClick: languageAction }, { children: [jsxRuntime.jsx("div", __assign({ className: 'icon' }, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.language, color: exports.Colors.light }) })), jsxRuntime.jsx("div", __assign({ className: 'text' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.caption, weight: exports.EFontWeight.bold, color: exports.Colors.light }, { children: language })) }))] })))] }))] })), jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'title' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading, color: exports.Colors.pink800, weight: exports.EFontWeight.medium }, { children: title })) })), jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'description' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4, color: exports.Colors.light }, { children: description })), jsxRuntime.jsxs("div", __assign({ className: 'meta' }, { children: [jsxRuntime.jsx(Text, __assign({ color: exports.Colors.light }, { children: owner })), jsxRuntime.jsx(Text, __assign({ color: exports.Colors.light }, { children: date }))] }))] })), jsxRuntime.jsx("div", __assign({ className: 'actions' }, { children: jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.outline, color: exports.Colors.light, label: label, onClick: onClick }) }))] }))] }))] })) }) })));
};

/**
 * Components
 */
var HeaderNavigationWrapper = styled__default["default"].div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .nav-container {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding-bottom: 4px;\n    .back {\n    }\n    .options {\n      display: flex;\n      gap: 4px;\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .nav-container {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding-bottom: 4px;\n    .back {\n    }\n    .options {\n      display: flex;\n      gap: 4px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.light;
});
var templateObject_1$b;

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

var HeaderNavigation = function (_a) {
    var backOption = _a.backOption, _b = _a.otherOtions, otherOtions = _b === void 0 ? [] : _b, args = __rest(_a, ["backOption", "otherOtions"]);
    return (jsxRuntime.jsx(HeaderNavigationWrapper, __assign({}, args, { children: jsxRuntime.jsx(LayoutContainer, __assign({ padding: false }, { children: jsxRuntime.jsxs("div", __assign({ className: 'nav-container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'back' }, { children: backOption ? (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.link, leftAddon: backOption.icon || exports.Icons.arrow_back, label: backOption.label, responsive: true, onClick: backOption.onClick, color: exports.Colors.darkBlue })) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})) })), otherOtions.length ? (jsxRuntime.jsx("div", __assign({ className: 'options' }, { children: otherOtions.map(function (option) { return (jsxRuntime.jsx(Button, { preset: exports.EButtonPreset.link, rightAddon: option.icon, label: option.label, onClick: option.onClick, color: exports.Colors.darkBlue, responsive: !!option.responsive, actionName: option.actionName }, v4())); }) }))) : null] })) })) })));
};

/**
 * Components
 */
var HeaderSectionWrapper = styled__default["default"].div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 72px;\n    @media (min-width: ", ") {\n      min-height: 512px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        gap: 0;\n        .language {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 4px;\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      padding-bottom: 64px;\n      .data {\n        display: flex;\n        flex-direction: column-reverse;\n        align-items: start;\n        gap: 16px;\n        @media (min-width: ", ") {\n          gap: 72px;\n          display: flex;\n          flex-direction: row;\n          align-items: end;\n        }\n        .title {\n          flex: 1.5;\n        }\n        .description {\n          flex: 1;\n        }\n      }\n      .meta {\n        display: flex;\n        gap: 16px;\n      }\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 72px;\n    @media (min-width: ", ") {\n      min-height: 512px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        gap: 0;\n        .language {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 4px;\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      padding-bottom: 64px;\n      .data {\n        display: flex;\n        flex-direction: column-reverse;\n        align-items: start;\n        gap: 16px;\n        @media (min-width: ", ") {\n          gap: 72px;\n          display: flex;\n          flex-direction: row;\n          align-items: end;\n        }\n        .title {\n          flex: 1.5;\n        }\n        .description {\n          flex: 1;\n        }\n      }\n      .meta {\n        display: flex;\n        gap: 16px;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, dark = _a.dark;
    return dark ? theme.colors.darkBlue : theme.colors.pink400;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
});
var templateObject_1$a;

var HeaderSection = function (_a) {
    var logo = _a.logo, title = _a.title, description = _a.description, owner = _a.owner, section = _a.section, _b = _a.dark, dark = _b === void 0 ? false : _b, args = __rest(_a, ["logo", "title", "description", "owner", "section", "dark"]);
    return (jsxRuntime.jsx(HeaderSectionWrapper, __assign({ dark: dark }, args, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'header' }, { children: jsxRuntime.jsx("div", __assign({ className: 'logo' }, { children: jsxRuntime.jsx(Image, { src: logo, width: 120 }) })) })), jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'title' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading1, color: dark ? exports.Colors.pink800 : exports.Colors.darkBlue, weight: exports.EFontWeight.medium }, { children: title })) })), jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4, color: dark ? exports.Colors.light : exports.Colors.pink800, weight: exports.EFontWeight.medium }, { children: description })) }))] })), jsxRuntime.jsxs("div", __assign({ className: 'meta' }, { children: [jsxRuntime.jsx(Text, __assign({ color: dark ? exports.Colors.pink400 : exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: owner })), jsxRuntime.jsx(Text, __assign({ color: dark ? exports.Colors.pink400 : exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: section }))] }))] }))] })) }) })));
};

/**
 * Components
 */
var HeaderSectionFlowWrapper = styled__default["default"].div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .home-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    /* padding-top: 24px; */\n    padding-bottom: 40px;\n    @media (min-width: ", ") {\n      gap: 72px;\n      padding-bottom: 96px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        gap: 0;\n        @media (min-width: ", ") {\n          gap: 16px;\n        }\n        .language {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 4px;\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 32px;\n      @media (min-width: ", ") {\n        gap: 72px;\n        flex-direction: row;\n      }\n      .title {\n        flex: 1;\n        flex-direction: column;\n        gap: 24px;\n        @media (min-width: ", ") {\n          gap: 40px;\n        }\n      }\n      .data {\n        flex: 1;\n        margin-top: 0px;\n        @media (min-width: ", ") {\n          margin-top: 56px;\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n          .meta {\n            display: flex;\n            gap: 16px;\n          }\n        }\n        .actions {\n          margin-top: 40px;\n        }\n      }\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .home-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    /* padding-top: 24px; */\n    padding-bottom: 40px;\n    @media (min-width: ", ") {\n      gap: 72px;\n      padding-bottom: 96px;\n    }\n    .header {\n      display: flex;\n      justify-content: space-between;\n      height: 72px;\n      align-items: center;\n      .actions {\n        display: flex;\n        gap: 0;\n        @media (min-width: ", ") {\n          gap: 16px;\n        }\n        .language {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 4px;\n        }\n      }\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 32px;\n      @media (min-width: ", ") {\n        gap: 72px;\n        flex-direction: row;\n      }\n      .title {\n        flex: 1;\n        flex-direction: column;\n        gap: 24px;\n        @media (min-width: ", ") {\n          gap: 40px;\n        }\n      }\n      .data {\n        flex: 1;\n        margin-top: 0px;\n        @media (min-width: ", ") {\n          margin-top: 56px;\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          gap: 24px;\n          .meta {\n            display: flex;\n            gap: 16px;\n          }\n        }\n        .actions {\n          margin-top: 40px;\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
});
var templateObject_1$9;

var HeaderSectionFlow = function (_a) {
    var logo = _a.logo, title = _a.title, owner = _a.owner, _b = _a.descriptions, descriptions = _b === void 0 ? [] : _b, args = __rest(_a, ["logo", "title", "owner", "descriptions"]);
    return (jsxRuntime.jsx(HeaderSectionFlowWrapper, __assign({}, args, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'home-container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'header' }, { children: jsxRuntime.jsx("div", __assign({ className: 'logo' }, { children: jsxRuntime.jsx(Image, { src: logo, width: 120 }) })) })), jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'title' }, { children: [jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading1, color: exports.Colors.light }, { children: title })) }), jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: exports.Colors.pink800 }, { children: owner })) })] })), jsxRuntime.jsx("div", __assign({ className: 'data' }, { children: jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: descriptions.map(function (description) { return (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, color: exports.Colors.light }, { children: description }), v4())); }) })) }))] }))] })) }) })));
};

/**
 * Components
 */
var CardDetailWrapper = styled__default["default"].div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  overflow-y: hidden;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  overflow-y: hidden;\n  position: relative;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
});
var CardDetailContainer = styled__default["default"].div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  /* display: flex;\n  flex-direction: column; */\n  overflow-y: auto;\n  height: 100%;\n  .detail-navigation {\n    height: 64px;\n  }\n  .detail-content {\n    display: flex;\n    flex-direction: column;\n    padding: 16px 32px 40px 32px;\n  }\n\n  @media (min-width: ", ") {\n    max-width: 480px;\n  }\n"], ["\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  /* display: flex;\n  flex-direction: column; */\n  overflow-y: auto;\n  height: 100%;\n  .detail-navigation {\n    height: 64px;\n  }\n  .detail-content {\n    display: flex;\n    flex-direction: column;\n    padding: 16px 32px 40px 32px;\n  }\n\n  @media (min-width: ", ") {\n    max-width: 480px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var CardDetailNavigation = styled__default["default"].div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  padding: 16px 16px 8px 16px;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  height: 48px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  padding: 16px 16px 8px 16px;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  height: 48px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
});
var CardDetailHeader = styled__default["default"].div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  margin-bottom: 24px;\n  position: relative;\n  /* width: fit-content; */\n  .subtitle:not(.compress) {\n    position: absolute;\n    top: 55%;\n    left: 24px;\n    background-color: ", ";\n    padding: 4px 8px;\n    box-sizing: border-box;\n    width: fit-content;\n    max-width: 180px;\n  }\n"], ["\n  margin-bottom: 24px;\n  position: relative;\n  /* width: fit-content; */\n  .subtitle:not(.compress) {\n    position: absolute;\n    top: 55%;\n    left: 24px;\n    background-color: ", ";\n    padding: 4px 8px;\n    box-sizing: border-box;\n    width: fit-content;\n    max-width: 180px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
});
var CardDetailBody = styled__default["default"].div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @media (min-width: ", ") {\n    overflow: hidden;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @media (min-width: ", ") {\n    overflow: hidden;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
styled__default["default"].div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject([""], [""])));
styled__default["default"].div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject([""], [""])));
styled__default["default"].div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject([""], [""])));
styled__default["default"].div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject([""], [""])));
var templateObject_1$8, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1;

var CardDetail = function (_a) {
    var _b = _a.compress, compress = _b === void 0 ? false : _b; _a.name; var subtitle = _a.subtitle, value = _a.value, action = _a.action, description = _a.description, dots = _a.dots; _a.graph; var image = _a.image, list = _a.list, closeAction = _a.closeAction, args = __rest(_a, ["compress", "name", "subtitle", "value", "action", "description", "dots", "graph", "image", "list", "closeAction"]);
    return (jsxRuntime.jsx(CardDetailWrapper, __assign({}, args, { id: 'card-detail-wrapper' }, { children: jsxRuntime.jsxs(CardDetailContainer, __assign({ id: 'card-detail-container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'detail-navigation' }, { children: jsxRuntime.jsx(CardDetailNavigation, __assign({ id: 'card-detail-navigation' }, { children: jsxRuntime.jsx(Button, { label: closeAction.label, onClick: closeAction.onClick, color: exports.Colors.light, preset: exports.EButtonPreset.solid, rightAddon: exports.Icons.chevron_right }) })) })), jsxRuntime.jsxs("div", __assign({ className: 'detail-content', id: 'card-detail-content' }, { children: [jsxRuntime.jsxs(CardDetailHeader, { children: [jsxRuntime.jsx("div", __assign({ className: 'title' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading1, weight: exports.EFontWeight.bold, color: exports.Colors.light }, { children: value })) })), jsxRuntime.jsx("div", __assign({ className: "subtitle ".concat(compress ? 'compress' : '') }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading5, weight: exports.EFontWeight.bold, color: exports.Colors.pink800 }, { children: subtitle })) }))] }), jsxRuntime.jsxs(CardDetailBody, { children: [description, list, action, dots, image] })] }))] })) })));
};

/**
 * Components
 */
var BannerWrapper = styled__default["default"].div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    padding: 64px 0;\n    .data {\n      width: 100%;\n      position: relative;\n      z-index: 1;\n      @media (min-width: ", ") {\n        max-width: 75%;\n      }\n      @media (min-width: ", ") {\n        max-width: 65%;\n      }\n      @media (min-width: ", ") {\n        max-width: 55%;\n      }\n      .title {\n        margin-bottom: 40px;\n      }\n      .content {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        .description {\n          width: 100%;\n          @media (min-width: ", ") {\n            max-width: 55%;\n          }\n        }\n        .actions {\n          display: flex;\n          flex-direction: column;\n          gap: 16px;\n          @media (min-width: ", ") {\n            flex-direction: row;\n          }\n        }\n      }\n    }\n    .image {\n      position: absolute;\n      width: 448px;\n      height: 448px;\n      right: 0;\n      top: 64px;\n      visibility: hidden;\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    padding: 64px 0;\n    .data {\n      width: 100%;\n      position: relative;\n      z-index: 1;\n      @media (min-width: ", ") {\n        max-width: 75%;\n      }\n      @media (min-width: ", ") {\n        max-width: 65%;\n      }\n      @media (min-width: ", ") {\n        max-width: 55%;\n      }\n      .title {\n        margin-bottom: 40px;\n      }\n      .content {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        .description {\n          width: 100%;\n          @media (min-width: ", ") {\n            max-width: 55%;\n          }\n        }\n        .actions {\n          display: flex;\n          flex-direction: column;\n          gap: 16px;\n          @media (min-width: ", ") {\n            flex-direction: row;\n          }\n        }\n      }\n    }\n    .image {\n      position: absolute;\n      width: 448px;\n      height: 448px;\n      right: 0;\n      top: 64px;\n      visibility: hidden;\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xxl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$7;

var Banner = function (_a) {
    var title = _a.title, description = _a.description, image = _a.image, firstAction = _a.firstAction, secondAction = _a.secondAction, args = __rest(_a, ["title", "description", "image", "firstAction", "secondAction"]);
    return (jsxRuntime.jsx(BannerWrapper, __assign({}, args, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'title' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading3, weight: exports.EFontWeight.medium }, { children: title })) })), jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: description })) })), jsxRuntime.jsxs("div", __assign({ className: 'actions' }, { children: [firstAction && (jsxRuntime.jsx(Button, { label: firstAction === null || firstAction === void 0 ? void 0 : firstAction.label, preset: exports.EButtonPreset.solid, color: exports.Colors.darkBlue, onClick: firstAction === null || firstAction === void 0 ? void 0 : firstAction.onClick })), secondAction && (jsxRuntime.jsx(Button, { label: secondAction === null || secondAction === void 0 ? void 0 : secondAction.label, preset: exports.EButtonPreset.outline, color: exports.Colors.darkBlue, onClick: secondAction === null || secondAction === void 0 ? void 0 : secondAction.onClick }))] }))] }))] })), jsxRuntime.jsx("div", __assign({ className: 'image' }, { children: jsxRuntime.jsx(Image, { src: image }) }))] })) }) })));
};

/**
 * Components
 */
var SpecialistCommentWrapper = styled__default["default"].div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    .content {\n      display: flex;\n      flex-direction: column-reverse;\n      padding-bottom: 0;\n      width: 100%;\n      @media (min-width: ", ") {\n        flex-direction: column;\n        flex-direction: row;\n        justify-content: space-between;\n        padding-bottom: 128px;\n        gap: 40px;\n      }\n      @media (min-width: ", ") {\n        width: 85%;\n        gap: 64px;\n      }\n      div {\n        box-sizing: border-box;\n      }\n      .data {\n        flex: 2;\n        gap: 16px;\n        display: flex;\n        flex-direction: column;\n        padding: 24px 0 64px 0;\n        @media (min-width: ", ") {\n          padding: 64px 0;\n        }\n      }\n      .owner {\n        flex: 1;\n        gap: 16px;\n        display: flex;\n        flex-direction: column;\n        .image,\n        .description {\n          width: 100%;\n          @media (min-width: ", ") {\n            width: 50%;\n          }\n          @media (min-width: ", ") {\n            width: 85%;\n          }\n          @media (min-width: ", ") {\n            width: 75%;\n          }\n        }\n        .image {\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          flex-direction: column;\n          justify-content: end;\n          gap: 4px;\n        }\n      }\n    }\n    .footer {\n      position: absolute;\n      height: 128px;\n      bottom: -16px;\n      right: 64px;\n      /* display: none; */\n      visibility: hidden;\n      @media (min-width: ", ") {\n        /* display: block; */\n        visibility: visible;\n      }\n    }\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  .container {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    .content {\n      display: flex;\n      flex-direction: column-reverse;\n      padding-bottom: 0;\n      width: 100%;\n      @media (min-width: ", ") {\n        flex-direction: column;\n        flex-direction: row;\n        justify-content: space-between;\n        padding-bottom: 128px;\n        gap: 40px;\n      }\n      @media (min-width: ", ") {\n        width: 85%;\n        gap: 64px;\n      }\n      div {\n        box-sizing: border-box;\n      }\n      .data {\n        flex: 2;\n        gap: 16px;\n        display: flex;\n        flex-direction: column;\n        padding: 24px 0 64px 0;\n        @media (min-width: ", ") {\n          padding: 64px 0;\n        }\n      }\n      .owner {\n        flex: 1;\n        gap: 16px;\n        display: flex;\n        flex-direction: column;\n        .image,\n        .description {\n          width: 100%;\n          @media (min-width: ", ") {\n            width: 50%;\n          }\n          @media (min-width: ", ") {\n            width: 85%;\n          }\n          @media (min-width: ", ") {\n            width: 75%;\n          }\n        }\n        .image {\n        }\n        .description {\n          display: flex;\n          flex-direction: column;\n          flex-direction: column;\n          justify-content: end;\n          gap: 4px;\n        }\n      }\n    }\n    .footer {\n      position: absolute;\n      height: 128px;\n      bottom: -16px;\n      right: 64px;\n      /* display: none; */\n      visibility: hidden;\n      @media (min-width: ", ") {\n        /* display: block; */\n        visibility: visible;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xxl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xl;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$6;

var SpecialistComment = function (_a) {
    var title = _a.title, message = _a.message, _b = _a.owner, name = _b.name, photo = _b.photo, role = _b.role, args = __rest(_a, ["title", "message", "owner"]);
    return (jsxRuntime.jsx(SpecialistCommentWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'content' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading4 }, { children: title })), jsxRuntime.jsx(Text, __assign({ color: exports.Colors.pink800, preset: exports.TextSizes.bodyLg }, { children: message }))] })), jsxRuntime.jsxs("div", __assign({ className: 'owner' }, { children: [photo && (jsxRuntime.jsx("div", __assign({ className: 'image' }, { children: jsxRuntime.jsx(Image, { src: photo }) }))), jsxRuntime.jsxs("div", __assign({ className: 'description' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd, color: exports.Colors.pink800, weight: exports.EFontWeight.bold }, { children: name })), jsxRuntime.jsx(Text, { children: role })] }))] }))] })), jsxRuntime.jsx("div", __assign({ className: 'footer' }, { children: jsxRuntime.jsx(Image, { src: ImgVoxLogoLarge }) }))] })) })));
};

/**
 * Components
 */
var ReferencesWrapper = styled__default["default"].div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n\n  hr {\n    border: 0;\n    height: 1px;\n    background: ", ";\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n  }\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 56px 0 32px 0;\n    @media (min-width: ", ") {\n      gap: 32px;\n      padding: 96px 0 32px 0;\n    }\n    .body {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      margin-bottom: 0px;\n      @media (min-width: ", ") {\n        flex-direction: row;\n        margin-bottom: 24px;\n        gap: 40px;\n      }\n      > .description {\n      }\n      > .links {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        @media (min-width: ", ") {\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          grid-template-rows: repeat(2, 1fr);\n          row-gap: 56px;\n          column-gap: 56px;\n        }\n        .link {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          a {\n            text-decoration: none;\n            :hover {\n              text-decoration: underline;\n              text-decoration-color: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n  .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: end;\n    gap: 32px;\n    padding: 32px 0;\n    @media (min-width: ", ") {\n      flex-direction: row;\n      align-items: center;\n    }\n    .data {\n      flex: 2;\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      align-items: start;\n      @media (min-width: ", ") {\n        align-items: center;\n        flex-direction: row;\n      }\n      .images {\n        display: flex;\n        gap: 16px;\n      }\n      .description {\n        flex: 1;\n      }\n    }\n    .company {\n      flex: 1;\n      text-align: end;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n\n  hr {\n    border: 0;\n    height: 1px;\n    background: ", ";\n    width: 100%;\n  }\n  @media (min-width: ", ") {\n  }\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 56px 0 32px 0;\n    @media (min-width: ", ") {\n      gap: 32px;\n      padding: 96px 0 32px 0;\n    }\n    .body {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      margin-bottom: 0px;\n      @media (min-width: ", ") {\n        flex-direction: row;\n        margin-bottom: 24px;\n        gap: 40px;\n      }\n      > .description {\n      }\n      > .links {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        @media (min-width: ", ") {\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          grid-template-rows: repeat(2, 1fr);\n          row-gap: 56px;\n          column-gap: 56px;\n        }\n        .link {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          a {\n            text-decoration: none;\n            :hover {\n              text-decoration: underline;\n              text-decoration-color: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n  .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: end;\n    gap: 32px;\n    padding: 32px 0;\n    @media (min-width: ", ") {\n      flex-direction: row;\n      align-items: center;\n    }\n    .data {\n      flex: 2;\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      align-items: start;\n      @media (min-width: ", ") {\n        align-items: center;\n        flex-direction: row;\n      }\n      .images {\n        display: flex;\n        gap: 16px;\n      }\n      .description {\n        flex: 1;\n      }\n    }\n    .company {\n      flex: 1;\n      text-align: end;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray100;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray800;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$5;

var References = function (_a) {
    var title = _a.title, description = _a.description, links = _a.links, footer = _a.footer, args = __rest(_a, ["title", "description", "links", "footer"]);
    return (jsxRuntime.jsxs(ReferencesWrapper, __assign({}, args, { children: [(title || description || links) && (jsxRuntime.jsxs(LayoutContainer, { children: [jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [title ? (jsxRuntime.jsx("div", __assign({ className: 'header' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading2 }, { children: title })) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), jsxRuntime.jsxs("div", __assign({ className: 'body' }, { children: [description ? (jsxRuntime.jsx("div", __assign({ className: 'descriptions' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: description })) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, {})), links && (jsxRuntime.jsx("div", __assign({ className: 'links' }, { children: links.map(function (e) { return (jsxRuntime.jsxs("div", __assign({ className: 'link' }, { children: [jsxRuntime.jsx(Text, __assign({ color: exports.Colors.pink800, weight: exports.EFontWeight.bold }, { children: e.label })), jsxRuntime.jsx("a", __assign({ href: e.link, target: 'blank' }, { children: jsxRuntime.jsx(Text, { children: e.description }) }))] }), v4())); }) })))] }))] })), jsxRuntime.jsx("hr", {})] })), footer && (jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'footer' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'data' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'images' }, { children: footer.images.map(function (img) { return (jsxRuntime.jsx(Image, { src: img, width: 112 }, v4())); }) })), jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body }, { children: footer.description })) }))] })), jsxRuntime.jsx("div", __assign({ className: 'company' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body }, { children: footer.company })) }))] })) }))] })));
};

/**
 * Components
 */
var FooterWrapper = styled__default["default"].div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  background-color: ", ";\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding: 56px 0 56px 0;\n  }\n  .body {\n    width: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 24px;\n    justify-content: space-between;\n    align-items: start;\n    @media (min-width: ", ") {\n      flex-direction: row;\n      gap: 96px;\n    }\n    .description {\n      flex: 2;\n    }\n    .social {\n      flex: 1;\n      display: flex;\n      justify-content: end;\n      > span {\n        cursor: pointer;\n      }\n    }\n  }\n  .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 24px;\n    @media (min-width: ", ") {\n      align-items: center;\n      flex-direction: row;\n      gap: 96px;\n    }\n    .actions {\n      display: flex;\n      flex-direction: column-reverse;\n      gap: 8px;\n      @media (min-width: ", ") {\n        align-items: center;\n        flex-direction: row;\n        gap: 24px;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  background-color: ", ";\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    padding: 56px 0 56px 0;\n  }\n  .body {\n    width: 100%;\n    display: flex;\n    flex-direction: column-reverse;\n    gap: 24px;\n    justify-content: space-between;\n    align-items: start;\n    @media (min-width: ", ") {\n      flex-direction: row;\n      gap: 96px;\n    }\n    .description {\n      flex: 2;\n    }\n    .social {\n      flex: 1;\n      display: flex;\n      justify-content: end;\n      > span {\n        cursor: pointer;\n      }\n    }\n  }\n  .footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 24px;\n    @media (min-width: ", ") {\n      align-items: center;\n      flex-direction: row;\n      gap: 96px;\n    }\n    .actions {\n      display: flex;\n      flex-direction: column-reverse;\n      gap: 8px;\n      @media (min-width: ", ") {\n        align-items: center;\n        flex-direction: row;\n        gap: 24px;\n      }\n    }\n  }\n"])), function (_a) {
    var _b = _a.color, color = _b === void 0 ? exports.Colors.gray200 : _b;
    return color;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$4;

// import { v4 } from 'uuid';
var Footer = function (_a) {
    var date = _a.date, description = _a.description, logo = _a.logo; _a.social; var politics = _a.politics, terms = _a.terms, args = __rest(_a, ["date", "description", "logo", "social", "politics", "terms"]);
    return (jsxRuntime.jsx(FooterWrapper, __assign({}, args, { children: jsxRuntime.jsx(LayoutContainer, { children: jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'body' }, { children: jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm }, { children: description })) })) })), jsxRuntime.jsxs("div", __assign({ className: 'footer' }, { children: [jsxRuntime.jsxs("div", __assign({ className: 'actions' }, { children: [logo ? (jsxRuntime.jsx("div", __assign({ className: 'logo' }, { children: jsxRuntime.jsx(Image, { src: logo, width: 80 }) }))) : null, terms ? (jsxRuntime.jsx("a", __assign({ href: terms.link, target: 'blank' }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, isLink: true }, { children: terms.label })) }))) : null, politics ? (jsxRuntime.jsx("a", __assign({ href: politics.link, target: 'blank' }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, isLink: true }, { children: politics.label })) }))) : null] })), jsxRuntime.jsx("div", __assign({ className: 'info' }, { children: jsxRuntime.jsx(Text, { children: date }) }))] }))] })) }) })));
};

// Component generated with util/vox-create-component.js
exports.ETeseType = void 0;
(function (ETeseType) {
    ETeseType["people"] = "people";
    ETeseType["institutions"] = "institutions";
    ETeseType["cities"] = "cities";
    ETeseType["planet"] = "planet";
})(exports.ETeseType || (exports.ETeseType = {}));

/**
 * Components
 */
var TeseWrapper = styled__default["default"].div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  height: 48px;\n  width: 48px;\n  position: relative;\n  overflow: hidden;\n  @media (min-width: ", ") {\n    height: 56px;\n    width: 56px;\n  }\n  .ring {\n    position: absolute;\n    border-width: 6px;\n    border-color: ", ";\n    border-style: solid;\n    border-radius: 50%;\n    margin-left: 4px;\n    margin-bottom: 4px;\n    @media (min-width: ", ") {\n      border-width: 8px;\n    }\n    &.people {\n      width: 30%;\n      height: 30%;\n      bottom: 60%;\n      left: 60%;\n      border-color: ", ";\n    }\n    &.institutions {\n      width: 70%;\n      height: 70%;\n      bottom: 40%;\n      left: 40%;\n      border-color: ", ";\n    }\n    &.cities {\n      width: 110%;\n      height: 110%;\n      bottom: 20%;\n      left: 20%;\n      border-color: ", ";\n    }\n    &.planet {\n      width: 150%;\n      height: 150%;\n      bottom: 0;\n      left: 0;\n      border-color: ", ";\n    }\n  }\n"], ["\n  height: 48px;\n  width: 48px;\n  position: relative;\n  overflow: hidden;\n  @media (min-width: ", ") {\n    height: 56px;\n    width: 56px;\n  }\n  .ring {\n    position: absolute;\n    border-width: 6px;\n    border-color: ", ";\n    border-style: solid;\n    border-radius: 50%;\n    margin-left: 4px;\n    margin-bottom: 4px;\n    @media (min-width: ", ") {\n      border-width: 8px;\n    }\n    &.people {\n      width: 30%;\n      height: 30%;\n      bottom: 60%;\n      left: 60%;\n      border-color: ", ";\n    }\n    &.institutions {\n      width: 70%;\n      height: 70%;\n      bottom: 40%;\n      left: 40%;\n      border-color: ", ";\n    }\n    &.cities {\n      width: 110%;\n      height: 110%;\n      bottom: 20%;\n      left: 20%;\n      border-color: ", ";\n    }\n    &.planet {\n      width: 150%;\n      height: 150%;\n      bottom: 0;\n      left: 0;\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dark200;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === exports.ETeseType.people ? theme.colors.pink800 : null;
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === exports.ETeseType.institutions ? theme.colors.yellow : null;
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === exports.ETeseType.cities ? theme.colors.cyan : null;
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === exports.ETeseType.planet ? theme.colors.orange : null;
});
var templateObject_1$3;

var Tese = function (_a) {
    var type = _a.type, args = __rest(_a, ["type"]);
    return (jsxRuntime.jsxs(TeseWrapper, __assign({ type: type }, args, { children: [jsxRuntime.jsx("div", { className: 'ring people' }), jsxRuntime.jsx("div", { className: 'ring institutions' }), jsxRuntime.jsx("div", { className: 'ring cities' }), jsxRuntime.jsx("div", { className: 'ring planet' })] })));
};

/**
 * Components
 */
var ChallengesWrapper = styled__default["default"].div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  .container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: start;\n    gap: 32px;\n    @media (min-width: ", ") {\n      flex-direction: row;\n    }\n    .image {\n      flex: 1;\n      align-self: stretch;\n      text-align: center;\n      img {\n        width: 100%;\n        height: auto;\n        @media (min-width: ", ") {\n          width: 256px;\n        }\n        @media (min-width: ", ") {\n          width: 328px;\n        }\n      }\n    }\n    .information {\n      flex: 2;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  .container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: start;\n    gap: 32px;\n    @media (min-width: ", ") {\n      flex-direction: row;\n    }\n    .image {\n      flex: 1;\n      align-self: stretch;\n      text-align: center;\n      img {\n        width: 100%;\n        height: auto;\n        @media (min-width: ", ") {\n          width: 256px;\n        }\n        @media (min-width: ", ") {\n          width: 328px;\n        }\n      }\n    }\n    .information {\n      flex: 2;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var templateObject_1$2;

var Challenges = function (_a) {
    var title = _a.title, image = _a.image, content = _a.content, args = __rest(_a, ["title", "image", "content"]);
    return (jsxRuntime.jsx(ChallengesWrapper, __assign({}, args, { children: jsxRuntime.jsxs("div", __assign({ className: 'container' }, { children: [jsxRuntime.jsx("div", __assign({ className: 'image' }, { children: jsxRuntime.jsx(Image, { src: image }) })), jsxRuntime.jsxs("div", __assign({ className: 'information' }, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, weight: exports.EFontWeight.bold }, { children: title })), content.map(function (e) { return (jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyMd }, { children: e }), e)); })] }))] })) })));
};

/**
 * Components
 */
var Card = styled__default["default"].div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  width: 100%;\n  /* height: 100%; */\n  background-size: contain;\n  background-repeat: no-repeat;\n  @media (min-width: ", ") {\n  }\n"], ["\n  width: 100%;\n  /* height: 100%; */\n  background-size: contain;\n  background-repeat: no-repeat;\n  @media (min-width: ", ") {\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var CardBody = styled__default["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  min-height: 640px;\n  position: relative;\n  overflow: hidden;\n  @media (min-width: ", ") {\n    width: 640px;\n    min-height: 640px;\n  }\n"], ["\n  background-color: ", ";\n  width: 100%;\n  min-height: 640px;\n  position: relative;\n  overflow: hidden;\n  @media (min-width: ", ") {\n    width: 640px;\n    min-height: 640px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xl;
});
var CardImage = styled__default["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 0;\n  background-image: url(", ");\n  background-position: center;\n  background-size: cover;\n"], ["\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 0;\n  background-image: url(", ");\n  background-position: center;\n  background-size: cover;\n"])), function (_a) {
    var image = _a.image;
    return image;
});
var CardContentWrapper = styled__default["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  padding: 32px 24px;\n  box-sizing: border-box;\n  z-index: 1;\n  position: absolute;\n  @media (min-width: ", ") {\n    padding: 40px 32px 48px 32px;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  padding: 32px 24px;\n  box-sizing: border-box;\n  z-index: 1;\n  position: absolute;\n  @media (min-width: ", ") {\n    padding: 40px 32px 48px 32px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
});
var CardRadial = styled__default["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  position: absolute;\n  top: -75%;\n  right: -50%;\n  z-index: 0;\n"], ["\n  background: radial-gradient(\n    circle,\n    rgba(23, 22, 45, 0) 0%,\n    rgba(23, 22, 45, 0) 27%,\n    rgba(23, 22, 45, 1) 87%\n  );\n  width: 150%;\n  height: 175%;\n  position: absolute;\n  top: -75%;\n  right: -50%;\n  z-index: 0;\n"])));
var CardList = styled__default["default"].ul(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin-bottom: 16px;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin-bottom: 16px;\n"])));
var CardContent = styled__default["default"].div(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var CardContentBetween = styled__default["default"].div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"])));
var CardOds = styled__default["default"].div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  width: fit-content;\n  row-gap: 4px;\n  column-gap: 4px;\n  .ods {\n    width: 56px;\n    height: 56px;\n    @media (min-width: ", ") {\n      width: 72px;\n      height: 72px;\n    }\n  }\n  > .tooltip {\n    position: relative;\n    :before {\n      content: attr(data-tooltip);\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      padding: 8px;\n      background-color: #333;\n      color: #fff;\n      border-radius: 4px;\n      font-family: ", ";\n      font-size: 12px;\n      white-space: nowrap;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n      z-index: 9999;\n    }\n    :hover::before {\n      opacity: 1;\n      visibility: visible;\n      transition: all 0.3s ease;\n    }\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  width: fit-content;\n  row-gap: 4px;\n  column-gap: 4px;\n  .ods {\n    width: 56px;\n    height: 56px;\n    @media (min-width: ", ") {\n      width: 72px;\n      height: 72px;\n    }\n  }\n  > .tooltip {\n    position: relative;\n    :before {\n      content: attr(data-tooltip);\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      padding: 8px;\n      background-color: #333;\n      color: #fff;\n      border-radius: 4px;\n      font-family: ", ";\n      font-size: 12px;\n      white-space: nowrap;\n      opacity: 0;\n      visibility: hidden;\n      transition: all 0.3s ease;\n      z-index: 9999;\n    }\n    :hover::before {\n      opacity: 1;\n      visibility: visible;\n      transition: all 0.3s ease;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
var CardFooter = styled__default["default"].div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 16px 32px;\n  box-sizing: border-box;\n  width: 100%;\n"], ["\n  padding: 16px 32px;\n  box-sizing: border-box;\n  width: 100%;\n"])));
styled__default["default"].div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 50%;\n"], ["\n  width: 50%;\n"])));
var CardImpactWrapper = styled__default["default"].div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var CardImpactWrapperBody = styled__default["default"].div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var CardImpactWrapperFooter = styled__default["default"].div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  text-align: end;\n"], ["\n  text-align: end;\n"])));
var CardSectionWrapper = styled__default["default"].div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 156px;\n  height: 156px;\n  border-radius: 4px;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .description {\n    line-height: 14px;\n  }\n"], ["\n  cursor: pointer;\n  width: 156px;\n  height: 156px;\n  border-radius: 4px;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .description {\n    line-height: 14px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray200;
});
var CardSectionWrapperHeader = styled__default["default"].div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var CardReportWrapper = styled__default["default"].div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  width: min-content;\n"], ["\n  width: min-content;\n"])));
var CardReportWrapperGraph = styled__default["default"].div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  cursor: pointer;\n  width: 264px;\n  height: 264px;\n  background-color: ", ";\n  border-radius: 4px;\n  margin-bottom: 16px;\n  overflow: hidden;\n  div.circles {\n    width: 150%;\n    height: 150%;\n    position: relative;\n    right: 10%;\n    bottom: -15%;\n    span {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      border-radius: 50%;\n    }\n    span.small {\n      height: 40%;\n      width: 40%;\n      background-color: ", ";\n      z-index: 3;\n      opacity: 50%;\n    }\n    span.medium {\n      height: 70%;\n      width: 70%;\n      background-color: ", ";\n      z-index: 2;\n      opacity: 50%;\n    }\n    span.large {\n      height: 95%;\n      width: 95%;\n      background-color: ", ";\n      z-index: 1;\n    }\n  }\n"], ["\n  cursor: pointer;\n  width: 264px;\n  height: 264px;\n  background-color: ", ";\n  border-radius: 4px;\n  margin-bottom: 16px;\n  overflow: hidden;\n  div.circles {\n    width: 150%;\n    height: 150%;\n    position: relative;\n    right: 10%;\n    bottom: -15%;\n    span {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      border-radius: 50%;\n    }\n    span.small {\n      height: 40%;\n      width: 40%;\n      background-color: ", ";\n      z-index: 3;\n      opacity: 50%;\n    }\n    span.medium {\n      height: 70%;\n      width: 70%;\n      background-color: ", ";\n      z-index: 2;\n      opacity: 50%;\n    }\n    span.large {\n      height: 95%;\n      width: 95%;\n      background-color: ", ";\n      z-index: 1;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.pink400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink900;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink600;
});
var CardReportWrapperContent = styled__default["default"].div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var CardReportWrapperFooter = styled__default["default"].div(templateObject_20 || (templateObject_20 = __makeTemplateObject([""], [""])));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;

var CardContentAsset = function (_a) {
    var ods = _a.ods, statement = _a.statement, aspiration = _a.aspiration, tematic = _a.tematic, description = _a.description, image = _a.image, asset = _a.asset, args = __rest(_a, ["ods", "statement", "aspiration", "tematic", "description", "image", "asset"]);
    return (jsxRuntime.jsxs(Card, __assign({}, args, { children: [jsxRuntime.jsxs(CardBody, { children: [image ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(CardImage, { image: image }), jsxRuntime.jsx(CardRadial, {})] })) : null, jsxRuntime.jsx(CardContentWrapper, { children: jsxRuntime.jsxs(CardContentBetween, { children: [ods.length > 0 ? (jsxRuntime.jsx(CardOds, { children: ods.sort().map(function (item) { return (jsxRuntime.jsx("div", __assign({ className: 'ods tooltip', "data-tooltip": getLabelODS(item) }, { children: jsxRuntime.jsx(Image, { src: getImageODS(item) }) }), v4())); }) })) : (jsxRuntime.jsx("div", {})), jsxRuntime.jsxs("div", { children: [jsxRuntime.jsxs(CardList, { children: [jsxRuntime.jsx("li", { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, preset: exports.TextSizes.bodyMd, color: exports.Colors.light }, { children: statement })) }), jsxRuntime.jsx("li", { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, preset: exports.TextSizes.bodyMd, color: exports.Colors.light }, { children: aspiration })) }), jsxRuntime.jsx("li", { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, preset: exports.TextSizes.bodyMd, color: exports.Colors.light }, { children: tematic })) })] }), jsxRuntime.jsx(CardContent, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.regular, preset: exports.TextSizes.bodyMd, color: exports.Colors.light }, { children: description })) })] })] }) })] }), asset ? (jsxRuntime.jsx(CardFooter, { children: jsxRuntime.jsx(Text, __assign({ className: 'asset-name', color: exports.Colors.darkBlue, weight: exports.EFontWeight.medium }, { children: asset })) })) : null] })));
};

var CardContentStatement = function (_a) {
    var asset = _a.asset, description = _a.description, image = _a.image, args = __rest(_a, ["asset", "description", "image"]);
    return (jsxRuntime.jsxs(Card, __assign({}, args, { children: [jsxRuntime.jsxs(CardBody, { children: [image ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(CardImage, { image: image }), jsxRuntime.jsx(CardRadial, {})] })) : null, jsxRuntime.jsx(CardContentWrapper, { children: jsxRuntime.jsx(CardContentBetween, { children: jsxRuntime.jsx("div", __assign({ style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    height: '100%',
                                } }, { children: jsxRuntime.jsx("div", __assign({ style: {
                                        paddingRight: 56,
                                    } }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, preset: exports.TextSizes.bodyLg, color: exports.Colors.light }, { children: description })) })) })) }) })] }), jsxRuntime.jsx(CardFooter, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium }, { children: asset })) })] })));
};

var CardContentTeses = function (_a) {
    var ods = _a.ods, title = _a.title, description = _a.description, image = _a.image, args = __rest(_a, ["ods", "title", "description", "image"]);
    return (jsxRuntime.jsx(Card, __assign({}, args, { children: jsxRuntime.jsxs(CardBody, { children: [image ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(CardImage, { image: image }), jsxRuntime.jsx(CardRadial, {})] })) : null, jsxRuntime.jsx(CardContentWrapper, { children: jsxRuntime.jsxs(CardContentBetween, { children: [ods.length > 0 ? (jsxRuntime.jsx(CardOds, { children: ods.sort().map(function (item) { return (jsxRuntime.jsx("div", __assign({ className: 'ods tooltip', "data-tooltip": getLabelODS(item) }, { children: jsxRuntime.jsx(Image, { src: getImageODS(item), alt: 'ODS' }) }), v4())); }) })) : (jsxRuntime.jsx("div", {})), jsxRuntime.jsxs("div", { children: [jsxRuntime.jsx("div", __assign({ style: {
                                            width: '75%',
                                            marginBottom: 16,
                                        } }, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.bold, preset: exports.TextSizes.heading5, color: exports.Colors.light }, { children: title })) })), jsxRuntime.jsx(CardContent, { children: jsxRuntime.jsx(Text, __assign({ weight: exports.EFontWeight.medium, preset: exports.TextSizes.bodyMd, color: exports.Colors.gray200 }, { children: description })) })] })] }) })] }) })));
};

var CardContentImpact = function (_a) {
    var title = _a.title, description = _a.description, args = __rest(_a, ["title", "description"]);
    return (jsxRuntime.jsxs(CardImpactWrapper, __assign({}, args, { children: [jsxRuntime.jsxs(CardImpactWrapperBody, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.heading5, color: exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: title })), jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.body, color: exports.Colors.darkBlue }, { children: description }))] }), jsxRuntime.jsx(CardImpactWrapperFooter, { children: jsxRuntime.jsx(Icon, { icon: exports.Icons.north_east, color: exports.Colors.pink800 }) })] })));
};

var CardContentSection$1 = function (_a) {
    var title = _a.title, buttonLabel = _a.buttonLabel, onClick = _a.onClick, args = __rest(_a, ["title", "buttonLabel", "onClick"]);
    return (jsxRuntime.jsxs(CardReportWrapper, __assign({}, args, { children: [jsxRuntime.jsx(CardReportWrapperGraph, { children: jsxRuntime.jsxs("div", __assign({ className: 'circles' }, { children: [jsxRuntime.jsx("span", { className: 'small' }), jsxRuntime.jsx("span", { className: 'medium' }), jsxRuntime.jsx("span", { className: 'large' })] })) }), jsxRuntime.jsx(CardReportWrapperContent, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodyLg, weight: exports.EFontWeight.bold }, { children: title })) }), jsxRuntime.jsx(CardReportWrapperFooter, { children: jsxRuntime.jsx("span", { children: jsxRuntime.jsx(Button, { label: buttonLabel, onClick: onClick, preset: exports.EButtonPreset.outline, color: exports.Colors.darkBlue }) }) })] })));
};

var CardContentSection = function (_a) {
    var title = _a.title, description = _a.description, args = __rest(_a, ["title", "description"]);
    return (jsxRuntime.jsxs(CardSectionWrapper, __assign({}, args, { children: [jsxRuntime.jsxs(CardSectionWrapperHeader, { children: [jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm, color: exports.Colors.pink800, weight: exports.EFontWeight.bold }, { children: title })), jsxRuntime.jsx(Icon, { icon: exports.Icons.north_east, color: exports.Colors.darkBlue, size: exports.EIconSize.small })] }), jsxRuntime.jsx("div", __assign({ className: 'description' }, { children: jsxRuntime.jsx(Text, __assign({ preset: exports.TextSizes.bodySm, color: exports.Colors.darkBlue, weight: exports.EFontWeight.bold }, { children: description })) }))] })));
};

/**
 * Components
 */
var SectionCircleWrapper = styled__default["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 156px;\n  height: 156px;\n  .circles {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .circle {\n      border-radius: 50%;\n      position: absolute;\n      &.size-1 {\n        width: 25%;\n        height: 25%;\n        background-color: ", ";\n        z-index: 6;\n      }\n      &.size-2 {\n        width: 40%;\n        height: 40%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 5;\n      }\n      &.size-3 {\n        width: 55%;\n        height: 55%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 4;\n      }\n      &.size-4 {\n        width: 70%;\n        height: 70%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 3;\n      }\n      &.size-5 {\n        width: 85%;\n        height: 85%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 2;\n      }\n      &.size-6 {\n        width: 100%;\n        height: 100%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 1;\n      }\n    }\n  }\n"], ["\n  width: 156px;\n  height: 156px;\n  .circles {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .circle {\n      border-radius: 50%;\n      position: absolute;\n      &.size-1 {\n        width: 25%;\n        height: 25%;\n        background-color: ", ";\n        z-index: 6;\n      }\n      &.size-2 {\n        width: 40%;\n        height: 40%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 5;\n      }\n      &.size-3 {\n        width: 55%;\n        height: 55%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 4;\n      }\n      &.size-4 {\n        width: 70%;\n        height: 70%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 3;\n      }\n      &.size-5 {\n        width: 85%;\n        height: 85%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 2;\n      }\n      &.size-6 {\n        width: 100%;\n        height: 100%;\n        background-color: ", ";\n        border: 1px solid ", ";\n        z-index: 1;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.pink900;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink900;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink600;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink800;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink600;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink400;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.pink200;
});
var templateObject_1;

var SectionCircle = function (_a) {
    var circles = _a.circles, args = __rest(_a, ["circles"]);
    return (jsxRuntime.jsx(SectionCircleWrapper, __assign({}, args, { children: jsxRuntime.jsx("div", __assign({ className: 'circles' }, { children: Array(circles)
                .fill(null)
                .map(function (_, i) {
                return jsxRuntime.jsx("div", { className: "circle size-".concat(i + 1) }, v4());
            }) })) })));
};

// Component generated with util/vox-create-component.js
exports.ESocialType = void 0;
(function (ESocialType) {
    ESocialType["linkedin"] = "linkedin";
    ESocialType["instagram"] = "instagram";
    ESocialType["spotify"] = "spotify";
    ESocialType["youtube"] = "youtube";
})(exports.ESocialType || (exports.ESocialType = {}));

// Component generated with util/vox-create-component.js
exports.EFundStatus = void 0;
(function (EFundStatus) {
    EFundStatus[EFundStatus["public"] = 0] = "public";
    EFundStatus[EFundStatus["owned"] = 1] = "owned";
    EFundStatus[EFundStatus["closed"] = 2] = "closed";
})(exports.EFundStatus || (exports.EFundStatus = {}));
exports.EFundArea = void 0;
(function (EFundArea) {
    EFundArea[EFundArea["health"] = 0] = "health";
    EFundArea[EFundArea["financial"] = 1] = "financial";
    EFundArea[EFundArea["education"] = 2] = "education";
})(exports.EFundArea || (exports.EFundArea = {}));

// Component generated with util/vox-create-component.js
exports.EInformationType = void 0;
(function (EInformationType) {
    EInformationType[EInformationType["FINANCIAL"] = 0] = "FINANCIAL";
    EInformationType[EInformationType["PROFILE"] = 1] = "PROFILE";
    EInformationType[EInformationType["DOCUMENT"] = 2] = "DOCUMENT";
})(exports.EInformationType || (exports.EInformationType = {}));

// Component generated with util/vox-create-component.js
exports.EInputAreaAlign = void 0;
(function (EInputAreaAlign) {
    EInputAreaAlign[EInputAreaAlign["left"] = 0] = "left";
    EInputAreaAlign[EInputAreaAlign["center"] = 1] = "center";
    EInputAreaAlign[EInputAreaAlign["right"] = 2] = "right";
})(exports.EInputAreaAlign || (exports.EInputAreaAlign = {}));

exports.IconSocialIn = IconSocialIn;
exports.IconSocialInstagram = IconSocialInstagram;
exports.IconSocialSpotify = IconSocialSpotify;
exports.IconSocialYoutube = IconSocialYoutube;
exports.UIThemeProvider = UIThemeProvider;
exports.VoxAlert = Alert;
exports.VoxAnalysis = Analysis;
exports.VoxAvatar = Avatar;
exports.VoxBanner = Banner;
exports.VoxButton = Button;
exports.VoxCalendar = Calendar;
exports.VoxCard = Card$1;
exports.VoxCardAsset = CardContentAsset;
exports.VoxCardContentReport = CardContentSection$1;
exports.VoxCardContentSection = CardContentSection;
exports.VoxCardDetail = CardDetail;
exports.VoxCardImpact = CardContentImpact;
exports.VoxCardStatement = CardContentStatement;
exports.VoxCardTeses = CardContentTeses;
exports.VoxChallenges = Challenges;
exports.VoxCheckBox = CheckBox;
exports.VoxCompany = Company;
exports.VoxConfig = Config;
exports.VoxDataFund = DataFund;
exports.VoxDocumentItem = DocumentItem;
exports.VoxDots = Dots;
exports.VoxFooter = Footer;
exports.VoxGraph = Graph;
exports.VoxHeader = Header;
exports.VoxHeaderHome = HeaderHome;
exports.VoxHeaderNavigation = HeaderNavigation;
exports.VoxHeaderSection = HeaderSection;
exports.VoxHeaderSectionFlow = HeaderSectionFlow;
exports.VoxIcon = Icon;
exports.VoxImage = Image;
exports.VoxImpactHistory = ImpactHistory;
exports.VoxInfo = Info;
exports.VoxInformation = Information;
exports.VoxInput = Input$1;
exports.VoxInputBlocks = InputBlocks;
exports.VoxLayoutContainer = LayoutContainer;
exports.VoxList = List;
exports.VoxLoadingIcon = Loading;
exports.VoxMenu = Menu;
exports.VoxMenuItem = MenuItem$1;
exports.VoxMessage = Message;
exports.VoxModal = Modal;
exports.VoxNotification = Notification;
exports.VoxReferences = References;
exports.VoxSectionCircle = SectionCircle;
exports.VoxSpecialistComment = SpecialistComment;
exports.VoxTab = Tab;
exports.VoxTabList = TabList;
exports.VoxTag = Tag;
exports.VoxTeseIcon = Tese;
exports.VoxText = Text;
exports.VoxTextArea = Input;
exports.VoxToogle = Toggle;
exports.voxUiTheme = voxUiTheme;
//# sourceMappingURL=index.js.map
